/** German texts (reference language). en.ts and tr.ts must have exactly the same keys. */
const de = {
  app: {
    name: 'Projektzeit',
    demo: 'Demo',
    demoNotice: 'Demo mit fiktiven Daten. Änderungen gelten bis zum Neuladen der Seite.',
    loading: 'Wird geladen …',
    loadingDemo: {
      db: 'Datenbank wird gestartet …',
      schema: 'Tabellen werden angelegt …',
      data: 'Beispieldaten werden erzeugt …',
    },
    noWasm: 'Die Demo konnte nicht starten, weil diese Ansicht keine WebAssembly-Ausführung erlaubt. Lokal starten: npm install, danach npm run dev:demo -w @pz/web.',
    fatal: 'Die Anwendung konnte nicht gestartet werden.',
  },
  nav: {
    myAbsences: 'Meine Abwesenheiten',
    team: 'Team',
    planning: 'Planung',
    evaluation: 'Mitarbeiterauswertung',
    absences: 'Abwesenheiten',
    rejectedBadge: '{{count}} zurückgewiesene Einträge',
    rejectedBadge_one: '{{count}} zurückgewiesener Eintrag',
    overview: 'Übersicht',
    week: 'Meine Woche',
    entries: 'Meine Zeiten',
    tasks: 'Aufgaben',
    approvals: 'Zeitfreigaben',
    billing: 'Abrechnung',
    workload: 'Auslastung',
    projects: 'Projekte',
    people: 'Personen',
    admin: 'Verwaltung',
    logout: 'Abmelden',
    theme: 'Darstellung',
    themeSystem: 'Wie System',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    menu: 'Menü',
    groupMine: 'Mein Bereich',
    groupProjects: 'Projekte und Team',
    groupLead: 'Leitung',
    groupAdmin: 'Verwaltung',
    cockpit: 'Cockpit',
    help: 'Kurzanleitung',
    leaveRequests: 'Abwesenheitsanträge',
    analysis: 'Projektanalysen',
    customers: 'Kunden',
    planningGroup: 'Planung & Kapazität',
    insightsGroup: 'Auswertungen',
    subTime: 'Zeiten',
    approvalsGroup: 'Freigaben',
    peopleGroup: 'Personen',
    announcements: 'Mitteilungen',
  },
  common: {
    moveDialog: 'Zum Verschieben ziehen; Doppelklick: zurück an den Platz',
    day: 'Tag',
    undo: 'Rückgängig',
    undone: 'Rückgängig gemacht',
    undoReason: 'Änderung rückgängig gemacht',
    sortAsc: 'Aufsteigend sortieren (Ihre Wahl wird gemerkt)',
    sortDesc: 'Absteigend sortieren',
    sortReset: 'Zurück zur Standardreihenfolge',
    shiftHint: 'Mit Umschalt (Shift) und Klick einen ganzen Bereich markieren.',
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    create: 'Anlegen',
    search: 'Suchen',
    all: 'Alle',
    yes: 'Ja',
    no: 'Nein',
    reset: 'Zurücksetzen',
    apply: 'Übernehmen',
    from: 'Von',
    to: 'Bis',
    date: 'Datum',
    week: 'Woche',
    month: 'Monat',
    year: 'Jahr',
    hours: 'Stunden',
    total: 'Gesamt',
    status: 'Status',
    note: 'Notiz',
    reason: 'Begründung',
    reasonHint: 'Wird im Änderungsprotokoll gespeichert.',
    optional: 'optional',
    exportExcel: 'Excel exportieren',
    today: 'Heute',
    previous: 'Zurück',
    next: 'Weiter',
    open: 'Öffnen',
    archive: 'Archivieren',
    unarchive: 'Wiederherstellen',
    archived: 'Archiviert',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    name: 'Name',
    email: 'E-Mail',
    role: 'Rolle',
    project: 'Projekt',
    task: 'Aufgabe',
    person: 'Person',
    description: 'Beschreibung',
    booked: 'Gebucht',
    planned: 'Geplant',
    budget: 'Budget',
    of: 'von',
    h: 'h',
    cw: 'KW',
    noData: 'Keine Daten im gewählten Zeitraum.',
    saved: 'Gespeichert',
    deleted: 'Gelöscht',
    copied: 'Kopiert',
    copy: 'Kopieren',
    history: 'Verlauf',
    createdAt: 'Erfasst am',
    select: 'Auswählen',
    selectAll: 'Alle auswählen',
    selected: '{{count}} ausgewählt',
    period: 'Zeitraum',
    type: 'Art',
    showArchived: 'Archivierte anzeigen',
    showInactive: 'Inaktive anzeigen',
    noResults: 'Keine Treffer.',
    typeToSearch: 'Tippen zum Suchen',
    noMatches: 'Keine Treffer',
    moreMatches: '{{count}} weitere Treffer: bitte genauer suchen',
    demoPrint: 'In der Demo kann das Druckfenster gesperrt sein. In der installierten Plattform öffnet sich der Druckdialog direkt; dort „Als PDF speichern“ wählen.',
  },
  status: {
    draft: 'Entwurf',
    submitted: 'Eingereicht',
    approved_l1: 'Projektleitung ok',
    approved: 'Freigegeben',
    rejected: 'Zurückgewiesen',
    billed: 'Abgerechnet',
  },
  billingType: {
    billable: 'Abrechenbar',
    included: 'Im Pauschalhonorar',
    non_billable: 'Nicht abrechnen',
    billableHint: 'Wird im Stundennachweis und in der Rechnung berücksichtigt.',
    includedHint: 'Leistung ist im Pauschalhonorar enthalten; erscheint im Nachweis, nicht als Betrag.',
    non_billableHint: 'Intern, Weiterbildung, Akquise: erscheint nicht in der Abrechnung.',
    fixed: 'Durch die Aufgabe festgelegt',
  },
  task: {
    manual: 'Manuell',
    internal: 'Intern',
    deleted: 'Aufgabe gelöscht',
    deletedHint: 'Die Aufgabe wurde gelöscht. Bitte den Entwurf einer anderen Aufgabe zuordnen oder löschen; so wird er nicht eingereicht.',
    formaDeleted: 'In Forma gelöscht',
    formaAccessLost: 'In Forma nicht mehr sichtbar',
    closed: 'Geschlossen',
    done: 'Erledigt',
    openInForma: 'In Forma öffnen',
    status: {
      draft: 'Entwurf',
      open: 'Offen',
      pending: 'Ausstehend',
      in_progress: 'In Bearbeitung',
      in_review: 'In Prüfung',
      completed: 'Abgeschlossen',
      not_approved: 'Nicht genehmigt',
      in_dispute: 'Strittig',
      closed: 'Geschlossen',
    },
  },
  week: {
    withdrawWeek: 'Woche zurückziehen',
    markAbsence: 'Abwesenheit eintragen',
    title: 'Meine Woche',
    titleOther: 'Woche von {{name}}',
    submitWeek: 'Woche einreichen',
    submitDone: '{{count}} Einträge eingereicht',
    submitDone_one: '{{count}} Eintrag eingereicht',
    nothingToSubmit: 'Keine Entwürfe in dieser Woche.',
    addEntry: 'Eintrag',
    recent: 'Zuletzt verwendet',
    recentEmpty: 'Noch keine Buchungen in den letzten Wochen.',
    absence: {
      special: 'Sonderurlaub',
      overtime: 'Freizeitausgleich',
      unpaid: 'Unbezahlter Urlaub',
      child_sick: 'Kind krank',
      parental: 'Elternzeit / Mutterschutz',
      pending: 'beantragt: {{kind}}',
      vacation: 'Urlaub',
      sick: 'Krank',
      training: 'Weiterbildung',
      other: 'Sonstige Abwesenheit',
      absent: 'Abwesend',
    },
    locked: 'Monat abgeschlossen',
    noEntries: 'Keine Einträge',
    viewPerson: 'Woche ansehen von',
    me: 'Mir',
    lockedHint: 'Der Monat ist abgeschlossen. Änderungen nur nach Freigabe durch das Büro.',
    rejectedHint: 'Zurückgewiesen: {{reason}}',
    tipKeyboard: 'Tipp: Stunden als 7,5 oder 7:30 eingeben.',
    showWeekend: 'Wochenende',
    showWeekendHint: 'Samstag und Sonntag anzeigen. Die Einstellung wird in diesem Browser gemerkt.',
    weekendNeeded: 'Wird angezeigt, weil am Wochenende gebucht wurde, es laut Vertrag Arbeitstage sind oder heute Wochenende ist.',
    compHint: 'davon {{hours}} h Freizeitausgleich',
    freeDay: 'arbeitsfrei',
    copied: 'Kopie am {{date}} angelegt',
    moved: 'Auf {{date}} verschoben',
    moveOrCopy: 'Verschieben oder kopieren',
    copyHere: 'Kopieren',
    moveHere: 'Verschieben',
    targetDate: 'Zieltag',
    dragHint: 'Tipp: Einträge auf einen anderen Tag ziehen verschiebt sie, mit gedrückter Strg- oder Alt-Taste wird kopiert. Innerhalb eines Tages bestimmt Ziehen die Reihenfolge.',
    toTop: 'Ganz nach oben',
    dragEntryHint: 'Auf einen Tag ziehen: verschieben · mit Strg oder Alt: kopieren',
    dragTaskHint: 'Auf einen Tag ziehen: neuer Eintrag mit dieser Aufgabe · zwischen die Favoriten: einsortieren',
    dropNew: 'Neuer Eintrag am {{day}}',
    dropMove: 'Hierher verschieben',
    dropCopy: 'Hierher kopieren',
    dayFull: 'Tagessoll erreicht',
    dayOver: 'Mehr als das Tagessoll',
    tipDrag: 'Tipp: Aufgaben auf einen Tag ziehen, um dort zu buchen; Stunden als 7,5 oder 7:30 eingeben.',
  },
  entry: {
    submittedDone: '{{count}} Einträge eingereicht',
    submittedDone_one: '{{count}} Eintrag eingereicht',
    withdrawnDone: '{{count}} Einträge zurückgezogen',
    withdrawnDone_one: '{{count}} Eintrag zurückgezogen',
    restored: 'Wiederhergestellt',
    billingTypeByRule: 'Aus Projekt oder Aufgabe übernommen',
    newTitle: 'Zeit erfassen',
    editTitle: 'Eintrag bearbeiten',
    task: 'Aufgabe',
    pickTask: 'Aufgabe suchen: Nummer oder Titel',
    changeTask: 'Andere Aufgabe',
    hours: 'Stunden',
    hoursHint: 'z. B. 7,5 oder 7:30 (Raster {{step}} min)',
    description: 'Tätigkeit',
    descriptionHint: 'Kurz und klar, gern in Ihrer Sprache; erscheint im Stundennachweis, den Tagestext für den Kunden passt das Büro bei Bedarf an.',
    billingType: 'Abrechnungsart',
    location: 'Arbeitsort',
    date: 'Datum',
    billedMinutes: 'Abzurechnende Stunden',
    billedMinutesHint: 'Leer = wie erfasst. Höher oder niedriger möglich.',
    billingNote: 'Abrechnungsnotiz',
    saveAndNew: 'Speichern und nächster',
    bookFor: 'Buchen für',
    deleteTitle: 'Eintrag löschen',
    deleteText: 'Der Eintrag wird in den Papierkorb verschoben und kann wiederhergestellt werden.',
    submit: 'Einreichen',
    withdraw: 'Zurückziehen',
    restore: 'Wiederherstellen',
    warnings: {
      TASK_FORMA_DELETED: 'Die Aufgabe wurde in Forma gelöscht. Die Buchung ist trotzdem gespeichert.',
      TASK_FORMA_ACCESS_LOST: 'Die Aufgabe ist in Forma nicht mehr sichtbar. Die Buchung ist trotzdem gespeichert.',
      TASK_CLOSED: 'Die Aufgabe ist geschlossen.',
      DAILY_LIMIT: 'Mehr als {{hours}} Stunden an diesem Tag.',
      WEEKEND: 'Buchung am Wochenende. Die Stunden zählen als Überstunden (Soll an diesem Tag: 0) und können als Freizeitausgleich beantragt werden.',
      WEEKEND_DATE: 'Buchung am Wochenende. Bitte das Datum prüfen.',
      FREE_DAY: 'Buchung an einem laut Vertrag arbeitsfreien Tag. Die Stunden zählen als Überstunden.',
      HOLIDAY: 'Buchung an einem Feiertag oder freien Tag des Büros. Die Stunden zählen als Überstunden.',
      ABSENCE_DAY: 'Für diesen Tag ist eine ganztägige Abwesenheit eingetragen. Falls doch gearbeitet wurde: Abwesenheit zurückziehen oder von der Personalverwaltung anpassen lassen.',
    },
    audit: {
      'time.submit': 'Eingereicht',
      'time.withdraw': 'Zurückgezogen',
      'time.approve_undo': 'Freigabe rückgängig gemacht',
      'time.reject_undo': 'Zurückweisung rückgängig gemacht',
      'time.update': 'Geändert',
      'time.delete': 'Gelöscht',
      'time.restore': 'Wiederhergestellt',
      'time.approve': 'Freigegeben',
      'time.reject': 'Zurückgewiesen',
      'time.reopen': 'Wieder geöffnet',
      'time.create_for_other': 'Für andere Person erfasst',
      'time.billed': 'Abzurechnende Stunden geändert',
    },
    locationNone: 'nicht angegeben',
    billedTitle: 'Abzurechnende Stunden',
    recorded: 'erfasst {{hours}} h',
    billedReset: 'Wie erfasst',
    billedInfo: 'Gilt nur für die Rechnung an den Kunden. Kennzahlen, Auslastung und Plan-Ist-Quote rechnen mit den erfassten Stunden.',
    billedShort: 'Abr. {{hours}} h',
    billedAction: 'Abr. Std.',
    noOvertime: 'Zählt nicht als Überstunden',
    noOvertimeHint: 'Zum Beispiel freiwillige Weiterbildung außerhalb der Arbeitszeit. Die Stunden bleiben gebucht.',
    noOvertimeByCategory: 'Die Kategorie der Aufgabe zählt nicht als Überstunden.',
    why: {
      title: 'Speichern geht noch nicht: {{list}}',
      task: 'Aufgabe wählen',
      hours: 'Stunden eintragen (Raster {{step}} min)',
      date: 'Datum wählen',
      description: 'Tätigkeit beschreiben (für diese Abrechnungsart Pflicht)',
      reason: 'Begründung der Änderung angeben (mindestens 3 Zeichen)',
      unchanged: 'nichts geändert',
      weekdays: 'mindestens einen Wochentag wählen',
      repeatEnd: 'das Ende liegt vor dem Beginn',
    },
  },
  entries: {
    nothingFor: 'Für diese Aktion passt keiner der markierten Einträge.',
    deletedMany: '{{count}} Einträge in den Papierkorb verschoben',
    deletedMany_one: '{{count}} Eintrag in den Papierkorb verschoben',
    title: 'Meine Zeiten',
    thisMonth: 'Dieser Monat',
    lastMonth: 'Letzter Monat',
    thisYear: 'Dieses Jahr',
    trash: 'Papierkorb',
    count: '{{count}} Einträge',
    count_one: '{{count}} Eintrag',
    sum: 'Summe',
    exportHint: 'Excel mit allen Einträgen des Zeitraums samt Ihrer Tätigkeiten, Summen je Tag und je Projekt. Auch als eigene Sicherung geeignet.',
    thisWeek: 'Diese Woche',
    showing: '{{shown}} von {{total}} Einträgen angezeigt, weitere beim Scrollen',
    capped: 'Angezeigt werden die neuesten {{count}} Einträge des Zeitraums. Wählen Sie einen kürzeren Zeitraum; der Excel-Export enthält alle Einträge.',
    formaLostFilter: 'Gefiltert: Einträge auf Forma-Aufgaben, die gelöscht wurden oder nicht mehr erreichbar sind. Bitte umbuchen oder mit dem Büro klären.',
    taskFilter: 'Gefiltert: Einträge auf einer Aufgabe.',
    clearFilter: 'Filter entfernen',
    search: 'Suchen',
    searchHint: 'Aufgabe, Projekt, Tätigkeit …',
    allProjects: 'Alle Projekte',
    allTypes: 'Alle Abrechnungsarten',
    clearFilters: 'Filter zurücksetzen',
    noMatch: 'Keine Einträge zu Suche und Filtern. Filter zurücksetzen, um alle Einträge des Zeitraums zu sehen.',
  },
  tasks: {
    showHidden: 'Ausgeblendete anzeigen',
    hideSelected: 'Ausblenden',
    showSelected: 'Wieder einblenden',
    hiddenMany: '{{count}} Aufgaben ausgeblendet',
    hiddenMany_one: '{{count}} Aufgabe ausgeblendet',
    shownMany: '{{count}} Aufgaben wieder eingeblendet',
    shownMany_one: '{{count}} Aufgabe wieder eingeblendet',
    title: 'Aufgaben',
    search: 'Nummer, Titel oder Projekt',
    includeClosed: 'Geschlossene anzeigen',
    createManual: 'Manuelle Aufgabe',
    manualTitle: 'Manuelle Aufgabe anlegen',
    manualHint: 'Für Arbeit ohne Forma-Issue, z. B. Weiterbildung, Akquise, Besprechungen. Was es in Forma gibt, bitte dort als Issue führen.',
    category: 'Kategorie',
    similar: 'Ähnliche Aufgaben gibt es schon:',
    billingTypeFixed: 'Abrechnungsart für alle Buchungen festlegen',
    created: 'Aufgabe {{ref}} angelegt',
    book: 'Zeit buchen',
    count: '{{count}} Aufgaben',
    count_one: '{{count}} Aufgabe',
    empty: 'Keine buchbaren Aufgaben gefunden. Die Zuordnung zu Projekten erfolgt durch die Projektleitung.',
    subtitle: 'Alle Aufgaben, auf die ich buchen kann: Forma-Issues und manuelle Aufgaben (M-Nummern).',
    billingForced: 'Durch Kategorie oder internes Projekt festgelegt.',
    planHint: 'Optional. Grundlage für Plan/Ist je Aufgabe.',
    formaKind: 'Kategorie / Typ (Forma)',
    allKinds: 'Alle Kategorien und Typen',
    wholeCategory: '{{category}}: alle Typen',
    typeExcluded: '{{type}} (nicht übernommen)',
    withoutValue: '(ohne Wert)',
    period: 'Beginn - Fällig',
    allStatuses: 'Alle Status',
    resetFilters: 'Filter zurücksetzen',
    selectAllShown: 'Alle {{count}} auswählen',
    noneFiltered: 'Keine Aufgaben für diese Filter.',
    none: 'Noch keine Aufgaben. Forma-Issues erscheinen nach dem Abgleich; manuelle Aufgaben über „Aufgabe anlegen“.',
    kindColumn: 'Kategorie / Typ',
    hiddenByFilter: 'Durch den Importfilter ausgeblendet (Typ wird nicht übernommen)',
    filteredOut: 'Importfilter',
    hide: 'Ausblenden',
    listLegend: 'Plan: Planstunden aus Projektzeit (0 = nicht bewertet). Ausgeblendete Aufgaben bleiben mit ihren Stunden erhalten und lassen sich wieder einblenden. Forma-Issues werden nur gelesen.',
    clashHint: 'Kollisionen dauerhaft heraushalten:',
    toImportFilter: 'Importfilter im Tab „Forma“',
    editManual: 'Aufgabe {{ref}} bearbeiten',
    number: 'Nummer',
    numberHint: 'Eindeutig im Projekt',
    numberTaken: '{{ref}} gibt es in diesem Projekt schon (auch ausgeblendete Aufgaben zählen). Zwei manuelle Aufgaben können nicht dieselbe Nummer tragen.',
    numberInvalid: 'Bitte eine Zahl von 1 bis 9999999 eingeben.',
    numberChangeHint: 'Die neue Nummer gilt überall: in Zeiten, Freigaben, Auswertungen, Favoriten und offenen Abrechnungsentwürfen (dort mit dem Hinweis „Daten geändert“). Abgeschlossene Dokumente behalten die Nummer von damals.',
    renameBooked: 'Der neue Name gilt überall, auch für die schon gebuchten {{hours}} h. Ist es eine andere Arbeit, legen Sie besser eine neue Aufgabe an.',
    renameHint: 'Der neue Name gilt überall, wo die Aufgabe vorkommt.',
    delete: {
      button: 'Löschen …',
      title: '{{ref}} löschen?',
      hideInstead: 'Stattdessen ausblenden',
      confirm: 'Endgültig löschen',
      hidden: '{{ref}} ausgeblendet; die Stunden bleiben erhalten',
      done: '{{ref}} gelöscht, {{count}} Einträge entfernt',
      done_one: '{{ref}} gelöscht, {{count}} Eintrag entfernt',
      warnTitle: 'Gelöscht werden nur Aufgaben ohne Stunden: eine Aufgabe mit eingereichten Stunden wird ausgeblendet, damit die Stunden erhalten bleiben.',
      warnHours: 'Auf der Aufgabe: {{count}} Einträge von {{people}} Personen, zusammen {{hours}} h (Ihre eigenen Entwürfe eingeschlossen).',
      warnHours_one: 'Auf der Aufgabe: {{count}} Eintrag, {{hours}} h.',
      warnNoHours: 'Auf die Aufgabe ist (sichtbar) noch nichts gebucht.',
      warnFinal: 'Das Löschen lässt sich nicht rückgängig machen. Deshalb ist es fast immer besser, die Aufgabe nicht zu löschen.',
      drafts: 'Entwürfe, die Personen noch nicht eingereicht haben, sind privat: sie bleiben bei den Personen, die sie einer anderen Aufgabe zuordnen.',
      better: 'Besser: „Stattdessen ausblenden“. Die Aufgabe verschwindet aus der Buchung, die Stunden bleiben vollständig erhalten, und sie lässt sich jederzeit wieder einblenden.',
      blocked: 'Löschen ist nicht möglich: {{count}} Einträge liegen in einem abgeschlossenen Monat oder sind abgerechnet. Die Aufgabe lässt sich nur ausblenden.',
      blocked_one: 'Löschen ist nicht möglich: {{count}} Eintrag liegt in einem abgeschlossenen Monat oder ist abgerechnet. Die Aufgabe lässt sich nur ausblenden.',
      approvedNeedsRight: '{{count}} Einträge sind bereits freigegeben; sie löscht nur, wer Einträge korrigieren darf (Büro).',
      hasHours: 'Löschen ist nicht möglich: {{count}} Einträge mit Stunden (eingereicht, freigegeben oder zurückgegeben). Die Aufgabe wird ausgeblendet; die Stunden bleiben vollständig erhalten.',
      understood: 'Ich habe verstanden, dass die Aufgabe und meine Entwürfe darauf gelöscht werden und das nicht rückgängig zu machen ist.',
    },
    startDate: 'Beginn',
    dueDate: 'Fällig',
    datesInvalid: 'Fällig liegt vor dem Beginn.',
    datesHint: 'Mit Beginn und Fälligkeit erscheint die Aufgabe im Zeitplan der Projektanalyse und in der Terminlage.',
    closedLabel: 'Erledigt (abgeschlossen)',
    closedHint: 'Abgeschlossene Aufgaben zählen im Fortschritt als erledigt; buchen ist weiter möglich.',
    kindCount: '{{kind}} ({{count}})',
    billingColumn: 'Abrechnung',
    sortNumber: 'Nr.',
    truncated: 'Mehr als {{count}} Aufgaben passen zum Filter, angezeigt werden die ersten {{count}}. Bitte Suche oder Filter eingrenzen.',
    formaDraft: 'Entwurf in Forma',
    formaDraftHint: 'In Forma noch ein Entwurf; erscheint, sobald er freigegeben ist oder Entwürfe übernommen werden.',
    billingByRole: 'Die Abrechnungsart legen Projektleitung, Abrechnung und Büro fest; sonst gilt die Vorgabe der Kategorie.',
    billingMany: 'Abrechnungsart setzen …',
    billingSetMany: 'Abrechnungsart für {{count}} manuelle Aufgaben gesetzt',
    billingSkipped: '{{count}} Aufgaben übersprungen (Forma-Aufgabe oder durch die Kategorie festgelegt)',
  },
  approvals: {
    weekendHint: 'Buchung am Wochenende',
    undone: '{{count}} Einträge zurückgesetzt',
    undone_one: '{{count}} Eintrag zurückgesetzt',
    undoSkipped: '{{count}} Einträge wurden inzwischen weiterbearbeitet und bleiben unverändert.',
    undoSkipped_one: '{{count}} Eintrag wurde inzwischen weiterbearbeitet und bleibt unverändert.',
    title: 'Freigaben',
    subtitle: 'Eingereichte Zeiten prüfen. Wer freigibt, legt jedes Projekt fest: Büro (Standard), Projektleitung, oder erst Projektleitung (Stufe 1), dann Büro (Stufe 2).',
    mine: 'Meine Freigaben',
    all: 'Alle offenen',
    stage: {
      l1: 'Freigabe Projektleitung',
      final: 'Freigabe Büro',
      override: 'Direkt freigeben',
    },
    approve: 'Freigeben',
    reject: 'Zurückweisen',
    rejectTitle: 'Einträge zurückweisen',
    rejectReason: 'Was soll korrigiert werden?',
    done: '{{count}} Einträge freigegeben',
    done_one: '{{count}} Eintrag freigegeben',
    rejected: '{{count}} Einträge zurückgewiesen',
    rejected_one: '{{count}} Eintrag zurückgewiesen',
    skipped: '{{count}} übersprungen',
    nothing: 'Nichts zu prüfen.',
    weekOf: 'KW {{week}}',
    bulk: {
      open: 'Zeiten: Export / Import',
      title: 'Offene Zeiten per Datei bearbeiten',
      intro: '1. Offene Einträge als CSV exportieren. 2. In Excel nur die Spalten „hours“, „description“ und „billing_type“ ändern. 3. Datei wieder einlesen: erst Vorschau, dann übernehmen. Änderungen laufen durch dieselben Regeln wie im Bearbeiten-Dialog (Rechte, Version, geschlossene Monate) und werden protokolliert; die Einträge bleiben zur Freigabe offen.',
      export: '1. Exportieren (CSV)',
      exported: '{{count}} Einträge exportiert',
      save: 'Datei speichern',
      copy: 'Text kopieren',
      fileText: 'Dateiinhalt (bearbeitbar)',
      import: '2. Importieren',
      chooseFile: 'CSV-Datei wählen',
      orPaste: 'oder Inhalt hier einfügen',
      preview: 'Vorschau',
      apply: 'Änderungen übernehmen',
      summary: '{{changed}} geändert, {{unchanged}} unverändert, {{errors}} mit Fehler',
      previewOnly: 'Vorschau: noch nichts wurde geändert.',
      applied: '{{count}} Einträge geändert',
      line: 'Zeile',
      person: 'Person',
      date: 'Datum',
      change: 'Änderung',
      state: 'Ergebnis',
      stateChanged: 'wird geändert',
      stateApplied: 'geändert',
      stateUnchanged: 'unverändert',
      stateError: 'Fehler',
      fields: {
        hours: 'Stunden',
        description: 'Tätigkeit',
        billing_type: 'Abrechnungsart',
      },
      errors: {
        NOT_IN_QUEUE: 'Gehört nicht (mehr) zu Ihren offenen Freigaben',
        CONFLICT: 'Seit dem Export geändert (Version)',
        BAD_HOURS: 'Ungültige Stunden (Raster und Höchstwert beachten)',
        BAD_BILLING_TYPE: 'Ungültige Abrechnungsart (billable, included, non_billable)',
        PERIOD_LOCKED: 'Monat ist abgeschlossen',
        ENTRY_BILLED: 'Schon abgerechnet',
        ENTRY_DELETED: 'Eintrag wurde gelöscht',
        ENTRY_APPROVED: 'Schon freigegeben',
        SELF_APPROVAL: 'Eigene Einträge können Sie nicht selbst bearbeiten',
        WRONG_STATUS: 'Status passt nicht (nicht mehr zur Freigabe offen)',
        FORBIDDEN: 'Keine Berechtigung zum Bearbeiten',
        NOT_FOUND: 'Eintrag nicht gefunden',
        REASON_REQUIRED: 'Begründung erforderlich',
        OTHER: 'Nicht übernommen',
      },
      noRows: 'Keine offenen Einträge zum Exportieren.',
    },
    groupsShown: '{{shown}} von {{total}} Personen-Wochen angezeigt, weitere beim Scrollen',
    filterPerson: 'Person',
    allPersons: 'Alle Personen',
    filterKind: 'Art der Aufgabe',
    allKinds: 'Alle Aufgaben',
    kindForma: 'Forma-Aufgaben',
    kindManual: 'Manuelle Aufgaben (ohne Kategorie)',
    summaryLine: '{{shown}} von {{total}} Einträgen · {{hours}} h offen',
    moreHint: 'Angezeigt: {{shown}} von {{total}} offenen Einträgen. Filter nach Person oder Aufgabe verkleinern die Liste.',
    loadMore: 'Weitere laden',
    views: {
      pending: 'Offen zur Freigabe',
      approved: 'Freigegeben (Rückgabe)',
    },
    filterTaskStatus: 'Aufgabenstatus',
    allTaskStatuses: 'Alle Aufgabenstatus',
    closedTask: 'Aufgabe geschlossen',
    closedTaskHint: 'Die Aufgabe ist in Forma geschlossen. Die Stunden zählen trotzdem; prüfen Sie kurz, ob die Buchung zu dieser Aufgabe gehört.',
    approvedTitle: 'Freigegebene Zeiten',
    approvedSubtitle: 'Freigegebene Einträge ändert niemand mehr direkt. Muss etwas korrigiert werden, geben Sie den Eintrag mit Begründung an die Person zurück; sie korrigiert ihn und reicht ihn erneut ein.',
    returnRule: 'Zurückgeben darf, wem die Freigabe gehört: die Projektleitung (bei „Nur Projektleitung“ oder für Stufe 1), sonst das Büro. Abgerechnete Einträge und abgeschlossene Monate erscheinen hier nicht.',
    approvedEmpty: 'Keine freigegebenen Einträge in diesem Zeitraum, die Sie zurückgeben dürfen.',
    return: 'Zurückgeben',
    returnTitle: '{{count}} Einträge zur Korrektur zurückgeben',
    returnTitle_one: 'Eintrag zur Korrektur zurückgeben',
    returnText: 'Die Freigabe wird aufgehoben; die Person wird benachrichtigt, korrigiert den Eintrag und reicht ihn erneut ein. Die Rückgabe wird protokolliert.',
    returnDraft: '{{count}} davon liegen in einem Stundennachweis-Entwurf; er zeigt danach „Daten geändert“.',
    returnReason: 'Was soll korrigiert werden?',
    returned: '{{count}} Einträge zurückgegeben',
    returned_one: '{{count}} Eintrag zurückgegeben',
    returnSkipped: '{{count}} Einträge wurden nicht zurückgegeben (inzwischen geändert, abgerechnet oder keine Berechtigung).',
    inDraft: 'Im Entwurf',
    inDraftHint: 'Der Tag liegt in einem Stundennachweis-Entwurf dieses Projekts. Nach der Rückgabe zeigt der Entwurf „Daten geändert“ und muss neu geprüft werden.',
  },
  billing: {
    print: 'Drucken / PDF',
    printHint: 'Druckansicht mit Unterschriftsfeldern; im Druckdialog „Als PDF speichern“ wählen.',
    noAccess: 'Die Abrechnung ist Personen mit dem Recht „Abrechnung“ vorbehalten (z. B. Assistenz der Geschäftsführung). Projektleitungen geben Stunden frei.',
    title: 'Abrechnung',
    subtitle: 'Stundennachweise und Abschlagsrechnungen',
    defaults: {
      title: 'Voreinstellungen der Dokumente',
      hint: 'Gelten für neue Dokumente und sind im einzelnen Dokument änderbar. Nur wer das Recht „Abrechnung“ hat, ändert sie, nicht die technische Administration.',
      show: 'Voreinstellungen anzeigen',
      hide: 'Voreinstellungen ausblenden',
    },
    documents: 'Dokumente',
    search: 'Nummer, Titel oder Projekt suchen',
    listCapped: 'Es werden die neuesten {{count}} Dokumente angezeigt. Suchen Sie nach Nummer, Titel oder Projekt, um ältere zu finden.',
    empty: 'Noch keine Dokumente. Oben einen Stundennachweis oder Abschlag anlegen.',
    noMatch: 'Keine Dokumente zu dieser Suche. Suchbegriff oder Status ändern.',
    unbilledNone: 'Alles Freigegebene ist abgerechnet.',
    newSn: 'Stundennachweis',
    newAbschlag: 'Abschlag',
    newSnTitle: 'Stundennachweis anlegen',
    newAbschlagTitle: 'Abschlagsrechnung anlegen',
    unbilled: 'Freigegeben, noch nicht abgerechnet',
    unbilledHint: 'Abrechenbare Stunden mit Status Freigegeben, die auf keinem abgeschlossenen Stundennachweis stehen.',
    noRate: 'kein Stundensatz',
    kinds: {
      stundennachweis: 'Stundennachweis',
      abschlag: 'Abschlagsrechnung',
    },
    docStatus: {
      draft: 'Entwurf',
      final: 'Abgeschlossen',
      invoiced: 'Rechnung gestellt',
      paid: 'Bezahlt',
      cancelled: 'Storniert',
    },
    number: 'Nummer',
    header: 'Kopfdaten',
    options: 'Optionen',
    layout: {
      label: 'Darstellung',
      matrix: 'Tage × Personen',
      list: 'Liste',
    },
    includeTypes: 'Enthaltene Abrechnungsarten',
    showAmounts: 'Beträge anzeigen (Stundensätze)',
    language: 'Sprache des Dokuments',
    dayTextPrefix: {
      label: 'Tagestext beginnt mit',
      discipline: 'Fachbereich',
      name: 'Name',
      none: 'nichts',
      code: 'Kürzel der Person (HA, HAL)',
    },
    includeUnapproved: 'Nicht freigegebene Einträge in der Vorschau zeigen',
    preview: 'Vorschau',
    dayText: 'Tätigkeitsbeschreibung',
    dayTextReset: 'Automatischen Text verwenden',
    dayTextEdited: 'angepasst',
    rows: 'Einzelbuchungen',
    exclude: 'Nicht abrechnen',
    billedHours: 'Abr. Std.',
    finalize: 'Abschließen',
    finalizeTitle: 'Dokument abschließen',
    finalizeText: 'Nummer wird vergeben, Inhalt wird eingefroren, die Buchungen werden als abgerechnet markiert. Nur freigegebene Buchungen werden übernommen.',
    finalized: 'Abgeschlossen als {{number}}',
    markInvoiced: 'Rechnung gestellt',
    markPaid: 'Bezahlt',
    cancel: 'Stornieren',
    cancelTitle: 'Dokument stornieren',
    cancelText: 'Die Buchungen werden wieder freigegeben und können neu abgerechnet werden. Die Nummer bleibt als storniert erhalten.',
    deleteDraft: 'Entwurf löschen',
    fields: {
      customerReference: 'Referenz / Bestellnummer Auftraggeber',
      title: 'Titel',
      consultant: 'Auftragnehmer',
      customer: 'Auftraggeber',
      projectLabel: 'Projektbezeichnung',
      projectNumber: 'Projektnummer',
      partner: 'Partner',
      periodLabel: 'Zeitraum (Text)',
      siteLocation: 'Einsatzort',
      place: 'Ort',
      documentDate: 'Datum',
      providerSignatureName: 'Name unter der Unterschrift (Auftragnehmer)',
      clientSignatureName: 'Name unter der Unterschrift (Auftraggeber)',
      issuerName: 'Firma (Kopfzeile)',
      issuerAddress: 'Adresse (Kopfzeile)',
      note: 'Hinweis im Dokument',
      contractNote: 'Vertragsgrundlage',
      asOf: 'Leistungsstand zum',
      sequenceLabel: 'Laufende Nummer',
      vatPercent: 'USt. %',
      customerAddress: 'Anschrift Auftraggeber',
      customerContact: 'Ansprechpartner Auftraggeber',
      customerVatId: 'USt-IdNr. Empfänger',
    },
    phases: 'Leistungsphasen',
    phase: 'Leistungsphase',
    weight: 'Bewertung %',
    fee: 'Honorar',
    progress: 'Stand %',
    earned: 'Erbracht',
    previous: 'Bisher abgerechnet',
    current: 'Dieser Abschlag',
    extras: 'Weitere Positionen',
    addExtra: 'Position hinzufügen',
    net: 'Netto',
    vat: 'USt.',
    gross: 'Brutto',
    previousDocs: 'Bisherige Abschläge',
    unapprovedWarning: '{{count}} Buchungen im Zeitraum sind noch nicht freigegeben und werden nicht abgerechnet.',
    unapprovedWarning_one: '{{count}} Buchung im Zeitraum ist noch nicht freigegeben und wird nicht abgerechnet.',
    noEntries: 'Keine freigegebenen Buchungen im Zeitraum.',
    amount: 'Betrag',
    readOnly: 'Abgeschlossene Dokumente sind unveränderlich. Für Korrekturen stornieren und neu anlegen.',
    recalcHint: 'Beträge werden nach dem Speichern neu berechnet.',
    noFee: 'Für dieses Projekt ist kein Honorar hinterlegt (Projekt > Honorar).',
    billedHint: 'Abzurechnende Stunden sind mit den erfassten Stunden vorbelegt und dürfen abweichen, auch nach oben (z. B. Pauschalvereinbarung). Alle anderen Auswertungen verwenden die erfassten Stunden.',
    printPreview: 'Druckansicht',
    dayTextTask: {
      label: 'Aufgabe im Tagestext',
      fallback: 'nur bei Buchungen ohne Tätigkeit',
      always: 'immer, als [Aufgabe] vor den Sätzen',
      byTask: 'je Aufgabe eine Zeile: „Aufgabe: HLS: … · ELT: …“',
    },
    dayTextHint: 'Je Tag eine Zeile je Fachbereich (oder Person). Jede Tätigkeit wird ein Satz, gleiche Sätze erscheinen einmal; ohne Tätigkeit steht der Aufgabentitel, außer die Zeile beschreibt diese Aufgabe schon. Gewählte Arbeitsorte stehen in Klammern. Von Hand angepasste Texte bleiben erhalten und werden markiert, wenn sich die Buchungen des Tages danach ändern.',
    dayTextOutdated: 'Buchungen nach der Anpassung geändert',
    dayTextOutdatedHint: 'Automatischer Text nach dem jetzigen Stand:',
    dayTextKeep: 'Angepassten Text behalten',
    outdatedNotice: '{{count}} von Hand angepasste Tagestexte passen nicht mehr sicher zu den Buchungen (in der Vorschau markiert). Bitte prüfen.',
    outdatedNotice_one: 'Ein von Hand angepasster Tagestext passt nicht mehr sicher zu den Buchungen (in der Vorschau markiert). Bitte prüfen.',
    finalizeOutdated: 'Achtung: {{count}} angepasste Tagestexte wurden nach Änderungen der Buchungen nicht geprüft.',
    finalizeOutdated_one: 'Achtung: ein angepasster Tagestext wurde nach Änderungen der Buchungen nicht geprüft.',
    dayTextLocations: 'Arbeitsort im Tagestext nennen',
    payment: {
      title: 'Zahlungsbedingungen',
      intro: 'Zahlungsziel, Skonto und Abzüge nach der Umsatzsteuer für diese Rechnung. Vorbelegt aus den Konditionen des Projekts (Kunden › Konditionen); hier darf das Dokument davon abweichen. Die Rechnung im Buchhaltungssystem bleibt das Original.',
      none: 'Für dieses Projekt sind noch keine Zahlungsbedingungen hinterlegt. Tragen Sie sie hier für dieses Dokument ein, oder dauerhaft in den Konditionen des Projekts.',
      fromProject: 'Aus den Projektkonditionen übernehmen',
      summary: 'Was der Kunde zahlt',
      frozen: 'Mit dem Dokument festgeschrieben: spätere Änderungen der Projektkonditionen ändern dieses Dokument nicht.',
      noteSaved: 'Beträge und Fälligkeit rechnen mit dem gespeicherten Stand der Positionen.',
    },
    basis: {
      changedShort: 'Daten geändert',
      changed: 'Seit der Vorbereitung dieses Entwurfs haben sich Systemdaten geändert: {{parts}}. Stunden, Namen und Beträge zeigt der Entwurf bereits nach dem neuen Stand; von Hand geänderte Tagestexte und die Kopfangaben (Empfänger, Projekt) bleiben, wie sie sind. Bitte den Entwurf durchsehen und dann „Geprüft und bestätigt“ wählen: Der Hinweis verschwindet bis zur nächsten Änderung.',
      checked: 'Geprüft und bestätigt; der Hinweis erscheint erst bei der nächsten Änderung wieder.',
      markChecked: 'Geprüft und bestätigt',
      takeRecipient: 'Empfänger aus Kundendaten übernehmen',
      takeProject: 'Projektnummer und Namen übernehmen',
      parts: {
        entries: 'Zeiteinträge des Zeitraums',
        texts: 'Namen von Personen oder Aufgaben',
        rates: 'Verkaufssätze (Beträge)',
        customer: 'Kundendaten (Empfänger)',
        project: 'Projektnummer oder -name',
        fee: 'Honorar, Leistungsphasen oder Konditionen',
      },
    },
    edit: {
      export: 'Zum Bearbeiten (Excel)',
      exportHint: 'Entwurf als Excel-Datei zum Bearbeiten: gelbe Spalten ändern und hier wieder einlesen',
      import: 'Bearbeitung einlesen',
      previewTitle: 'Bearbeitete Datei: Vorschau',
      apply: '{{count}} Änderungen übernehmen',
      applied: '{{count}} Änderungen übernommen',
      previewRefreshed: 'Die Systemdaten haben sich seit der Vorschau geändert. Die Vorschau zeigt jetzt den neuen Stand; bitte prüfen und erneut übernehmen.',
      stale: 'Der Entwurf wurde nach dem Export geändert. Die Vorschau vergleicht mit dem heutigen Stand; prüfen Sie die Änderungen.',
      noChanges: 'Die Datei enthält keine Änderungen gegenüber dem Entwurf.',
      entries: 'Einträge ({{count}})',
      excluded: 'nicht abrechnen',
      days: '{{count}} Tagestexte geändert',
      phases: 'Leistungsstand',
      extras: 'Zusatzpositionen: {{count}} Zeilen',
      problems: '{{count}} Zeilen wurden nicht übernommen:',
      row: 'Zeile {{row}}',
      problem: {
        hours: 'Stunden ungültig (0 bis 24)',
        percent: 'Fortschritt ungültig (0 bis 100)',
        line: 'Zusatzposition unvollständig',
        date: 'Datum ungültig',
        number: 'Zahl ungültig',
        unknown: 'Eintrag oder Leistungsphase gehört nicht zum Dokument',
        own: 'Eigene Einträge bleiben unverändert (über eigene Stunden entscheidet eine andere Person)',
        too_many: 'Zu viele Zusatzpositionen (höchstens 30)',
      },
    },
    recipient: {
      button: 'Empfänger aus Kundendaten',
      title: 'Empfänger aus den Kundendaten',
      none: 'Mit diesem Projekt ist noch keine Firma verknüpft (Kunden > Projekte).',
      agreed: 'laut Konditionen',
      take: 'Übernehmen',
      following: 'Der Empfänger folgt den Kundendaten: Änderungen an Firma, Ansprechpartner, Bestellnummer oder Konditionen erscheinen in diesem Entwurf von selbst (protokolliert). Ein Empfängerfeld von Hand zu ändern beendet das.',
      manual: 'Der Empfänger ist von Hand gesetzt und folgt den Kundendaten nicht. „Aus Kundendaten übernehmen“ verbindet ihn wieder.',
    },
    bulk: {
      button: 'Mehrere exportieren',
      title: 'Dokumente gesammelt exportieren',
      intro: 'Alle Dokumente des Filters als Zip-Datei: jedes Dokument als Excel-Datei, dazu eine Liste. Ein Dokument gehört zum Zeitraum, wenn sein Leistungszeitraum (oder sein Datum) ihn berührt. Höchstens 300 Dokumente je Datei.',
      kind: 'Art',
      export: 'Zip-Datei erstellen',
    },
  },
  workload: {
    leadPrivacy: 'Sie sehen den Auslastungsgrad (Farbe), keine Vertragsstunden. Stunden sehen nur Personalverwaltung und Geschäftsführung.',
    cellTitleLead: 'geplant {{plan}} h, gebucht {{booked}} h',
    levelTitle: 'Auslastung: {{level}}',
    levelShort: {
      none: 'keine',
      low: '< 70 %',
      ok: '70-100 %',
      high: '100-110 %',
      over: '> 110 %',
    },
    title: 'Auslastung',
    subtitle: 'Kapazität = Vertragsstunden abzüglich Feiertage (je Standort) und Abwesenheiten.',
    level: {
      none: 'keine Kapazität',
      low: 'unter 70 %',
      ok: '70 bis 100 %',
      high: '100 bis 110 %',
      over: 'über 110 %',
    },
    legend: 'Wert im Verhältnis zur Kapazität',
    cellTitle: 'Kapazität {{cap}} h, geplant {{plan}} h, gebucht {{booked}} h',
    internalPart: 'davon intern (F&E, Weiterbildung, Verwaltung): {{hours}} h',
    location: 'Standort',
    planHint: 'Stunden je Woche für dieses Projekt eintragen. Die Farbe zeigt die Auslastung der Person über alle Projekte.',
    fill: 'Serie eintragen',
    fillTitle: 'Planung für mehrere Wochen',
    perWeek: 'Stunden je Woche',
    import: 'CSV importieren',
    importTitle: 'Abwesenheiten importieren',
    importResult: '{{ok}} importiert, {{errors}} Fehler',
    calendar: 'Kalender',
    overrides: 'Betriebliche Anpassungen',
    overrideNew: 'Tag anpassen',
    fraction: 'Anteil frei',
    fractionFull: 'ganzer Tag',
    fractionHalf: 'halber Tag (Nachmittag frei)',
    fractionNone: 'Arbeitstag (Feiertag aufheben)',
    allCalendars: 'alle Kalender',
    rowsFound: '{{count}} Zeilen erkannt',
    rowsFound_one: '{{count}} Zeile erkannt',
    noAccess: 'Die Auslastung sehen Projektleitungen (ihre Projekte), die Planung und die Geschäftsführung.',
    onlyFlagged: 'Nur mit Hinweisen',
    stateHint: 'Abgeschlossene Wochen: Hinweis, wenn die Buchungen mehr als {{hours}} h von der Kapazität abweichen (alle Projekte).',
  },
  kpi: {
    solo: 'Überwiegend allein bearbeitet',
    soloHint: '{{count}} Aufgaben mit mindestens 80 % der Stunden von dieser Person; nur hier sagt die Quote etwas über die eigene Arbeit.',
    soloHint_one: '{{count}} Aufgabe mit mindestens 80 % der Stunden von dieser Person; nur hier sagt die Quote etwas über die eigene Arbeit.',
    confidentialNote: 'Personenbezogene Leistungsdaten. Nur für die Geschäftsführung; jeder Aufruf wird protokolliert.',
    utilization: 'Auslastung',
    utilizationHint: 'gebucht / Kapazität',
    billableShare: 'Anteil abrechenbar',
    projectShare: 'Anteil Projektarbeit',
    balance: 'Saldo Soll/Ist',
    punctuality: 'Pünktlich eingereicht',
    rejectionRate: 'Korrektur angefordert',
    capacity: 'Soll',
    booked: 'Ist',
    billable: 'Abrechenbar',
    budgetUsed: 'Budget verbraucht',
    salesValue: 'Wert abrechenbar',
    unbilledValue: 'Noch nicht abgerechnet',
    cost: 'Kosten',
    costMissing: 'ohne Kostensatz: {{hours}} h',
    byPerson: 'Nach Person',
    byMonth: 'Nach Monat',
    byProject: 'Nach Projekt',
    weekly: 'Wochenverlauf',
    plannedRemaining: 'Noch geplant',
    otherHours: 'Übrige Stunden',
    showTable: 'Als Tabelle',
    showChart: 'Als Diagramm',
    weekPrefix: 'KW',
    asOf: 'Soll/Ist vom {{from}} bis {{to}}',
    weekState: 'Woche',
    under: '{{hours}} h unter Soll',
    over: '{{hours}} h über Soll',
    underLegend: 'Woche unter Soll',
    overLegend: 'Woche über Soll',
    efficiency: 'Plan-Ist-Quote',
    efficiencyHint: '{{count}} Aufgaben: {{plan}} h Plan-Anteil, {{actual}} h gebucht',
    efficiencyHint_one: '{{count}} Aufgabe: {{plan}} h Plan-Anteil, {{actual}} h gebucht',
    efficiencyNone: 'Keine abgeschlossenen Aufgaben mit Plan im Zeitraum.',
    efficiencyExplain: 'Erledigte Aufgaben mit Plan (Forma-Feld oder Eintrag der Projektleitung). Quote = Plan / alle auf die Aufgabe gebuchten Stunden; über 100 % = schneller als geplant. Der Wert gehört zur Aufgabe: Alle, die an einer Aufgabe mitgearbeitet haben, haben denselben Wert. Er zeigt, wie die bearbeiteten Aufgaben gegen den Plan liefen, nicht wie schnell eine Person arbeitet.',
    efficiencyExplainOwn: 'Erledigte Aufgaben mit Plan (Forma-Feld oder Eintrag der Projektleitung), auf die nur Sie gebucht haben. Quote = Plan / Ihre Stunden; über 100 % = schneller als geplant. Gemeinsam bearbeitete Aufgaben erscheinen hier nicht, weil ihre Quote die Stunden der anderen verraten würde.',
    sharedLeftOut: '{{count}} gemeinsam bearbeitete Aufgaben sind nicht enthalten.',
    sharedLeftOut_one: '{{count}} gemeinsam bearbeitete Aufgabe ist nicht enthalten.',
  },
  projects: {
    openBookingImportHint: 'Ohne Haken buchen nur Mitglieder des Projektteams; das Team legen Büro oder Projektleitung im Projekt fest.',
    importForma: 'Aus Forma übernehmen',
    importInfo: 'Legt für jedes markierte Forma-Projekt ein Projekt in Projektzeit an, verknüpft es und schaltet die Synchronisation ein. Nummer und Name kommen aus dem Forma-Namen (z. B. „2024-017 Klinikum Nordtal“). Aufgaben und Standorte erscheinen nach der nächsten Synchronisation. Projektleitung, Mitglieder und Honorar danach je Projekt ergänzen.',
    importResult: '{{created}} übernommen, {{skipped}} übersprungen (bereits verknüpft)',
    importDone: '{{count}} Projekte übernommen',
    importDone_one: '{{count}} Projekt übernommen',
    importCount: '{{count}} übernehmen',
    importAs: 'In Projektzeit',
    alreadyLinked: 'verknüpft mit {{number}}',
    autoNumber: 'F-Nummer',
    archivedMany: '{{count}} Projekte archiviert',
    archivedMany_one: '{{count}} Projekt archiviert',
    restoredMany: '{{count}} Projekte wiederhergestellt',
    restoredMany_one: '{{count}} Projekt wiederhergestellt',
    archiveCount: '{{count}} archivieren',
    restoreCount: '{{count}} wiederherstellen',
    title: 'Projekte',
    new: 'Projekt anlegen',
    number: 'Projektnummer',
    name: 'Bezeichnung',
    customer: 'Auftraggeber',
    customerAddress: 'Adresse Auftraggeber',
    partner: 'Partner',
    site: 'Einsatzort',
    calendar: 'Feiertagskalender (Einsatzort)',
    billingMode: {
      label: 'Abrechnung',
      hourly: 'Nach Stunden',
      fixed_fee: 'Pauschalhonorar',
      mixed: 'Gemischt',
      internal: 'Intern',
    },
    defaultBillingType: 'Standard-Abrechnungsart',
    openBooking: 'Alle Mitarbeitenden dürfen buchen',
    openBookingHint: 'Für interne Projekte wie Weiterbildung oder Verwaltung.',
    budget: 'Budget (Stunden)',
    fee: 'Honorar gesamt',
    start: 'Beginn',
    end: 'Ende',
    statusLabel: 'Status',
    syncPausedHint: 'Nur aktive Projekte werden automatisch mit Forma abgeglichen. Pausierte, abgeschlossene, abgebrochene und archivierte Projekte ruhen; „Jetzt abgleichen“ geht jederzeit, und beim Zurücksetzen auf aktiv liest der nächste Lauf das ganze Projekt.',
    statuses: {
      active: 'Aktiv',
      on_hold: 'Pausiert',
      completed: 'Abgeschlossen',
      cancelled: 'Abgebrochen',
    },
    notes: 'Notizen',
    color: 'Farbe',
    colorHint: 'Erkennungsfarbe in „Meine Woche“ und in den Listen, immer zusammen mit Nummer und Name. Eine der acht Farben, eine eigene Farbe (Farbfeld oder Farbcode) oder keine. Neue Projekte erhalten die Farbe, die sich von den aktiven Projekten am stärksten unterscheidet.',
    colorNone: 'keine',
    colors: {
      blue: 'Blau',
      orange: 'Orange',
      aqua: 'Türkis',
      yellow: 'Gelb',
      magenta: 'Magenta',
      green: 'Grün',
      violet: 'Violett',
      red: 'Rot',
    },
    assignColors: 'Farben vergeben',
    assignColorsHint: 'Aktive Projekte ohne Farbe erhalten eine Farbe, die sich von den Farben der aktiven Projekte möglichst stark unterscheidet. Vorhandene Farben bleiben unverändert.',
    assignedColors: '{{count}} Projekte haben eine Farbe erhalten',
    approval: {
      title: 'Freigabe der Zeiten',
      mode: 'Wer gibt frei',
      companyDefault: 'Standard der Firma ({{mode}})',
      self: 'Eigene Zeiten freigeben (Freigebende)',
      selfHint: 'Dürfen Projektleitung und Büro ihre eigenen Stunden in diesem Projekt freigeben?',
      selfDefault: 'Standard der Firma ({{value}})',
      selfAllowed: 'Freigebende dürfen ihre eigenen Stunden freigeben.',
      changeHint: 'Eine Änderung gilt für alle Einträge, über die noch nicht entschieden ist; bereits freigegebene bleiben freigegeben.',
      modes: {
        office: 'Büro / Assistenz (eine Stufe)',
        lead: 'Projektleitung (eine Stufe)',
        lead_office: 'Projektleitung, dann Büro (zwei Stufen)',
        self: 'Eigene Freigabe mit dem Einreichen',
      },
      hints: {
        office: 'Das Büro (Assistenz der Geschäftsführung) gibt die eingereichten Stunden in einem Schritt frei; die Projektleitung wird nicht gefragt.',
        lead: 'Eine Projektleitung des Projekts gibt in einem Schritt endgültig frei; bei mehreren Projektleitungen genügt eine. Ohne Projektleitung, oder wenn die einzige Projektleitung eigene Stunden einreicht, entscheidet das Büro.',
        lead_office: 'Zwei Schritte: zuerst eine Projektleitung (bei mehreren genügt eine), danach das Büro. Eine dritte Stufe gibt es nie. Erst nach dem Büro gilt der Eintrag als freigegeben und kann abgerechnet werden.',
        self: 'Mit dem Einreichen sind die Stunden freigegeben. Die Person kann das bis zum Monatsabschluss zurückziehen; das Büro kann korrigieren.',
      },
      compare: {
        title: 'Die Möglichkeiten im Vergleich',
        who: 'Wer gibt frei',
        several: 'Mehrere Projektleitungen',
        final: 'Freigegeben und abrechenbar',
        return: 'Rückgabe freigegebener Stunden',
        whoOffice: 'Büro',
        whoLead: 'eine Projektleitung',
        whoLeadOffice: '1. eine Projektleitung, 2. Büro',
        whoSelf: 'die Person mit dem Einreichen',
        severalNone: 'ohne Bedeutung',
        severalOne: 'eine genügt',
        severalOneNoThird: 'eine genügt, keine dritte Stufe',
        finalOffice: 'nach der Freigabe des Büros',
        finalLead: 'nach der Freigabe der Projektleitung',
        finalLeadOffice: 'erst nach dem Büro (Stufe 2)',
        finalSelf: 'sofort mit dem Einreichen',
        returnOffice: 'Büro',
        returnLead: 'Projektleitung oder Büro',
        returnLeadOffice: 'nach Stufe 1: Projektleitung oder Büro; nach Stufe 2: Büro',
        returnSelf: 'Büro',
        note: '„Projektleitung“ und „Projektleitung, dann Büro“ unterscheiden sich nur darin, ob das Büro nach der Projektleitung noch einmal prüft. Die Projektleitung muss nie einzeln von jeder Projektleitung freigegeben werden.',
      },
    },
    archiveText: 'Archivierte Projekte verschwinden aus Listen und Auswahlen. Daten und Forma-Verbindung bleiben erhalten.',
    tabs: {
      overview: 'Übersicht',
      members: 'Team',
      tasks: 'Aufgaben',
      forma: 'Forma',
      fee: 'Honorar',
      kpi: 'Stunden und Budget',
      analysis: 'Analyse',
    },
    members: 'Team',
    addMember: 'Person hinzufügen',
    role: {
      lead: 'Projektleitung',
      member: 'Mitglied',
    },
    listScope: {
      label: 'Welche Projekte',
      mine: 'Meine Projekte',
      all: 'Alle Projekte',
      mineHint: 'Projekte, in denen Sie Mitglied oder Projektleitung sind. „Alle Projekte“ zeigt jedes Projekt, das Sie sehen dürfen; die Auswahl gilt für Ihr Konto auf jedem Gerät.',
    },
    scope: {
      label: 'Aufgaben',
      all: 'alle',
      selected: 'nur ausgewählte',
    },
    validFrom: 'Ab',
    validTo: 'Bis',
    removeMember: 'Entfernen',
    removeMemberText: 'Hat die Person schon gebucht, endet die Mitgliedschaft heute; die Buchungen bleiben.',
    selectTasks: 'Aufgaben auswählen',
    editMember: 'Mitgliedschaft bearbeiten',
    scopeSelectedHint: 'Die Person kann dann nur auf ausgewählte Aufgaben buchen. Nach dem Speichern öffnet sich die Aufgabenauswahl.',
    noTasksSelected: 'Keine Aufgabe ausgewählt: Die Person kann in diesem Projekt nicht buchen.',
    validRangeError: '„Bis“ liegt vor „Ab“.',
    myRole: 'Meine Rolle',
    formaLinked: 'Mit Forma verbunden',
    formaNotLinked: 'Nicht mit Forma verbunden',
    formaState: {
      not_linked: 'Nicht verbunden',
      active: 'Verbunden',
      deleted: 'In Forma gelöscht',
      access_lost: 'Kein Zugriff in Forma',
    },
    formaStateHint: 'Die Plattform löscht nie Daten wegen Änderungen in Forma. Betroffene Aufgaben bleiben buchbar und werden markiert.',
    formaLink: 'Forma-Projekt verbinden',
    formaUnlink: 'Verbindung lösen',
    formaProject: 'Forma-Projekt',
    syncEnabled: 'Issues automatisch übernehmen',
    includeClosed: 'Geschlossene Issues übernehmen',
    syncNow: 'Jetzt abgleichen',
    fullSync: 'Vollabgleich',
    lastSync: 'Letzter Abgleich',
    syncResult: '{{created}} neu, {{updated}} geändert, {{flagged}} markiert, {{excluded}} durch den Filter nicht übernommen',
    feePhases: 'Honorar nach Leistungsphasen (HOAI § 55 Technische Ausrüstung)',
    feeHint: 'Bewertung und Beträge frei änderbar, z. B. für Minderungen oder Besondere Leistungen.',
    resetHoai: 'Auf HOAI-Standard zurücksetzen',
    runStats: '{{fetched}} gelesen, {{created}} neu, {{updated}} geändert, {{excluded}} nicht übernommen',
    whatIsRead: 'Was aus Forma gelesen wird',
    readFields: 'Issues mit Nummer, Titel, Status, Kategorie und Typ, Standort, Beginn und Fälligkeit sowie die unten gewählten Felder.',
    readNotHours: 'Planstunden und gebuchte Stunden kommen nur aus Projektzeit, nicht aus Forma.',
    readOneWay: 'Nur lesen: Projektzeit schreibt nie nach Forma.',
    includeClosedHint: 'Empfohlen: auch erledigte Issues übernehmen, damit Fortschritt und Buchungen vollständig sind.',
    importFilter: 'Kategorien und Typen (Importfilter)',
    clashInfo: 'Kollisionen aus der Modellkoordination (Forma Model Coordination, Navisworks-Anbindung) legt Forma als Issues in der Kategorie „Coordination“ mit dem festen Typ „Clash“ an. Typen mit diesem Namen oder „Kollision“ werden standardmäßig nicht übernommen. Hier festlegen, welche Typen in Projektzeit erscheinen.',
    saveFilter: 'Speichern und abgleichen',
    filterSaved: 'Gespeichert: {{hidden}} ausgeblendet, {{shown}} wieder sichtbar, {{kept}} mit Stunden behalten',
    cleanupExcluded: 'Ausgeblendete bereinigen ({{count}})',
    noTypesYet: 'Kategorien und Typen werden beim nächsten Abgleich aus Forma gelesen.',
    take: 'Übernehmen',
    categoryType: 'Kategorie / Typ',
    inProjektzeit: 'Sichtbar',
    hiddenByFilter: 'Ausgeblendet',
    withHours: 'Mit Stunden',
    clashBadge: 'Kollision',
    inactiveInForma: 'in Forma inaktiv',
    notTaken: 'nicht übernommen',
    showTasks: 'In der Aufgabenliste zeigen',
    lastFullExcluded: 'Beim letzten vollständigen Abgleich ({{date}}) durch den Filter nicht übernommen: {{count}} Issues.',
    keptWithHours: '{{count}} Aufgaben ausgeschlossener Typen bleiben sichtbar, weil auf sie gebucht wurde.',
    filterHint: 'Ausschließen blendet die Aufgaben sofort aus (umkehrbar). „Bereinigen“ löscht ausgeblendete Aufgaben ohne Stunden aus Projektzeit; in Forma bleiben sie und kommen zurück, wenn der Typ wieder übernommen wird.',
    cleanupTitle: 'Ausgeblendete Aufgaben bereinigen',
    cleanupText: '{{count}} ausgeblendete Aufgaben der ausgeschlossenen Typen ohne gebuchte Stunden werden aus Projektzeit gelöscht. In Forma ändert sich nichts. Aufgaben mit Stunden bleiben erhalten.',
    cleanupConfirm: 'Bereinigen',
    cleanupDone: '{{deleted}} Aufgaben gelöscht, {{kept}} mit Stunden behalten',
    fieldsTitle: 'Felder aus Forma ({{taken}} von {{total}} übernommen)',
    fieldsIntro: 'Benutzerdefinierte Felder der Forma-Issues, z. B. Gewerk, Geschoss, Leistungsphase, Priorität, Teilprojekt, Sprints. Übernommene Felder erscheinen in den Aufgabenlisten als Spalte und Filter und in der Projektanalyse.',
    reloadFields: 'Felder neu lesen',
    fieldsReloaded: '{{count}} Felder gelesen',
    saveFields: 'Speichern und abgleichen',
    fieldsSaved: 'Felder gespeichert; der Abgleich liest die Werte',
    searchFields: 'Feld suchen',
    onlyTaken: 'Nur übernommene',
    noFieldsYet: 'Die Felder werden beim nächsten Abgleich aus Forma gelesen.',
    field: 'Feld',
    fieldType: 'Art',
    fieldValues: 'Werte',
    fieldRole: 'In der Analyse',
    fieldDeleted: 'in Forma gelöscht',
    locationsUsed: 'Die Analyse nimmt Gebäude und Geschoss aus den Forma-Standorten (Gebäude: Ebene {{building}}, Geschoss: Ebene {{floor}}).',
    fieldsHint: 'Werte werden nur gelesen und bei jedem Abgleich aktualisiert. Welches Feld als Geschoss, Gebäude, Gewerk oder Leistungsphase dient, wird vorgeschlagen und lässt sich in der Projektanalyse unter „Einstellungen“ ändern.',
    fieldRoles: {
      floor: 'Geschoss',
      building: 'Gebäude',
      trade: 'Gewerk',
      phase: 'Leistungsphase',
    },
    fieldTypes: {
      list: 'Liste',
      text: 'Text',
      numeric: 'Zahl',
      date: 'Datum',
      paragraph: 'Absatz',
      checkbox: 'Ankreuzfeld',
    },
    count: '{{count}} Projekte',
    count_one: '{{count}} Projekt',
    archiveFilter: 'Anzeige',
    archiveModes: {
      active: 'Aktuelle Projekte',
      only: 'Nur archivierte',
      all: 'Alle',
    },
    booking: {
      title: 'Buchbarkeit',
      open: 'Buchbar',
      openHint: 'Mitarbeitende finden das Projekt und seine Aufgaben beim Buchen.',
      closedShort: 'Nicht buchbar',
      closedHint: 'Ohne aktive Forma-Verbindung und ohne Freigabe ist das Projekt bei der Suche nach Projekten und Aufgaben ausgeblendet.',
      release: 'Ohne Forma buchbar',
      releaseHint: 'Gibt das Projekt ohne Forma-Verbindung zum Buchen frei (z. B. Akquise oder ein Altprojekt). Jederzeit wieder zurücknehmbar.',
    },
    identityOnlyHint: 'Als technischer Admin ändern Sie Projektnummer und Namen; alle anderen Angaben pflegt das Büro.',
    includeDrafts: 'Entwürfe aus Forma übernehmen',
    includeDraftsHint: 'Aus (Standard): Issues im Entwurfsstatus werden keine Aufgaben; schon angelegte Entwürfe ohne Stunden werden ausgeblendet. An: Entwürfe zählen in den Analysen (Fortschritt) mit, bleiben aber in jedem Fall von der Buchung ausgeschlossen; erst nach der Veröffentlichung in Forma kann gebucht werden.',
    formaNameFollow: 'Nummer und Namen aus Forma übernehmen',
    formaNameFollowHint: 'Eine Umbenennung in Forma ändert Projektnummer und Namen hier beim nächsten Abgleich. Aus: die hier gepflegten Angaben bleiben.',
    runDrafts: '{{count}} Entwürfe nicht übernommen',
    runDrafts_one: '1 Entwurf nicht übernommen',
    colorCustom: 'Eigene Farbe',
    colorCode: 'Farbcode (#rrggbb)',
    formaLinks: {
      files: 'Forma: Dateien',
      filesHint: 'Öffnet das Projekt in Forma unter Data Management > Files',
      board: 'Forma Board',
      boardHint: 'Öffnet das Board dieses Projekts in Forma Board',
      boardGeneralHint: 'Öffnet Forma Board (für das Projekt ist kein eigenes Board hinterlegt)',
      boardUrl: 'Adresse des Forma Boards dieses Projekts (optional)',
      boardUrlHint: 'Forma Board ist eine eigene Anwendung; die Adresse des Boards aus der Browserzeile hier einfügen. Leer: Der Knopf öffnet den allgemeinen Einstieg.',
      boardUrlInvalid: 'Die Adresse beginnt mit https://',
    },
    resetHoaiHint: 'Setzt die Leistungsphasen auf die Anteile der HOAI § 55 (Technische Ausrüstung) und verteilt das Gesamthonorar danach.',
    resetHoaiText: 'Die Leistungsphasen werden durch die Standardanteile der HOAI § 55 ersetzt ({{shares}}) und das Gesamthonorar von {{total}} danach verteilt. Eigene Bezeichnungen, Anteile und Beträge gehen dabei verloren. Gespeichert wird erst mit „Speichern“.',
  },
  people: {
    protectedHint: 'Dieses Konto hat geschützte Rechte, die Sie nicht haben. Rolle, Zugang, E-Mail und Aktivierung ändert nur, wer diese Rechte hat (in der Regel die Geschäftsführung); Notfallzugang nur auf dem Server.',
    weeklyHoursHint: 'Sichtbar nur für die Person selbst, die Personalverwaltung und die Geschäftsführung.',
    title: 'Personen',
    new: 'Person anlegen',
    displayName: 'Name',
    shortCode: 'Kürzel',
    kind: {
      external: 'Extern',
    },
    company: 'Firma (extern)',
    discipline: 'Fachbereich',
    country: 'Standort',
    countries: {
      DE: 'Deutschland',
      TR: 'Türkei',
    },
    calendar: 'Feiertagskalender',
    entryDate: 'Eintritt',
    exitDate: 'Austritt',
    notes: 'Notizen (HR)',
    contracts: 'Arbeitszeit',
    weeklyHours: 'Stunden je Woche',
    workdays: 'Arbeitstage',
    addContract: 'Änderung ab Datum',
    rates: 'Stundensätze',
    rateKind: {
      sales: 'Verkauf',
      cost: 'Kosten',
      overtime: 'Überstundensatz',
    },
    rateProject: 'nur Projekt',
    perHour: '€/h',
    roles: {
      admin: 'Administration (IT)',
      office: 'Büro und Geschäftsführung',
      employee: 'Mitarbeiter/in',
      external: 'Extern',
    },
    ownRightsHint: 'Die eigene Rolle und die eigenen Rechte ändert eine andere berechtigte Person. Geschützte Rechte vergibt nur, wer sie selbst hat.',
    extraPermissions: 'Zusätzliche Rechte',
    permissions: {
      'time.approve.final': 'Zeiten final freigeben',
      'time.manage': 'Alle Zeiten korrigieren',
      'period.manage': 'Monatsabschluss',
      'billing.manage': 'Abrechnung',
      'rates.sales.view': 'Verkaufssätze sehen',
      'rates.cost.view': 'Kostensätze sehen',
      'hr.manage': 'Personal: Vertragsstunden, Abwesenheiten (vertraulich)',
      'kpi.team.view': 'Team-Kennzahlen (vertraulich)',
      'workload.manage': 'Auslastung planen',
      'projects.manage': 'Projekte verwalten',
      'users.manage': 'Benutzer und Rollen',
      'settings.manage': 'Einstellungen',
      'backup.manage': 'Datensicherung',
      'audit.view': 'Protokoll einsehen',
      'data.export.all': 'Gesamtexport und Power BI',
      'sync.manage': 'Forma-Abgleich',
      'analytics.view': 'Projektanalyse aller Projekte (Leitung)',
      'customers.manage': 'Kundenstamm und Konditionen',
      'announcements.manage': 'Mitteilungen veröffentlichen',
      'rights.manage': 'Rollen und Rechte vergeben',
      'projects.view.all': 'Alle Projekte mit Stunden sehen',
      'staffing.view': '„Wer arbeitet wo“ sehen',
    },
    permissionHints: {
      'time.approve.final': 'Endgültige Freigabe der Zeiten aller Projekte (die Projektleitung gibt ihre Projekte ohne dieses Recht frei).',
      'time.manage': 'Einträge anderer anlegen, ändern und löschen, auch freigegebene (mit Protokoll).',
      'period.manage': 'Monate abschließen und wieder öffnen.',
      'billing.manage': 'Stundennachweise, Abschläge, abzurechnende Stunden.',
      'rates.sales.view': 'Verkaufssätze und Beträge auf Dokumenten und in der Analyse sehen.',
      'rates.cost.view': 'Kostensätze und Kosten in der Analyse sehen.',
      'hr.manage': 'Verträge, Abwesenheiten aller, Krankmeldungen, Überstunden und Feiertage.',
      'kpi.team.view': 'Mitarbeiterauswertung (vertraulich, jeder Aufruf wird protokolliert).',
      'workload.manage': 'Planung aller Projekte und Auslastung aller Personen.',
      'projects.manage': 'Projekte anlegen und ändern, Projektleitung und Team festlegen, Vorlagen.',
      'users.manage': 'Konten anlegen, Zugänge zurücksetzen, aktivieren und deaktivieren.',
      'settings.manage': 'Systemeinstellungen, Kategorien, Outlook-Anbindung.',
      'backup.manage': 'Sicherungen erstellen und einspielen.',
      'audit.view': 'Protokoll lesen (Beträge, Stunden und Gesundheitsdaten nur mit dem passenden Recht).',
      'data.export.all': 'Gesamtexport und Power-BI-Daten.',
      'sync.manage': 'Forma-Verbindung und -Abgleich, Feldübernahme.',
      'analytics.view': 'Projektanalyse und Portfolio aller Projekte.',
      'customers.manage': 'Kunden, Ansprechpartner und Konditionen.',
      'announcements.manage': 'Mitteilungen an alle oder Gruppen veröffentlichen.',
      'rights.manage': 'Rollen und Rechte vergeben (geschützte Rechte nur, wer sie selbst hat).',
      'projects.view.all': 'Alle Projekte (auch archivierte) mit Team, Aufgaben und Stunden lesen, z. B. für eine Projektleitung, die die Bereichsleitung vertritt. Ändern nur mit den passenden Rechten.',
      'staffing.view': 'Wer in welchem Projekt mitarbeitet (Kästchen, Projektleitung als „PL“). Stunden nur für Projekte, deren Stunden die Person ohnehin sehen darf.',
    },
    roleBase: {
      employee: 'ohne besondere Rechte: eigene Zeiten und Woche, eigene Abwesenheiten, Teamkalender, Aufgaben und Projekte, in denen die Person Mitglied ist. Als Projektleitung (im Projekt festgelegt) zusätzlich Freigabe, Planung und Analyse der eigenen Projekte – dafür ist kein Recht nötig.',
      external: 'ohne besondere Rechte: nur die zugewiesenen Projekte und Aufgaben buchen, eigene Einträge; kein Teamkalender, keine Kennzahlen.',
      office: 'alle fachlichen Rechte des Büros und der Geschäftsführung (Freigabe, Abrechnung, Personal, Projekte, Auswertungen). Rollen und Rechte vergeben gehört nicht dazu.',
      admin: 'technische Verwaltung: Konten, Rechte (ohne geschützte), Einstellungen, Forma, Sicherung und Protokoll. Keine Freigaben, Abrechnung, Personal- oder Leistungsdaten.',
    },
    roleMatrix: {
      title: 'Standardrechte aller Rollen',
      protected: 'Geschütztes Recht: vergibt nur, wer es selbst hat',
      hint: 'Jedes Recht gehört zum Standard mindestens einer Rolle. Mitarbeitende haben als Standard nur „Wer arbeitet wo“ (ohne fremde Stunden), Externe bewusst keines; was beide ohne Rechte können (buchen, eigene Woche, eigene Abwesenheiten), steht oben. Weitere Rechte gibt es je Person. Die Geschäftsführung ist Büro plus „Rollen und Rechte vergeben“.',
    },
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    resetAccess: 'Zugang zurücksetzen',
    setupLink: 'Einrichtungslink',
    setupLinkHint: 'Den Link persönlich übermitteln. Er gilt 7 Tage und nur einmal.',
    memberships: 'Projekte',
    absenceSummary: 'Abwesenheiten {{year}}',
    days: '{{count, number}} Tage',
    days_one: '{{count, number}} Tag',
    access: {
      title: 'Zugang',
      password: 'Passwort gesetzt',
      totp: 'Zweiter Faktor aktiv',
      pending: 'Einrichtung offen',
      entra: 'Microsoft-Anmeldung verknüpft',
      lockedUntil: 'Gesperrt bis {{time}} (zu viele Fehlversuche bei Anmeldung oder Bestätigung)',
      unlock: 'Sperre aufheben',
      unlocked: 'Sperre aufgehoben',
    },
    tabs: {
      master: 'Stammdaten',
      time: 'Arbeitszeit',
      rates: 'Sätze',
      access: 'Rolle und Zugang',
    },
    weekly: '{{hours}} h/Woche',
    accessHint: 'Passwörter vergibt niemand direkt: „Zugang zurücksetzen“ erzeugt einen Einrichtungslink, mit dem die Person selbst ein Passwort festlegt.',
    removePicture: 'Profilbild entfernen',
    approver: {
      title: 'Genehmigung von Abwesenheiten',
      hint: 'Urlaub und andere Anträge entscheidet die gewählte Person (z. B. Teamleitung). Krankmeldungen bestätigt immer die Personalverwaltung. Ohne Auswahl entscheidet die Personalverwaltung.',
      hr: 'Personalverwaltung',
    },
    subtitle: 'Stammdaten, Rolle und Zugang. Abwesenheiten, Urlaubskonten und Kalender stehen im Reiter „Abwesenheiten“.',
    searchPlaceholder: 'Name, Kürzel, Fachbereich oder E-Mail suchen',
    count: '{{count}} Personen',
    count_one: '{{count}} Person',
    shortCodeHint: 'Feste Kennung der Person in Nachweisen und Listen (z. B. HA, HAL): 2 bis 6 Buchstaben oder Ziffern, im ganzen Unternehmen eindeutig.',
    shortCodeAuto: 'automatisch',
    suggestCode: 'Aus dem Namen vorschlagen',
    fillCodes: 'Fehlende Kürzel vergeben ({{count}})',
    fillCodesHint: 'Vergibt allen aktiven Personen ohne Kürzel ein eindeutiges Kürzel: die Initialen (HA); ist es vergeben, kommt ein Buchstabe dazu (HAL).',
    fillCodesDone: '{{count}} Kürzel vergeben',
    noAccess: 'Nur für die Personalverwaltung und die Systemverwaltung.',
    rights: 'Rechte',
    rightsHint: 'Die Rolle setzt Standardrechte (vorausgewählt). Einzelne Standardrechte lassen sich entfernen, weitere hinzufügen. Rollen und Rechte ändern nur Administration und Geschäftsführung.',
    rightsDefault: 'Standard der Rolle',
    rightsReadOnly: 'Rollen und Rechte ändern nur Administration und Geschäftsführung.',
    rightTags: {
      default: 'Standard',
      removed: 'entfernt',
      extra: 'zusätzlich',
    },
    jobTitle: 'Berufsbezeichnung',
    jobTitleHint: 'Nur zur Anzeige; die Rechte hängen nicht davon ab.',
    overtimeAccount: 'Überstundenkonto führen',
    overtimeAccountHint: 'Aus: keine Überstunden-Bilanz und kein Freizeitausgleich (z. B. Geschäftsführung oder pauschale Vergütung).',
    overtimeRateHint: 'Persönlich, gilt für alle Projekte: der Betrag je Überstunde laut Vertrag (gleich dem normalen Satz oder anders). Sichtbar nur mit dem Recht auf Kostensätze.',
  },
  admin: {
    outlook: {
      title: 'Outlook-Kalender',
      notConfigured: 'Die Verbindung zu Microsoft 365 ist nicht eingerichtet (GRAPH_* in der .env). Siehe Installationsanleitung.',
      off: 'Die Übertragung ist in den Einstellungen ausgeschaltet.',
      connection: 'Verbindung',
      targets: 'Ziele',
      personal: 'persönliche Kalender',
      appointments: 'Termine in Outlook',
      failing: '{{count}} mit Fehler',
      failing_one: '{{count}} mit Fehler',
      lastRun: 'Letzter Lauf',
      result: 'Ergebnis',
      resultText: '{{created}} neu, {{updated}} geändert, {{removed}} entfernt, {{errors}} Fehler',
      syncNow: 'Jetzt übertragen',
      hint: 'Läuft alle 5 Minuten. Übertragen werden nur genehmigte Abwesenheiten von 7 Tagen zurück bis etwa 13 Monate voraus, ohne Bemerkungen. Arten, die nicht für den Teamkalender freigegeben sind, und Krankheit erscheinen als „Abwesend“.',
      problems: 'Postfächer mit Fehlern',
      noProblems: 'Keine Fehler.',
    },
    title: 'Verwaltung',
    tabs: {
      outlook: 'Outlook',
      settings: 'Einstellungen',
      periods: 'Monatsabschluss',
      forma: 'Forma',
      backup: 'Datensicherung',
      audit: 'Protokoll',
      categories: 'Kategorien',
      templates: 'Aufgabenvorlagen',
      jobs: 'Berichte der Wartung',
    },
    settings: {
      leave: 'Abwesenheiten',
      teamVisible: 'Im Teamkalender mit Art sichtbar',
      teamVisibleHint: 'Alle anderen Arten erscheinen als „abwesend“. Krankheit ist nie mit Art sichtbar.',
      outlook: 'Outlook-Kalender',
      outlookEnabled: 'Genehmigte Abwesenheiten in Outlook eintragen',
      outlookPersonal: 'Im Kalender der Person mit dem Status „Abwesend“ (sichtbar bei der Terminplanung in Outlook und Teams)',
      outlookTeam: 'Gemeinsamer Teamkalender (Postfach-Adresse, optional)',
      outlookHint: 'Voraussetzung: App-Registrierung und Exchange-Rollenzuweisung, siehe Installationsanleitung.',
      annMail: 'Mitteilungen per E-Mail',
      annMailEnabled: 'Mitteilungen auch per E-Mail senden können',
      annMailEnabledHint: 'Wer veröffentlicht, entscheidet je Mitteilung („Auch per E-Mail senden“). Das Häkchen ist bei jeder neuen Mitteilung zunächst nicht gesetzt. Die E-Mail geht an die Firmenadressen der erreichten Personen, auch an externe, als Blindkopie.',
      annMailSender: 'Absender',
      annMailSenderHint: 'Die Adresse, von der die E-Mails kommen und in deren „Gesendete Elemente“ sie liegen.',
      annMailPublisher: 'Die Person, die die Mitteilung veröffentlicht',
      annMailNoAddress: 'Die gewählte Person hat keine gültige E-Mail-Adresse. Bitte eine andere Person wählen oder die Adresse unter Personen ergänzen.',
      annMailNotConfigured: 'Es ist kein E-Mail-Dienst eingerichtet (Microsoft Graph, wie für die Outlook-Kalender). Ohne ihn wird nichts gesendet.',
      annMailHint: 'Technisch: Die App-Registrierung braucht in Exchange Online das Recht „Application Mail.Send“, beschränkt auf die Postfächer der Absender (siehe docs/INTEGRATIONS.md).',
      syncInterval: 'Forma-Abgleich alle',
      syncWindow: 'Zeitraum',
      windows: {
        daily: 'Täglich 6-24 Uhr, auch sonntags',
        workhours: 'Mo-Sa 6-21 Uhr',
        always: 'Rund um die Uhr',
      },
      minutes: '{{count}} Minuten',
      autoImport: 'Neue Forma-Projekte nachts übernehmen (buchbar nur für das Projektteam)',
      company: 'Firma',
      appName: 'Name der Anwendung',
      place: 'Ort (für Dokumente)',
      defaultCalendar: 'Standard-Feiertagskalender',
      approval: 'Freigabe',
      stages: 'Freigabestufen',
      stages1: '1 Stufe (Projektleitung oder Büro)',
      stages2: '2 Stufen (Projektleitung, dann Büro)',
      selfApproval: 'Eigene Zeiten freigeben erlaubt',
      approvalMode: 'Standard-Freigabe der Zeiten',
      approvalModeHint: 'Gilt für Projekte ohne eigene Wahl. Jedes Projekt kann unter Übersicht > Freigabe der Zeiten eine eigene Regel haben.',
      selfApprovalHint: 'Standard für alle Projekte; ein Projekt kann es anders festlegen.',
      time: 'Zeiterfassung',
      step: 'Raster (Minuten)',
      requireDescription: 'Tätigkeit Pflicht für',
      ownBillingType: 'Mitarbeitende wählen beim Buchen die Abrechnungsart (abrechenbar, im Pauschalhonorar, nicht abrechnen). Vorgabe aus Aufgabe und Projekt; feste Regeln von Kategorie oder Aufgabe bleiben fest. Die abzurechnenden Stunden legt weiterhin die Abrechnung fest.',
      warnDaily: 'Hinweis ab Stunden pro Tag',
      maxFuture: 'Buchung in die Zukunft (Tage)',
      deadline: 'Einreichen bis (Tage nach Wochenende)',
      trackingStart: 'Erfassungsbeginn (Go-live)',
      trackingStartHint: 'Soll/Ist-Kennzahlen und Kapazitätsdaten für Power BI zählen ab diesem Tag.',
      billing: 'Abrechnung',
      billingMoved: 'Die Voreinstellungen der Dokumente (Nummernkreise, Umsatzsteuer, Sprache, Aussteller, Tagestexte) ändert, wer das Recht „Abrechnung“ hat, in der Abrechnung unter „Voreinstellungen der Dokumente“; das vorgeschlagene Zahlungsziel unter Kunden › Konditionen. Beide Module sind nur mit der zusätzlichen Bestätigung offen; die technische Administration ändert sie nicht.',
      prefixSn: 'Nummernkreis Stundennachweis',
      prefixAb: 'Nummernkreis Abschlag',
      vat: 'Umsatzsteuer %',
      issuerName: 'Firmenname in Dokumenten',
      issuerAddress: 'Adresse in Dokumenten',
      billingLanguage: 'Standardsprache Dokumente',
      forma: 'Forma',
      deepLink: 'Link-Vorlage zu Issues',
      security: 'Sicherheit',
      totpExternal: 'Zweiter Faktor für Externe',
      teamKpi: 'Team-Kennzahlen (personenbezogene Leistungsdaten) eingeschaltet. Ausschalten, bis z. B. eine Betriebsvereinbarung vorliegt.',
      leadLoadLevels: 'Auslastungsampel auch für Projektleitung und Planung (Farben ohne Stunden). Wer Planwerte gezielt verändert, kann aus dem Farbwechsel die verfügbaren Wochenstunden einer Person ungefähr ableiten; ausschalten, wenn das nicht gewünscht ist.',
      totpPrivileged: 'Zweiter Faktor für Büro, Geschäftsführung, Admin',
      idle: 'Abmeldung nach Inaktivität (Stunden)',
      maxDays: 'Sitzung höchstens (Tage)',
      bi: 'Power BI',
      pseudonymize: 'Namen im Power-BI-Export durch Kürzel ersetzen',
      companyName: 'Firmenname',
      companyNameHint: 'Erscheint in der Navigation, auf der Anmeldeseite und in Exporten.',
      logo: 'Logo',
      logoHint: 'PNG, JPG oder SVG; wird auf höchstens 600 × 200 Pixel verkleinert und sofort gespeichert.',
      noLogo: 'kein Logo',
      logoUpload: 'Logo hochladen',
      logoChange: 'Logo ersetzen',
      workLocations: 'Arbeitsorte (Auswahl beim Buchen)',
      workLocationsHint: 'Feste Liste statt Freitext. Die erste Angabe ist Standard für neue Einträge.',
      hrKpi: 'Kennzahlen',
      tolerance: 'Hinweis ab Abweichung je Woche (Stunden)',
      toleranceHint: 'Abgeschlossene Wochen mit größerer Abweichung zur Kapazität werden als „unter Soll“ oder „über Soll“ markiert.',
      snDefaultHint: 'Voreinstellung für neue Stundennachweise; im Dokument änderbar.',
      docSick: 'Bescheinigung bei Krankheit ab Kalendertag',
      docChildSick: 'Bescheinigung bei Kind krank ab Kalendertag',
      docHint: '0 = keine Bescheinigung erwartet. Fehlt eine erwartete Bescheinigung, sehen die Person und die Personalverwaltung einen Hinweis; die Krankmeldung zählt trotzdem.',
      retention: 'Nachweise aufbewahren (Monate nach Ende der Abwesenheit)',
      retentionHint: '0 = ohne Frist aufbewahren. Danach löscht die nächtliche Wartung den Inhalt der Dateien; Name und Zeitpunkt bleiben im Protokoll.',
      saturdayLeaveTR: 'Türkei: Samstag zählt im Urlaub als Urlaubstag',
      saturdayLeaveTRHint: 'Für Personen mit türkischem Feiertagskalender und 5-Tage-Woche: Ein Samstag zwischen zwei Urlaubstagen zählt als Urlaubstag, wenn der Arbeitsvertrag den Samstag nicht als wöchentlichen Ruhetag (hafta tatili) festlegt (Yargıtay; İş Kanunu Art. 56). Aus: es zählen nur die Arbeitstage des Vertrags (günstiger für die Beschäftigten). Sonntage, Feiertage und Feiertage auf einem Samstag zählen nie; die Sollzeit ändert sich nicht.',
      leaveRulesHint: 'Urlaubstage zählen nur an Arbeitstagen des Vertrags; Wochenenden, Feiertage des Kalenders der Person und freie Tage zählen nicht. Erkrankt jemand im Urlaub, trägt die Personalabteilung die Krankheit mit Attest ein: Die Urlaubstage werden gutgeschrieben (§ 9 BUrlG; Türkei: İş Kanunu Art. 56, Yıllık Ücretli İzin Yönetmeliği Art. 6), der Urlaub verlängert sich nicht. Einzelheiten: Hilfe › Abwesenheiten.',
      standardsUrl: 'Link zu den Firmenstandards',
      standardsUrlHint: 'Seite, auf der die Firma Richtlinien, Vorlagen und Layouts pflegt (z. B. SharePoint). Die Startseite verlinkt nur dorthin; Inhalte werden nicht in die Plattform übernommen.',
      links: 'Links in der Seitenleiste',
      linksHint: 'Erscheinen über dem eigenen Namen, nur wenn eine Adresse eingetragen ist. Ohne eigene Bezeichnung gilt die Standardbezeichnung der jeweiligen Sprache. Inhalte werden nicht in die Plattform übernommen.',
      linkUrl: {
        standards: 'Firmenstandards und Vorlagen (Adresse)',
        meetings: 'Notizen der Koordinationsbesprechung (Adresse)',
        website: 'Website der Firma (Adresse)',
        formaHome: 'Forma My Home (Adresse; Standard https://acc.autodesk.eu/home)',
        sharepoint: 'SharePoint der Firma, Hauptordner (Adresse)',
      },
      linkLabel: 'Bezeichnung (optional)',
      automations: 'Automatisierungen',
      automationsIntro: 'Erinnerungen, die die Plattform selbst erzeugt: ohne externen Dienst und ohne E-Mail. Jede Regel zeigt einer Person nur, was sie ohnehin sehen darf.',
      autoWeekly: 'Frist zum Einreichen der Woche (Mitarbeitende)',
      autoMissing: 'Fehlende Buchungen: Arbeitstage ohne Eintrag (Mitarbeitende)',
      autoMissingDays: 'Rückblick (Arbeitstage)',
      autoPending: 'Wartende Freigaben (Genehmigende)',
      autoPendingDays: 'Hervorheben nach (Tagen)',
      autoMonth: 'Monatsabschluss in den ersten Arbeitstagen (Büro, Geschäftsführung)',
      jobsTitle: 'Hintergrundaufgaben (nur Anzeige)',
      jobForma: 'Forma-Abgleich',
      jobFormaWhen: 'alle {{minutes}} Minuten, {{window}}',
      jobOutlook: 'Outlook-Kalender',
      jobOutlookWhen: 'alle 5 Minuten, wenn die Anbindung eingeschaltet ist',
      jobNightly: 'Nachtlauf',
      jobNightlyWhen: '2:30 Uhr: Abgleich, Momentaufnahme, Kapazitätswerte, Aufbewahrungsfristen, Power-BI-Export (wenn eingerichtet)',
      jobsHint: 'Diese Aufgaben laufen immer. Rhythmus und Zeitfenster des Forma-Abgleichs stellen Sie im Bereich „Forma / Power BI“ ein.',
      paymentDays: 'Standard-Zahlungsziel (Tage)',
      paymentDaysHint: 'Vorgabe für das Zahlungsziel, wenn die Konditionen eines Projekts angelegt werden. Die Konditionen je Projekt stehen unter Kunden › Konditionen.',
      noOvertime: 'Stunden ohne Überstundenwirkung erlauben („zählt nicht als Überstunden“)',
      noOvertimeHint: 'Manche gebuchte Stunden sollen das Überstundenkonto nicht erhöhen, z. B. freiwillige Weiterbildung am Abend, eine Firmenveranstaltung außerhalb der Arbeitszeit oder Reisezeit, die nach Vertrag keine Arbeitszeit ist. Eingeschaltet können Einträge (von der Person, der Freigabe oder Personal) und ganze Kategorien so markiert werden. Die Stunden bleiben gebucht, im Projekt sichtbar und abrechenbar; sie zählen nur nicht zum Überstundensaldo. Aus (Standard): Jede gebuchte Stunde zählt. Vor dem Einschalten mit dem Betriebsrat klären (A-10).',
      outlookHolidays: 'Feiertage in die persönlichen Kalender eintragen',
      outlookHolidaysHint: 'Jede Person erhält ihre Feiertage aus Projektzeit (Kalender, Firmentage, eigene Abweichungen) als Termin „abwesend“; Änderungen werden übernommen. Den Feiertagskalender von Outlook selbst bitte nicht zusätzlich einblenden, sonst erscheinen Tage doppelt (Outlook: Datei > Optionen > Kalender > Feiertage hinzufügen – nicht verwenden).',
      splitRuleTR: 'Türkei: Hinweis auf den Urlaubsteil von 10 Tagen',
      splitRuleTRHint: 'Aus (Standard). An: Die Freigabe zeigt einen Hinweis, wenn im Jahr kein Urlaubsteil von mindestens 10 Arbeitstagen mehr möglich ist (İş Kanunu m. 56/3). Nichts wird blockiert.',
      leaveTwoStage: 'Abwesenheitsanträge in zwei Stufen genehmigen',
      leaveTwoStageHint: 'Aus (Standard): Die zugewiesene Person (Personen > Genehmigung der Abwesenheiten) entscheidet allein. An: Sie stimmt zuerst zu, danach entscheidet Personal; Personal kann jederzeit direkt entscheiden. Ohne zugewiesene Person und bei Krankmeldungen bleibt es bei Personal.',
    },
    periods: {
      hint: 'Ein abgeschlossener Monat kann nicht mehr geändert werden. Offene Einträge vorher klären.',
      lock: 'Abschließen',
      unlock: 'Öffnen',
      locked: 'Abgeschlossen',
      open: 'Offen',
      openEntries: 'Entwürfe',
      submitted: 'In Prüfung',
      approved: 'Freigegeben',
      billed: 'Abgerechnet',
      forceTitle: 'Monat trotz offener Einträge abschließen?',
      forceText: '{{count}} Einträge sind noch nicht freigegeben. Sie bleiben dann unverändert im abgeschlossenen Monat.',
      forceText_one: '{{count}} Eintrag ist noch nicht freigegeben. Er bleibt dann unverändert im abgeschlossenen Monat.',
      unlockTitle: 'Monat wieder öffnen',
    },
    forma: {
      connStatus: {
        connected: 'verbunden',
        disconnected: 'nicht verbunden',
        error: 'Fehler',
      },
      nextRun: 'Nächster Abgleich',
      load: 'Je Lauf: {{projects}} aktive Projekte, etwa {{requests}} Abrufe, Dauer etwa {{minutes}} Min.; etwa {{perDay}} Abrufe am Tag. Nicht abgeglichen: {{skipped}} pausierte, abgeschlossene, abgebrochene oder archivierte Projekte. Projektzeit sendet höchstens {{rpm}} Abrufe je Minute und wartet, wenn Autodesk eine Pause verlangt.',
      loadWarn: 'Ein Lauf braucht fast das ganze Intervall: Intervall vergrößern oder beendete Projekte auf abgeschlossen setzen.',
      connection: 'Verbindung',
      mode: 'Modus',
      modes: {
        mock: 'Demo (fiktive Daten)',
        user_3lo: 'Dienstkonto (Anmeldung)',
        ssa: 'Secure Service Account',
      },
      hub: 'Hub',
      connect: 'Mit Forma anmelden',
      notConfigured: 'Forma ist nicht eingerichtet (FORMA_MODE). Siehe Installationsanleitung.',
      projects: 'Verbundene Projekte',
      runs: 'Letzte Abgleiche',
      syncAll: 'Alle abgleichen',
      fullAll: 'Vollabgleich aller Projekte',
      kind: {
        full: 'voll',
        incremental: 'Änderungen',
      },
      statsHeader: 'abgerufen / neu / geändert / markiert',
      duration: 'Dauer',
      token: 'Anmeldung gültig bis',
      runStatus: {
        ok: 'ok',
        warning: 'Hinweis',
        error: 'Fehler',
        running: 'läuft',
      },
      filesTemplate: 'Adresse „Dateien“ eines Projekts ({projectId})',
      boardTemplate: 'Adresse „Forma Board“ (allgemeiner Einstieg; {projectId} möglich)',
      linksHint: 'Für Projekte mit Forma-Verbindung zeigt die Projektseite „Forma: Dateien“ und „Forma Board“. Ein Projekt kann im Reiter Forma die Adresse seines eigenen Boards tragen.',
    },
    backup: {
      countsOnly: 'Anzahl der Zeilen je Tabelle. Geänderte Einträge mit Person, Datum und Stunden sieht nur, wer das Recht „Gesamtexport und Power BI“ hat.',
      title: 'Datensicherung',
      hint: 'Die Datenbank wird jede Nacht vollständig gesichert (Server). Hier: Momentaufnahmen zum Vergleichen und Gesamtexporte.',
      snapshots: 'Momentaufnahmen',
      create: 'Momentaufnahme erstellen',
      label: 'Bezeichnung',
      compare: 'Vergleichen',
      compareWith: 'Vergleichen mit',
      current: 'aktuellem Stand',
      download: 'Herunterladen',
      exportAll: 'Gesamtexport',
      exportXlsx: 'Excel (alle Tabellen)',
      exportJson: 'JSON (vollständig)',
      powerbi: 'Power BI',
      powerbiHint: 'Optional: CSV-Dateien für eigene Power-BI-Berichte. Ist SharePoint eingerichtet, werden sie nachts dorthin geschrieben; hier manuell. Für die Auswertungen in Projektzeit nicht nötig.',
      powerbiDownload: 'CSV-Paket erstellen',
      powerbiUpload: 'Nach SharePoint hochladen',
      result: 'Vergleich',
      protectedOk: 'Keine geschützten Daten entfernt.',
      protectedBad: '{{count}} geschützte Datensätze fehlen. Bitte sofort prüfen.',
      protectedBad_one: '{{count}} geschützter Datensatz fehlt. Bitte sofort prüfen.',
      table: 'Tabelle',
      before: 'Vorher',
      after: 'Nachher',
      added: 'neu',
      removed: 'entfernt',
      changed: 'geändert',
      entryChanges: 'Geänderte Zeiteinträge',
      monthTotals: 'Monatssummen mit Abweichung',
      kinds: {
        nightly: 'nachts',
        manual: 'manuell',
        before_change: 'vor Änderung',
      },
      protected: 'geschützt',
      size: 'Größe',
      entriesCount: 'Zeiteinträge',
    },
    audit: {
      masked: 'Inhalt nur für Berechtigte (z. B. Stunden, Vertragsdaten, Abrechnung)',
      action: 'Aktion',
      entity: 'Objekt',
      who: 'Wer',
      when: 'Wann',
      change: 'Änderung',
      shown: '{{count}} Ereignisse angezeigt',
      moreWhileScrolling: '{{count}} Ereignisse angezeigt, weitere beim Scrollen',
      partlyMasked: 'Einzelne Werte nur für Berechtigte (z. B. Honorar, Budget, Stunden, Sätze)',
    },
  },
  profile: {
    title: 'Profil',
    language: 'Sprache',
    password: 'Passwort ändern',
    current: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    changed: 'Passwort geändert',
    myExport: 'Eigene Zeiten exportieren',
    demoNote: 'In der Demo gibt es keine Anmeldung. Oben kann die Rolle gewechselt werden.',
    picture: 'Profilbild',
    pictureUpload: 'Bild hochladen',
    pictureChange: 'Bild ändern',
    pictureHint: 'JPG, PNG oder WebP. Wird quadratisch zugeschnitten und verkleinert. Sichtbar für angemeldete Kolleginnen und Kollegen.',
    themeHint: 'Hell, dunkel oder wie im Betriebssystem eingestellt.',
    access: 'Zugang',
    accessHint: 'Den Zugang richtet die Verwaltung ein. Passwort vergessen: die Verwaltung sendet einen neuen Einrichtungslink.',
  },
  auth: {
    entraMismatch: 'Dieses Microsoft-Konto passt nicht zu dem Konto, das mit dieser E-Mail verknüpft ist. Bitte die Verwaltung bitten, den Zugang zurückzusetzen.',
    title: 'Anmelden',
    email: 'E-Mail',
    password: 'Passwort',
    totp: 'Code aus der Authenticator-App',
    signIn: 'Anmelden',
    signInMicrosoft: 'Mit Microsoft anmelden',
    or: 'oder',
    setupTitle: 'Zugang einrichten',
    setupFor: 'Zugang für {{name}} ({{email}})',
    setPassword: 'Passwort festlegen',
    passwordRules: 'Mindestens 10 Zeichen, davon drei Arten: Kleinbuchstaben, Großbuchstaben, Ziffern, Sonderzeichen.',
    totpSetupTitle: 'Zweiten Faktor einrichten',
    totpSetupText: 'QR-Code mit Microsoft Authenticator oder einer anderen App scannen und den angezeigten Code eingeben.',
    totpManual: 'Schlüssel für manuelle Eingabe',
    enable: 'Aktivieren',
    entraUnknown: 'Dieses Microsoft-Konto ist in der Plattform nicht angelegt.',
    entraFailed: 'Die Microsoft-Anmeldung ist fehlgeschlagen.',
    noAccess: 'Kein Zugang oder Passwort vergessen? Die Verwaltung sendet einen Einrichtungslink.',
  },
  overview: {
    fastTask: 'Schneller als geplant: {{ref}} {{title}} (Plan {{plan}} h, Ihre Zeit {{own}} h)',
    fastCheck: 'Sehr deutlich unter Plan? Kurz prüfen, ob alle Stunden gebucht sind.',
    overPlanTitle: 'Aufgaben über Plan ({{count}})',
    overPlanHint: 'Offene Aufgaben mit mehr gebuchten als geplanten Stunden. Plan anpassen oder Ursache klären.',
    hello: 'Guten Tag, {{name}}',
    toWeek: 'Zur Woche',
    openLastWeek: 'Letzte Woche: {{count}} Einträge noch nicht eingereicht',
    openLastWeek_one: 'Letzte Woche: {{count}} Eintrag noch nicht eingereicht',
    openOlder: '{{count}} ältere Entwürfe',
    openOlder_one: '{{count}} älterer Entwurf',
    approvals: 'Warten auf Freigabe',
    approvalsL1: 'Bei der Projektleitung',
    approvalsFinal: 'Beim Büro',
    toApprovals: 'Prüfen',
    budget: 'Budget ab 80 %',
    forma: 'Hinweise aus Forma',
    formaText: 'Diese Aufgaben haben offene Buchungen, sind aber in Forma gelöscht oder nicht mehr sichtbar.',
    billing: 'Abrechnung',
    draftDocs: '{{count}} Entwürfe',
    draftDocs_one: '{{count}} Entwurf',
    unbilled: '{{hours}} h freigegeben, nicht abgerechnet',
    system: 'System',
    syncErrors: 'Forma-Abgleich: {{count}} Fehler in 24 h',
    syncErrors_one: 'Forma-Abgleich: {{count}} Fehler in 24 h',
    syncOk: 'Forma-Abgleich ohne Fehler',
    lastSnapshot: 'Letzte Momentaufnahme: {{when}}',
    mine: 'Mein Bereich',
    lead: 'Leitung',
    toCockpit: 'Zum Cockpit',
    myWeekTitle: 'Meine Woche (KW {{week}})',
    remaining: 'noch {{hours}} h bis zum Soll',
    weekFull: 'Soll dieser Woche erreicht',
    allGood: 'Alles eingereicht, keine Auffälligkeiten.',
    weekUnder: 'KW {{week}}: {{hours}} h weniger als Ihre Sollzeit. Fehlen Buchungen oder eine Abwesenheit?',
    weekOver: 'KW {{week}}: {{hours}} h über Ihrer Sollzeit (Überstunden).',
    stateHint: 'Hinweis ab {{hours}} h Abweichung je Woche. Feiertage und genehmigte Abwesenheiten mindern die Sollzeit.',
    myFigures: 'Meine Kennzahlen',
    periods: {
      month: 'Monat',
      quarter: 'Quartal',
      year: 'Jahr',
    },
    targetActual: 'Ist / Soll',
    weekStates: 'Wochen unter Soll: {{under}}, über Soll: {{over}}',
    planVsActual: 'Aufgaben: Plan und Ist',
    showLess: 'Weniger anzeigen',
    showAll: 'Alle {{count}} anzeigen',
    doneOn: 'Erledigt am',
    planTask: 'Plan (h)',
    actualTask: 'Ist gesamt (h)',
    ownHours: 'Meine Stunden (h)',
    personHours: 'davon Person (h)',
    factor: 'Faktor',
    leadQuiet: 'Keine offenen Punkte.',
    layout: {
      button: 'Anpassen',
      title: 'Startseite anpassen',
      hint: 'Blöcke ein- oder ausblenden und die Reihenfolge ändern. Die Einstellung gilt für Ihr Konto auf allen Geräten.',
      reset: 'Standard',
      up: 'Nach oben',
      down: 'Nach unten',
      tiles: 'Kacheln',
      blocks: {
        tiles: 'Kacheln',
        work: 'Meine Arbeit',
        week: 'Meine Woche',
        announcements: 'Mitteilungen',
        upcoming: 'Demnächst',
        figures: 'Meine Kennzahlen',
        lead: 'Für die Leitung',
      },
    },
  },
  demo: {
    viewAs: 'Ansicht als',
    personasHint: 'Rollen wechseln, um Rechte und Sichtbarkeit zu vergleichen.',
    filePreview: 'Vorschau der erzeugten Datei',
    downloadBlocked: 'Im Demo-Viewer sind direkte Downloads gesperrt: Die Datei wird hier angezeigt und kann über „Herunterladen“ gespeichert werden.',
    formaLink: 'In der Demo gibt es hinter den Issues kein echtes Forma-Projekt. In der installierten Plattform öffnet dieser Link das Issue in Autodesk Forma (neuer Tab).',
    download: 'Herunterladen',
    downloadSaved: 'Datei gespeichert',
    downloadFailed: 'Die Datei konnte nicht gespeichert werden. Bitte noch einmal versuchen.',
    downloadUnavailable: 'In dieser Ansicht sind Downloads nicht möglich: Die Datei wird hier nur angezeigt.',
  },
  planning: {
    title: 'Planung',
    subtitle: 'Plan-Stunden je Aufgabe und Personal je Woche. Für Projektleitung und Verwaltung.',
    noProjects: 'Keine Projekte zum Planen. Planen können Projektleitungen (ihre Projekte) und die Verwaltung.',
    chooseProject: 'Projekt wählen',
    openPlanning: 'Plan-Stunden bearbeiten',
    tabs: {
      tasks: 'Aufgaben (Plan-Stunden)',
      staff: 'Personal je Woche',
    },
    tasksInfo: 'Plan-Stunden sind die Grundlage für Plan/Ist je Aufgabe; am besten vor Arbeitsbeginn eintragen. Sie werden nur hier gepflegt, Forma liefert keine Stunden. Leer = noch kein Plan, 0 = Aufgabe wird nicht bewertet. Jede Änderung wird protokolliert.',
    onlyOpen: 'Nur offene Aufgaben',
    onlyWithoutPlan: 'Nur ohne Plan',
    planHours: 'Plan (h)',
    noPlan: 'kein Plan',
    legend: 'Eingabe in Stunden, z. B. 12 oder 12,5. Enter oder Feld verlassen speichert, Esc verwirft.',
    bulkSet: 'Plan setzen',
    bulkRemove: 'Eigenen Plan entfernen',
    bulkHint: 'Gilt für {{count}} markierte Aufgaben. 0 = nicht bewerten.',
    bulkHint_one: 'Gilt für {{count}} markierte Aufgabe. 0 = nicht bewerten.',
    bulkDone: '{{count}} Aufgaben geändert',
    bulkDone_one: '{{count}} Aufgabe geändert',
    location: 'Standort',
    subLocation: 'Unterstandort',
    site: 'Projektstandort',
    noLocation: 'kein Standort in Forma',
    filters: {
      status: 'Status',
      allStatus: 'Alle Status',
      due: 'Fälligkeit',
      dueAny: 'Alle Termine',
      dueOverdue: 'Überfällig',
      due7: 'Fällig in 7 Tagen',
      due14: 'Fällig in 14 Tagen',
      dueNone: 'Ohne Termin',
      plan: 'Plan',
      planAny: 'Alle Pläne',
      planNone: 'Ohne Plan',
      planZero: 'Nicht bewertet (0)',
      planSet: 'Mit Plan',
      booked: 'Buchungen',
      bookedAny: 'Alle',
      bookedNone: 'Ohne Buchungen',
      bookedSome: 'Mit Buchungen',
      sort: 'Sortierung',
      sortRef: 'Nummer',
      sortDue: 'Fälligkeit',
      sortBooked: 'Gebucht (meiste zuerst)',
      sortPlan: 'Plan (größte zuerst)',
      reset: 'Filter zurücksetzen',
    },
  },
  evaluation: {
    title: 'Mitarbeiterauswertung',
    subtitle: 'Kennzahlen je Person für Gespräche und Steuerung. Wer wann Zeit hat, zeigt die Auslastung.',
    noAccess: 'Nur für die Geschäftsführung (Recht „Team-Kennzahlen“).',
    signalFastTitle: 'Aufgaben deutlich unter Plan',
    signalFastText: 'Erledigte Aufgaben mit einer Plan-Ist-Quote ab {{percent}} %. Plan prüfen (zu groß?) oder die gute Lösung im Team nutzen. Der Wert gehört zur Aufgabe, nicht zur Person.',
    signalOverTitle: 'Über Sollzeit',
    signalOverText: 'Wochen mit mehr als {{hours}} h über der Sollzeit: Überstunden, Belastung ansprechen.',
    signalUnderTitle: 'Unter Sollzeit',
    signalUnderText: 'Wochen mit mehr als {{hours}} h unter der Sollzeit: fehlende Buchungen oder Abwesenheiten klären.',
    sort: 'Sortieren',
    sortBy: {
      name: 'Name',
      balance: 'Saldo (niedrigster zuerst)',
      billable: 'Anteil abrechenbar',
      flags: 'Hinweise (meiste zuerst)',
    },
    hint: 'Plan-Ist-Quote = Plan-Stunden erledigter Aufgaben / darauf gebuchte Stunden. Bei gemeinsamen Aufgaben für alle Beteiligten gleich; über die eigene Arbeit sagt nur der Wert der überwiegend allein bearbeiteten Aufgaben etwas. Aussagekräftig erst bei mehreren Aufgaben und guter Planqualität; keine Rangliste und allein keine Grundlage für Personalentscheidungen.',
    criteria: {
      title: 'Bewertungskriterien',
      intro: 'Diese Kriterien liegen der Auswertung zugrunde. Die Auswahl bestimmt nur, welche Spalten diese Ansicht zeigt (gilt für dieses Gerät); die Kennzahlen selbst bleiben unverändert.',
      show: 'Kriterien',
      all: 'Alle anzeigen',
      balance: {
        name: 'Sollzeit und Saldo',
        desc: 'Gebuchte Stunden gegen die Sollzeit aus Vertrag, Feiertagen und Abwesenheiten im gewählten Zeitraum.',
      },
      weeks: {
        name: 'Wochenhinweise',
        desc: 'Abgeschlossene Wochen mit mehr als {{hours}} h unter oder über der Sollzeit (Toleranz aus den Einstellungen).',
      },
      billable: {
        name: 'Anteil abrechenbar',
        desc: 'Abrechenbare Stunden an allen gebuchten Stunden (ohne Pauschalhonorar und nicht abrechenbar).',
      },
      projectShare: {
        name: 'Anteil Projektarbeit',
        desc: 'Anteil der Projektarbeit an den gebuchten Stunden; interne Zeiten (Weiterbildung, Akquise, Verwaltung) werden getrennt gezeigt.',
      },
      efficiency: {
        name: 'Plan-Ist-Quote',
        desc: 'Plan-Stunden erledigter Aufgaben im Verhältnis zu den gebuchten Stunden: ab {{good}} % grün, unter {{low}} % Hinweis. Der Wert gehört zur Aufgabe, keine Rangliste.',
      },
      punctuality: {
        name: 'Pünktlich eingereicht',
        desc: 'Wochen, die innerhalb der Frist ({{days}} Tag(e) nach Wochenende) eingereicht wurden.',
      },
      corrections: {
        name: 'Korrektur angefordert',
        desc: 'Anteil der Einträge, die in der Freigabe zur Korrektur zurückgegeben wurden.',
      },
      thresholds: 'Schwellen: Plan/Ist grün ab {{good}} %, Hinweis unter {{low}} %; Wochentoleranz {{hours}} h; Einreichfrist {{days}} Tag(e).',
    },
    export: {
      title: 'Exportieren',
      chosen: '{{count}} gewählte Personen:',
      chosen_one: '1 gewählte Person:',
      all: 'Alle Personen:',
      html: 'HTML (interaktiv)',
      htmlHint: 'Eine Datei, die jeder Browser ohne Konto öffnet; die Werte zeigen beim Zeigen ihre Erklärung.',
      person: 'Diese Person exportieren:',
      reportTitle: 'Mitarbeiterauswertung (vertraulich)',
      detailsLimited: 'Wochen und Projekte sind für die ersten {{count}} Personen enthalten; für weitere Personen bitte einzeln oder in kleineren Gruppen exportieren.',
    },
    selectHint: 'Personen ankreuzen, um nur sie zu exportieren; ohne Auswahl gilt der Export für alle.',
    balanceCol: 'Saldo (Ist − Soll)',
    balanceHint: 'Gebuchte Stunden minus Sollstunden im Zeitraum. Plus: mehr gebucht als Soll (Mehrarbeit), minus: weniger. Soll = Vertragsstunden abzüglich Feiertage und Abwesenheiten.',
    basis: {
      title: 'Worauf die Auswertung beruht und wie „höchster“ und „niedrigster“ Wert gemeint sind',
      data: 'Daten: die gebuchten Stunden des gewählten Zeitraums (eingereicht und freigegeben; Entwürfe zählen erst nach dem Einreichen), die Aufgaben mit Planstunden und die Freigabevorgänge.',
      target: 'Soll: Vertragsstunden je Arbeitstag, abzüglich Feiertage, Urlaub, Krankheit und andere Abwesenheiten; ab dem Erfassungsbeginn der Person.',
      balance: 'Saldo = Ist − Soll. Plus heißt mehr gebucht als Soll, minus weniger. Ein Saldo ist keine Bewertung: Mehrarbeit kann vereinbart, ein Minus durch Gleitzeit erklärt sein.',
      noScore: 'Es gibt keine Gesamtnote und keine Rangliste. Jede Spalte ist ein eigenes Kriterium; „höchster“ und „niedrigster“ Wert gelten nur innerhalb einer Spalte (Klick auf den Spaltenkopf sortiert, zweiter Klick dreht die Reihenfolge).',
      extremes: 'Auffällig sind Wochen mehr als {{hours}} h unter oder über Soll, eine Plan-Ist-Quote unter dem Zielwert und viele Zurückweisungen – immer als Anlass für ein Gespräch, nicht als Urteil.',
      context: 'Kennzahlen hängen von Planqualität, gemeinsamer Arbeit an Aufgaben und Projektrollen ab; allein sind sie keine Grundlage für Personalentscheidungen (Mitbestimmung beachten).',
    },
  },
  absencesPage: {
    title: 'Abwesenheiten und Feiertage',
    subtitle: 'Ansprüche und Salden, alle Abwesenheiten, Erfassen und Import, Überstunden für die Lohnabrechnung, Feiertage und Firmentermine. Anträge werden unter Freigaben entschieden.',
    noAccess: 'Nur für die Personalverwaltung (Abwesenheiten) und die Verwaltung (Feiertage, Firmentermine).',
    searchPerson: 'Person suchen',
  },
  areas: {
    title: 'Stunden nach Bereich',
    titleMine: 'Wofür meine Zeit verwendet wurde',
    area: 'Bereich',
    project: 'Projektarbeit',
    internal: 'Intern',
    forma: 'Forma-Aufgaben',
    hintMine: 'Bereich = Kategorie der manuellen Aufgabe (z. B. Besprechung, Baustelle) oder Forma-Aufgaben. Intern = Zeit außerhalb von Projekten, z. B. Weiterbildung, F&E, Verwaltung. Nur für Sie sichtbar.',
    hintCockpit: 'Summe aller gebuchten Stunden im Zeitraum, ohne Personenbezug.',
    hintLead: 'Summe der gebuchten Stunden in Ihren Projekten, ohne Personenbezug.',
    shareHint: 'Anteil der Stunden auf Projekten (ohne das interne Projekt)',
    internalHours: 'intern {{hours}} h',
  },
  hourTypes: {
    title: 'Stundenarten',
    type: 'Art',
    billable: 'Abrechenbar',
    included: 'Inklusive (Pauschale)',
    nonBillableProject: 'Projekt, nicht abrechenbar',
    internal: 'Intern',
    termsTitle: 'Begriffe: Plan, gebucht, abgerechnet und Stundenarten',
    coverageShort: '{{hours}} h ohne Plan',
    coverageTitle: 'Die Quote deckt {{pct}} der Stunden auf erledigten Aufgaben ab. {{hours}} h auf {{count}} erledigten Aufgaben ohne Planstunden sind nicht bewertet.',
    coverageTitle_one: 'Die Quote deckt {{pct}} der Stunden auf erledigten Aufgaben ab. {{hours}} h auf {{count}} erledigten Aufgabe ohne Planstunden sind nicht bewertet.',
    coverageNotice: 'Bei einem Teil der erledigten Aufgaben fehlen die Planstunden: Die Plan-Ist-Quote deckt im Team nur {{pct}} der Stunden auf erledigten Aufgaben ab, {{hours}} h sind nicht bewertet. Werte mit dem Hinweis „ohne Plan“ vorsichtig lesen; Planstunden in Forma oder bei den manuellen Aufgaben ergänzen.',
    coverageInfo: 'Bei einigen erledigten Aufgaben fehlen die Planstunden ({{hours}} h im Team); diese Stunden gehen nicht in die Plan-Ist-Quote ein.',
    terms: {
      plan: {
        name: 'Plan',
        desc: 'Planstunden einer Aufgabe (Forma-Feld oder Eintrag bei der manuellen Aufgabe). Nur erledigte Aufgaben mit Plan gehen in die Plan-Ist-Quote ein. Leer = nicht geplant: nicht bewertet, aber als „ohne Plan“ ausgewiesen; 0 = bewusst nicht bewerten.',
      },
      booked: {
        name: 'Gebucht (Ist)',
        desc: 'Die Stunden, die eine Person einträgt. Grundlage für Soll/Ist, Saldo, Auslastung und die Plan-Ist-Quote. Persönliche Kennzahlen verwenden nur gebuchte Stunden.',
      },
      billed: {
        name: 'Abgerechnet',
        desc: 'Die Stunden, die das Büro auf den Stundennachweis übernimmt; sie können von den gebuchten abweichen. Sie stehen in Projektanalyse und Abrechnung (gebucht gegen abgerechnet), nicht in der Bewertung einer Person.',
      },
      billable: {
        name: 'Abrechenbar',
        desc: 'Projektarbeit, die nach Stunden auf dem Kundendokument erscheint.',
      },
      included: {
        name: 'Inklusive (Pauschale)',
        desc: 'Projektarbeit, die das Pauschalhonorar abdeckt: auf dem Nachweis eines Pauschalprojekts, ohne eigene Berechnung.',
      },
      nonBillableProject: {
        name: 'Projekt, nicht abrechenbar',
        desc: 'Arbeit in einem Kundenprojekt, die nicht berechnet wird (z. B. interne Kontrolle). Sie zählt als Projektarbeit, erscheint aber nie auf einem Kundendokument. Die Art kommt aus der Aufgabe bzw. ihrer Kategorie.',
      },
      internal: {
        name: 'Intern',
        desc: 'Zeit im internen Projekt, z. B. Forschung und Entwicklung, Weiterbildung, Verwaltung: keine Projektarbeit und nie abrechenbar. Sie zählt zur Sollzeit wie jede Buchung.',
      },
      example: {
        name: 'Beispiel',
        desc: 'Aufgabe mit 20 h Plan, 5 h gebucht und erledigt, 8 h abgerechnet: Plan-Ist-Quote 400 % (deutlich unter Plan), Soll/Ist der Person +5 h, Projektanalyse 5 h gebucht und 8 h abgerechnet.',
      },
    },
  },
  scope: {
    button: 'Werte eingrenzen',
    col: 'Im Projekt',
    title: 'Werte von „{{field}}“ im Projekt',
    intro: 'Welche Werte dieses Feldes das Projekt verwendet: im ganzen Projekt, je Gebäude und je Standort aus Forma. Die Projektanalyse verwendet nur diese Werte; eine Aufgabe mit einem anderen Wert zählt dort als „ohne Angabe“ und wird aufgelistet. Die Aufgaben in Forma bleiben unverändert.',
    targets: 'Bereich',
    project: 'Ganzes Projekt',
    buildings: 'Gebäude ({{field}})',
    locations: 'Standorte aus Forma',
    all: 'alle',
    inherit: 'übernommen',
    count: '{{n}} von {{m}}',
    selectAll: 'Alle',
    selectNone: 'Keine (übernehmen)',
    reset: 'Alle Werte',
    hintProject: 'Abgewählte Werte verwendet das Projekt nicht. Alle ausgewählt = keine Einschränkung.',
    hintPlace: 'Die Werte, die dieses Gebäude bzw. dieser Standort verwendet (z. B. seine Geschosse). Ohne Auswahl gelten die Werte des übergeordneten Standorts, des Gebäudes oder des ganzen Projekts.',
    tasks: '{{count}} Aufg.',
    notOffered: 'nicht mehr in Forma',
    floorHint: 'Geschosse dieser Auswahl ohne Aufgaben erscheinen im Gebäude der Analyse leer (schraffiert), Geschosse außerhalb gar nicht.',
    saved: 'Werte gespeichert. {{count}} Aufgaben haben Werte außerhalb und werden in der Analyse aufgelistet.',
    saved_one: 'Werte gespeichert. {{count}} Aufgabe hat einen Wert außerhalb und wird in der Analyse aufgelistet.',
    savedNone: 'Werte gespeichert.',
    summaryAll: 'alle Werte',
    summaryPlaces: '+ {{count}} Gebäude/Standorte',
    summaryPlaces_one: '+ {{count}} Gebäude/Standort',
    notice: '{{count}} Aufgaben haben Werte außerhalb der Werte des Projekts: {{list}}. Sie zählen hier als „ohne Angabe“, damit kein Geschoss oder Gewerk erscheint, das es im Projekt nicht gibt. Wert in Forma korrigieren oder die Werte des Projekts anpassen.',
    notice_one: '{{count}} Aufgabe hat einen Wert außerhalb der Werte des Projekts: {{list}}. Sie zählt hier als „ohne Angabe“, damit kein Geschoss oder Gewerk erscheint, das es im Projekt nicht gibt. Wert in Forma korrigieren oder die Werte des Projekts anpassen.',
    edit: 'Werte bearbeiten',
    taskMark: 'Außerhalb der Werte des Projekts: {{list}}',
  },
  staffing: {
    title: 'Wer arbeitet wo',
    intro: 'Projekte und die Personen darin: gebuchte Stunden im Zeitraum (je dunkler, desto mehr), Projektleitung (PL) und Mitglieder ohne Stunden. Entwürfe anderer zählen nicht, das interne Projekt ist nicht enthalten.',
    introLead: 'Ihre Projekte als Projektleitung und die Personen darin: gebuchte Stunden im Zeitraum (je dunkler, desto mehr) und Mitglieder ohne Stunden. Entwürfe anderer zählen nicht.',
    period: 'Zeitraum',
    ranges: {
      '4w': 'Letzte 4 Wochen',
      '3m': 'Letzte 3 Monate',
      '12m': 'Letzte 12 Monate',
    },
    searchProject: 'Projekt suchen',
    onlyHours: 'Nur mit Stunden',
    inactive: 'Auch pausierte und abgeschlossene',
    cellHours: '{{hours}} h im Zeitraum',
    cellNoHours: 'keine Stunden im Zeitraum',
    noMember: 'nicht im Projektteam (offenes Projekt)',
    legendMember: 'Mitglied ohne Stunden',
    hint: 'Sichtbar mit dem Recht „Wer arbeitet wo“ (Standard: Mitarbeitende, Büro, technische Administration; Externe nicht). Stunden nur für Projekte, deren Stunden Sie ohnehin sehen. Farbe = Anteil an der größten Zelle; die Zahl ist immer die Stundenzahl.',
    introBoxes: 'Wer in welchem aktiven Projekt mitarbeitet: ein gefülltes Kästchen heißt „arbeitet im Projekt“, „PL“ markiert die Projektleitung. Stunden sehen nur Projektleitung (eigene Projekte), Büro und Geschäftsführung.',
    archived: 'Auch archivierte',
    archivedTag: 'archiviert',
    projectName: 'Projekt, Auftraggeber, Projektleitung',
    cellWorks: 'arbeitet im Projekt',
    legendWorks: 'arbeitet im Projekt (ohne Stunden)',
  },
  days: {
    mode: 'Art der Auswahl',
    modes: {
      range: 'Zeitraum, halber Tag, Stunden',
      days: 'Kalender',
    },
    prev: 'Vorheriger Monat',
    next: 'Nächster Monat',
    noWorkday: 'kein Arbeitstag',
    chosen: '{{count}} Tage gewählt',
    chosen_one: '{{count}} Tag gewählt',
    clear: 'Auswahl leeren',
    legendHoliday: 'Feiertag',
    legendAbsence: 'schon eingetragen',
    hint: 'Arbeitstage anklicken, auch über mehrere Monate; Umschalt+Klick wählt alle Arbeitstage zwischen zwei Tagen. Wochenenden, Feiertage und freie Tage lassen sich nicht wählen und zählen nie. Halbe Feiertage (½) einfach als ganzen Tag wählen: sie zählen als halber Urlaubstag. Halbe Urlaubstage oder Stunden an einem einzelnen Tag: „Zeitraum, halber Tag, Stunden“.',
    records: 'wird als {{count}} Einträge gespeichert',
    records_one: 'wird als {{count}} Eintrag gespeichert',
    ignored: '{{count}} gewählte Tage sind keine Arbeitstage und zählen nicht',
    ignored_one: '{{count}} gewählter Tag ist kein Arbeitstag und zählt nicht',
    halfHoliday: 'halber Feiertag: ein ganzer Urlaubstag zählt hier ½',
    holidaysOfMonth: 'Feiertage des Monats',
    halfAm: 'halber Tag, vormittags',
    halfPm: 'halber Tag, nachmittags',
  },
  holidays: {
    add: 'Feiertag hinzufügen',
    editTitle: 'Feiertag bearbeiten',
    intro: 'Alle Kalender sind vollständig bearbeitbar: Standard-Feiertage umbenennen, verschieben, auf einen halben Tag setzen oder entfernen (und wiederherstellen), eigene Tage einmalig oder jedes Jahr hinzufügen, für einen Kalender oder für alle. Bewegliche Feiertage (z. B. Ostern) werden je Jahr angepasst.',
    source: 'Herkunft',
    sources: {
      standard: 'Standard',
      changed: 'Geändert',
      custom: 'Eigener Tag',
    },
    yearly: 'jedes Jahr',
    yearlyLabel: 'Jedes Jahr an diesem Tag',
    yearlyHint: 'Gilt ab dem gewählten Jahr jedes Jahr am selben Datum (z. B. 24.12. halber Tag). Für bewegliche Feiertage nicht geeignet.',
    remove: 'Entfernen (Arbeitstag)',
    removedTitle: 'Entfernte Standard-Feiertage',
    restore: 'Wiederherstellen',
    saved: 'Feiertag gespeichert.',
    removed: '„{{name}}“ entfernt: der Tag ist jetzt ein Arbeitstag.',
    deleted: '„{{name}}“ gelöscht.',
    restored: '„{{name}}“ wiederhergestellt.',
    wasName: 'Standard: {{name}}',
    moveHint: 'Verschoben: Am {{date}} ist dann kein Feiertag mehr.',
    calendarHintStandard: 'Standard-Feiertag dieses Kalenders: Änderungen gelten für diesen Kalender.',
    person: {
      title: 'Abweichende Feiertage einzelner Personen {{year}}',
      intro: 'Für Personen, die an einem Feiertag arbeiten und dafür einen anderen Tag oder halben Tag frei haben (z. B. 29.10. gearbeitet, 27.10. und der Vormittag des 28.10. frei). Gilt nur für diese Person: Sollstunden, Urlaubstage, Teamkalender und ihr Outlook-Kalender folgen; die Person wird benachrichtigt. Kein Umweg über Überstunden nötig.',
      add: 'Abweichenden Feiertag eintragen',
      none: 'Keine abweichenden Feiertage in diesem Jahr.',
      kind: 'Art',
      kinds: {
        day: 'ganzer Tag frei',
        am: 'Vormittag frei',
        pm: 'Nachmittag frei',
        work: 'arbeitet (kein Feiertag)',
      },
      kindHints: {
        day: 'Der Tag ist für diese Person ein Feiertag.',
        am: 'Der Vormittag ist frei, der Nachmittag Arbeitszeit.',
        pm: 'Der Nachmittag ist frei, der Vormittag Arbeitszeit.',
        work: 'Der Feiertag des Kalenders gilt für diese Person nicht: Sie arbeitet regulär.',
      },
      nameHint: 'z. B. „Cumhuriyet Bayramı (verschoben)“ oder „Arbeitstag statt Feiertag“',
      calendarDay: 'Feiertag im Kalender',
      saved: 'Gespeichert; die Person wird benachrichtigt.',
    },
  },
  stepUp: {
    title: 'Zusätzliche Bestätigung',
    text: '„{{module}}“ ist zusätzlich geschützt. Bitte bestätigen Sie erneut; die Bestätigung gilt {{minutes}} Minuten.',
    password: 'Passwort',
    totp: 'Code der Authenticator-App',
    demoHint: 'Demo: Bestätigungswort „demo“.',
    confirm: 'Bestätigen und öffnen',
    unavailable: 'Für Ihr Konto ist keine Bestätigung möglich (Anmeldung nur mit Microsoft, ohne Passwort und Authenticator-App). Richten Sie im Profil die Authenticator-App ein.',
    settingsTitle: 'Zusätzliche Bestätigung',
    forBilling: 'Abrechnung nur nach erneuter Bestätigung öffnen',
    forCustomers: 'Kunden nur nach erneuter Bestätigung öffnen',
    minutes: 'Bestätigung gilt',
    minutesValue: '{{count}} Minuten',
    minutesValue_one: '{{count}} Minute',
    settingsHint: 'Ändern dürfen nur Personen mit dem Recht des Moduls, nicht die technische Administration. Jede Bestätigung und jeder Fehlversuch wird protokolliert; Fehlversuche sperren das Konto wie bei der Anmeldung.',
    limits: 'Grenzen: Die Bestätigung schützt vor fremder Nutzung einer offenen Sitzung und vor dem Zugriff über die Anwendung. Wer direkten Zugang zu Server, Datenbank oder Sicherungen hat, kann die Daten dort lesen; dagegen helfen nur Betriebsmaßnahmen (getrennte Zugänge, verschlüsselte Sicherungen, Protokollierung).',
    textFinance: 'Beträge (Stundensätze, Kosten, Umsätze, Gesamtexporte) sind zusätzlich geschützt. Bitte bestätigen Sie erneut; die Bestätigung gilt {{minutes}} Minuten.',
    lockedHelp: 'Das Konto ist nach 5 Fehlversuchen 15 Minuten gesperrt und danach automatisch wieder frei. Sofort entsperren kann die Benutzerverwaltung (Personen > Zugang > „Sperre aufheben“). Das Passwort bleibt dabei erhalten.',
    attempts: 'Fehlversuche zählen wie bei der Anmeldung: nach 5 Fehlversuchen 15 Minuten Sperre, danach automatisch frei; die Benutzerverwaltung kann sie sofort aufheben.',
    limitsTitle: 'Was die Bestätigung schützt',
    moneyLocked: 'Beträge sind ausgeblendet, bis Sie sich zusätzlich bestätigen.',
    showMoney: 'Beträge anzeigen',
    stateLocked: 'Gesperrt',
    stateOpen: 'Entsperrt bis {{time}}',
    stateHint: 'Nach Ablauf sperrt sich der Bereich von selbst; mit „Jetzt sperren“ sofort.',
    lockNow: 'Jetzt sperren',
    lockedNow: 'Gesperrt. Beim nächsten Öffnen wird erneut bestätigt.',
    mandatory: 'Die zusätzliche Bestätigung ist immer aktiv (Abrechnung, Kunden und alle Beträge). Wer kein Recht auf das Modul hat, sieht es nicht – auch nicht die technische Administration, solange Büro und Geschäftsführung das Recht nicht vergeben.',
  },
  jobs: {
    intro: 'Jede Nacht läuft die Wartung (Forma-Abgleich, wiederkehrende Einträge, Sicherung, Sollzeiten, Aufräumen); jeder Schritt wird mit Ergebnis festgehalten. Die tägliche Prüfung am Ende sucht Probleme, die im Hintergrund entstanden sind. Berichte enthalten Anzahlen und Projektnummern, keine personenbezogenen Daten.',
    kind: 'Art',
    kinds: {
      all: 'Alle Berichte',
      nightly: 'Nachtwartung',
      check: 'Prüfung (manuell)',
    },
    status: {
      ok: 'in Ordnung',
      warning: 'Hinweise',
      error: 'Fehler',
      running: 'läuft',
      skipped: 'übersprungen',
    },
    started: 'Beginn',
    steps: 'Schritte',
    step: 'Schritt',
    duration: 'Dauer',
    findings: 'Befunde',
    result: 'Ergebnis',
    failedCount: '{{count}} fehlgeschlagen',
    noFindings: 'keine',
    noFindingsLong: 'Keine Probleme gefunden.',
    checkNow: 'Jetzt prüfen',
    checked: 'Prüfung abgeschlossen: {{count}} Befunde.',
    checked_one: 'Prüfung abgeschlossen: {{count}} Befund.',
    exportList: 'Liste als Excel',
    exportOne: 'Bericht als Excel',
    latestProblem: 'Letzter Bericht ({{date}}): {{errors}} Fehler, {{warnings}} Hinweise.',
    open: 'Öffnen',
    none: 'Noch keine Berichte. Der erste entsteht in der nächsten Nacht oder mit „Jetzt prüfen“.',
    report: 'Bericht',
    reportTitle: '{{kind}} vom {{date}}',
    summary: '{{steps}} Schritte, {{errors}} Fehler, {{warnings}} Hinweise',
    lookAt: 'Ansehen',
    codes: {
      step_failed: {
        short: 'Schritt fehlgeschlagen',
        text: '{{step}}: {{error}}',
      },
      forma_errors: {
        short: 'Forma-Fehler',
        text: 'Synchronisation mit Fehlern in {{count}} Projekten: {{projects}}.',
      },
      forma_warnings: {
        short: 'Forma-Hinweise',
        text: 'Synchronisation mit Hinweisen in {{count}} Projekten: {{projects}}.',
      },
      forma_lost_projects: {
        short: 'Forma-Verbindung verloren',
        text: '{{count}} aktive Projekte ohne Forma-Zugriff oder in Forma gelöscht: {{projects}}.',
      },
      hours_on_lost_tasks: {
        short: 'Stunden auf gelöschten Forma-Aufgaben',
        text: '{{entries}} nicht abgerechnete Einträge auf {{count}} Aufgaben, die in Forma gelöscht oder nicht mehr erreichbar sind.',
      },
      outlook_errors: {
        short: 'Outlook-Termine fehlgeschlagen',
        text: '{{count}} Termine konnten nicht geschrieben werden (Berechtigung des Postfachs prüfen).',
      },
      backup_missing: {
        short: 'Sicherung fehlt',
        text: 'Keine Sicherung in den letzten 36 Stunden (letzte: {{last}}).',
      },
      months_open: {
        short: 'Monate offen',
        text: '{{count}} vergangene Monate sind nicht abgeschlossen ({{months}}).',
      },
      approvals_waiting: {
        short: 'Freigaben warten',
        text: '{{count}} Einträge warten seit mehr als {{days}} Tagen auf Freigabe.',
      },
      long_days: {
        short: 'Ungewöhnlich lange Tage',
        text: '{{count}} Tage mit mehr als 16 gebuchten Stunden einer Person (letzte 60 Tage).',
      },
      forma_idle: {
        short: 'Forma-Abgleich ruht',
        text: 'Seit über einem Tag keine Synchronisation (letzte: {{last}}).',
      },
    },
    stepNames: {
      'forma-auto-import': 'Neue Forma-Projekte übernehmen',
      'forma-full-sync': 'Forma vollständig abgleichen',
      'recurring-entries': 'Wiederkehrende Einträge',
      snapshot: 'Sicherung',
      'snapshot-retention': 'Alte Sicherungen entfernen',
      'capacity-cache': 'Sollzeiten berechnen',
      'documents-retention': 'Nachweise nach Frist löschen',
      'powerbi-export': 'Power-BI-Export',
      'sessions-cleanup': 'Abgelaufene Sitzungen entfernen',
      'daily-check': 'Tägliche Prüfung',
    },
  },
  leave: {
    bookedWarning: 'In diesem Zeitraum sind bereits {{hours}} h gebucht. Stimmt der Zeitraum? Nach der Genehmigung zählen die Buchungen zusätzlich.',
    cut: {
      text: 'An diesen Tagen ist Urlaub eingetragen. Krankheitstage mit Attest zählen nicht als Urlaub (§ 9 BUrlG; Türkei: İş Kanunu Art. 56, Yıllık Ücretli İzin Yönetmeliği Art. 6): Der Urlaub wird um diese Tage gekürzt, {{days}} Urlaubstage gehen zurück; der Urlaub verlängert sich nicht.',
      confirm: 'Urlaub kürzen und {{days}} Urlaubstage gutschreiben',
      self: 'An diesen Tagen ist Urlaub eingetragen. Bitte melden Sie die Erkrankung mit Attest bzw. Arbeitsunfähigkeitsbescheinigung der Personalabteilung: Sie trägt die Krankheit ein und schreibt die Urlaubstage gut.',
    },
    bookedInPeriod: 'Bereits {{hours}} h gebucht im Zeitraum',
    compInfo: 'Freizeitausgleich wird genehmigt wie Urlaub. Der Tag bleibt Teil der Sollzeit und wird nicht gebucht; so sinken die Überstunden.',
    overtimeAfter: 'Überstunden danach: {{hours}} h',
    overtimeShort: 'Überstunden',
    overtime: {
      title: 'Überstunden und Freizeitausgleich',
      earned: 'Saldo laut Buchungen',
      adjusted: 'Ausgezahlt / korrigiert',
      planned: 'Freizeitausgleich geplant',
      requested: 'Freizeitausgleich beantragt',
      available: 'Verfügbar',
      hint: 'Seit {{since}}, Stand gestern: gebuchte Stunden minus Sollzeit. Arbeit am Wochenende, an Feiertagen, an Abwesenheitstagen und Stunden über dem Soll erhöhen den Saldo; Freizeitausgleich und Auszahlungen senken ihn. Auszahlungen und Korrekturen trägt die Personalverwaltung ein. Richtwert aus den Projektbuchungen, kein Arbeitszeitkonto.',
    },
    carryoverHint: 'Ein nicht genommener Rest wird nicht automatisch gestrichen. Nach Ablauf passt die Personalverwaltung den Rest an; ob er verfällt, hängt unter anderem davon ab, ob rechtzeitig auf den drohenden Verfall hingewiesen wurde.',
    title: 'Meine Abwesenheiten',
    subtitle: 'Urlaub und andere Abwesenheiten beantragen, Krankmeldung mit Bescheinigung eintragen, Anspruch und Anträge im Blick.',
    request: 'Abwesenheit beantragen',
    sickNote: 'Krankmeldung',
    requestTitle: 'Abwesenheit beantragen',
    sickTitle: 'Krankmeldung eintragen',
    hrTitle: 'Abwesenheit erfassen',
    person: 'Person',
    kind: 'Art',
    extent: 'Umfang',
    modes: {
      full: 'Ganze Tage',
      half: 'Halber Tag',
      hours: 'Stunden',
    },
    parts: {
      am: 'Vormittag',
      pm: 'Nachmittag',
    },
    hours: 'Stunden',
    startTime: 'Beginn',
    note: 'Bemerkung',
    noteHint: 'Optional, z. B. Anlass. Keine Diagnosen eintragen.',
    preview: 'Arbeitstage: {{days}} ({{hours}} h)',
    previewHours: '{{hours}} h',
    previewDays: 'Arbeitstage: {{days}}',
    balanceAfter: 'Danach verfügbar: {{value}} {{unit}}',
    balanceAfterYear: 'Danach verfügbar ({{year}}): {{value}} {{unit}}',
    overlap: 'An diesen Tagen gibt es schon eine Abwesenheit.',
    needsApproval: 'Der Antrag wird genehmigt oder abgelehnt; bis dahin mindert er die Sollzeit nicht.',
    submit: 'Beantragen',
    save: 'Eintragen',
    requested: 'Antrag gestellt',
    recorded: 'Eingetragen',
    withdraw: 'Zurückziehen',
    cancel: 'Stornieren',
    withdrawn: 'Zurückgezogen',
    status: {
      requested: 'Beantragt',
      approved: 'Genehmigt',
      rejected: 'Änderung angefordert',
      cancelled: 'Storniert',
    },
    balance: {
      entitlement: 'Anspruch {{year}}',
      carryover: 'Rest Vorjahr',
      carryoverUntil: 'zu nehmen bis {{date}}',
      taken: 'Genommen',
      planned: 'Geplant',
      requested: 'Beantragt',
      available: 'Verfügbar',
      none: 'Für dieses Jahr ist noch kein Urlaubsanspruch erfasst (Personalverwaltung).',
    },
    units: {
      days: 'Tage',
      hours: 'Std.',
    },
    empty: 'Keine Abwesenheiten in diesem Jahr.',
    outlookNote: 'Genehmigte Abwesenheiten erscheinen automatisch in Ihrem Outlook-Kalender mit dem Status „Abwesend“.',
    decidedBy: 'entschieden von {{name}}',
    period: 'Zeitraum',
    state: 'Status',
    approve: 'Genehmigen',
    reject: 'Änderung anfordern',
    rejectTitle: 'Änderung anfordern',
    rejectReason: 'Was soll geändert werden? (die Person sieht den Hinweis)',
    approvedMany: '{{count}} genehmigt',
    rejectedMany: '{{count}} Änderungsanfragen gesendet',
    undone: '{{count}} Entscheidungen zurückgenommen',
    undone_one: '{{count}} Entscheidung zurückgenommen',
    queueEmpty: 'Keine offenen Anträge.',
    own: 'Eigener Antrag: entscheidet eine andere Person mit dem Recht Personal',
    restAfter: 'Rest danach',
    alsoAbsent: 'Gleicher Fachbereich abwesend: {{names}}',
    requestedAt: 'Gestellt',
    entitlement: 'Anspruch',
    editEntitlement: 'Anspruch bearbeiten',
    unit: 'Einheit',
    amount: 'Anspruch im Jahr',
    carryover: 'Rest aus dem Vorjahr',
    carryoverUntil: 'Rest zu nehmen bis',
    sickDays: 'Krank (Arbeitstage)',
    allTab: 'Alle Abwesenheiten',
    overviewTab: 'Ansprüche und Salden',
    eventsTab: 'Firmentermine',
    holidaysTab: 'Feiertage',
    cancelTitle: 'Abwesenheit stornieren',
    cancelReason: 'Begründung',
    statusFilter: 'Status',
    allStatuses: 'Alle',
    hrInfo: 'Von der Personalverwaltung erfasste Abwesenheiten gelten sofort als genehmigt.',
    importHint: 'CSV mit den Spalten email;kind;from;to;halfDay;externalRef. Arten: vacation, special, training, overtime, unpaid, sick, child_sick, parental, other. Gleiche externalRef aktualisiert den Eintrag.',
    events: {
      new: 'Termin anlegen',
      name: 'Bezeichnung',
      country: 'Standort',
      allCountries: 'Alle Standorte',
      hint: 'Im Teamkalender, auf der Startseite und – mit Teilnehmenden – in deren Outlook-Kalender. Arbeitsfreie Tage für alle (z. B. Betriebsruhe) unter „Feiertage“ als ganzer oder halber Tag eintragen, dann mindern sie die Sollzeit; ein Firmentermin (z. B. Baustellenbegehung) ist Arbeitszeit und mindert sie nicht.',
      edit: 'Termin bearbeiten',
      part: 'Dauer',
      partHint: 'Halbe Tage und Uhrzeiten nur an einem einzelnen Tag.',
      parts: {
        full: 'ganztägig',
        time: 'Uhrzeit',
      },
      start: 'Beginn',
      end: 'Ende',
      notePlaceholder: 'z. B. Treffpunkt, Schutzausrüstung, Ansprechpartner',
      participants: 'Teilnehmende',
      participantsCount: '{{count}} Teilnehmende',
      participantsCount_one: '{{count}} Teilnehmende/r',
      everybody: 'für alle',
      searchPerson: 'Person suchen',
      participantsHint: 'Ohne Auswahl gilt der Termin für alle (des Standorts). Mit Auswahl sehen die Teilnehmenden ihn in ihrer Zeile im Teamkalender, auf der Startseite und – wenn die Outlook-Anbindung eingeschaltet ist – als Termin „gebucht“ in ihrem Outlook-Kalender (ohne Einladung).',
      deleted: 'Termin „{{title}}“ gelöscht.',
    },
    profileBirthday: 'Geburtstag (Tag und Monat)',
    profileShowBirthday: 'Im Teamkalender zeigen',
    profileBirthdayHint: 'Freiwillig. Das Jahr wird nicht gespeichert.',
    decidedByHr: 'Entscheidet: Personalverwaltung.',
    decidedByName: 'Entscheidet: {{name}}.',
    sickInfo: 'Die Krankmeldung zählt sofort: Sollzeit, Teamkalender (nur „abwesend“) und Outlook. Die Personalverwaltung bestätigt sie.',
    restAfterHint: 'Bei Urlaub der verbleibende Anspruch, bei Freizeitausgleich die Überstunden, jeweils nach diesem und allen anderen offenen Anträgen der Person.',
    sickRecorded: 'Krankmeldung eingetragen; die Personalverwaltung bestätigt sie.',
    resubmit: 'Anpassen und erneut senden',
    changeNote: 'Hinweis zur Änderung',
    changeHint: 'Die Tage sind wieder frei. Bitte den Antrag anpassen und erneut senden.',
    resubmitted: 'Neu gesendet',
    noOvertimeAccount: 'Für Sie wird kein Überstundenkonto geführt; Freizeitausgleich ist daher nicht vorgesehen.',
  },
  team: {
    leadHint: 'Farbig hervorgehoben: Projekte, die die Person leitet.',
    legendEvent: 'Firmentermin (Teilnahme)',
    title: 'Team',
    subtitle: 'Wer ist wann da: Abwesenheiten, Feiertage des Standorts, Firmentermine und die Projekte jeder Person. Stunden und Aufgaben sieht hier niemand.',
    today: 'Heute',
    until: '{{label}} bis {{date}}',
    present: 'Da',
    projects: 'Projekte',
    noProjects: 'Kein Projekt',
    lead: 'Leitung',
    birthday: 'Geburtstag',
    events: 'Firmentermine',
    country: 'Standort',
    all: 'Alle',
    discipline: 'Fachbereich',
    search: 'Name suchen',
    legendAbsent: 'Abwesend',
    legendHoliday: 'Feiertag',
    legendFree: 'Kein Arbeitstag',
    people: 'Personen',
    calendar: 'Kalender',
    mail: 'E-Mail schreiben',
    privacy: 'Krankheit und andere persönliche Gründe erscheinen nur als „abwesend“.',
  },
  overtime: {
    tab: 'Überstunden',
    intro: 'Überstunden je Monat für die Lohnabrechnung: wo die Stunden über dem Soll entstanden sind, was als Freizeitausgleich genommen und was ausgezahlt wurde. Eine Auszahlung (mit dem Lohn eines Monats) oder eine Korrektur senkt oder erhöht den Saldo sofort, wird protokolliert und ist für die Person in „Meine Abwesenheiten“ sichtbar. Grundlage sind die Projektbuchungen; für die Abrechnung den Monat erst nach dem Monatsabschluss verwenden.',
    month: 'Monat',
    closed: 'Monat abgeschlossen',
    open: 'Monat noch offen: Werte können sich ändern',
    excel: 'Excel für die Lohnabrechnung',
    empty: 'Keine Mitarbeitenden mit Arbeitszeitvertrag in diesem Monat.',
    adjust: 'Auszahlung oder Korrektur',
    adjustTitle: 'Überstunden: {{name}}',
    kind: 'Art',
    kinds: {
      payout: 'Auszahlung',
      correction: 'Korrektur',
    },
    hours: 'Stunden',
    sign: 'Vorzeichen',
    payoutHint: 'Monat der Lohnabrechnung, mit der die Stunden bezahlt werden.',
    correctionHint: 'Z. B. Saldo aus der Zeit vor Projektzeit oder eine Vereinbarung. Begründung ist Pflicht.',
    balanceNow: 'Saldo heute',
    balanceParts: 'Buchungen {{earned}} h, ausgezahlt/korrigiert {{adjusted}} h, Freizeitausgleich geplant {{planned}} h',
    history: 'Auszahlungen und Korrekturen',
    none: 'Noch keine Auszahlungen oder Korrekturen.',
    payrollMonth: 'Lohn {{month}}',
    removeTitle: 'Auszahlung oder Korrektur löschen',
    openEntries: '{{count}} Einträge nicht freigegeben',
    openEntries_one: '{{count}} Eintrag nicht freigegeben',
    reset: {
      button: 'Saldo zurücksetzen',
      title: 'Saldo zurücksetzen: {{name}}',
      question: 'Sind Sie sicher? Der Überstundensaldo von {{name}} (heute {{hours}} h) wird auf 0 gesetzt: Überstunden, Soll/Ist und die Hinweise auf fehlende Buchungen zählen ab {{date}}.',
      confirm: 'Ja, Saldo zurücksetzen',
      date: 'Zählt ab',
      dateHint: 'Meist heute, oder der Tag, ab dem die Person vollständig bucht. Nicht in der Zukunft.',
      notePlaceholder: 'z. B. Einführungsphase, Start mit Projektzeit am …',
      keeps: 'Die gebuchten Stunden und Einträge bleiben unverändert. Auszahlungen und Korrekturen vor dem Tag zählen nicht mehr. Die Person erhält eine Benachrichtigung mit den ausgebuchten Stunden; die Änderung wird protokolliert und lässt sich zurücknehmen.',
      done: 'Saldo von {{name}} zurückgesetzt ({{hours}} h ausgebucht).',
      undoNote: 'Zurücksetzen rückgängig gemacht',
      since: 'Erfassung ab {{date}}',
      countsFrom: 'Überstunden zählen ab {{date}}.',
    },
    cols: {
      target: 'Soll',
      booked: 'Gebucht',
      difference: 'Differenz',
      daysOff: 'Freie Tage',
      daysOffHint: 'Wochenende und andere arbeitsfreie Tage des Vertrags',
      holiday: 'Feiertage',
      absenceDay: 'Abwesenheitstage',
      workdayExtra: 'Über Soll',
      compensation: 'Freizeitausgleich',
      paidOut: 'Ausgezahlt',
      balance: 'Saldo heute',
      balanceHint: 'Alle Monate seit Erfassungsbeginn, nach Auszahlungen und geplantem Freizeitausgleich',
      rate: 'Überstundensatz',
      paidOutValue: 'Wert ausgezahlt',
    },
  },
  errors: {
    ABSENCE_OVERLAP: 'Für diese Tage gibt es schon eine beantragte oder genehmigte Abwesenheit.',
    SICK_DURING_LEAVE: 'An diesen Tagen ist Urlaub eingetragen. Eine Krankheit im Urlaub trägt die Personalabteilung mit Attest ein; die Urlaubstage werden gutgeschrieben.',
    STEP_UP_REQUIRED: 'Bitte bestätigen Sie erneut, um diesen Bereich zu öffnen.',
    STEP_UP_UNAVAILABLE: 'Für Ihr Konto ist keine Bestätigung möglich; richten Sie die Authenticator-App ein.',
    ABSENCE_PAST_MIDNIGHT: 'Eine Abwesenheit von einigen Stunden endet am selben Tag (spätestens 24:00). Bitte Beginn oder Dauer anpassen.',
    ATTACHMENT_TYPE: 'Dieser Dateityp wird nicht angenommen. Erlaubt sind PDF, JPG, PNG, WEBP und HEIC; der Inhalt muss zum Dateityp passen.',
    ATTACHMENT_SIZE: 'Die Datei ist leer oder größer als 10 MB.',
    ATTACHMENT_COUNT: 'Zu dieser Abwesenheit gibt es schon 5 Nachweise. Bitte zuerst einen entfernen.',
    reasons: {
      NOT_EDIT_FILE: 'Die Datei ist keine Bearbeitungsdatei von Projektzeit.',
      OTHER_DOCUMENT: 'Die Datei gehört zu einem anderen Dokument.',
      FILE_LIMIT: 'Die Datei ist für eine Bearbeitungsdatei zu groß (entpackt über 24 MB oder mehr als 20.000 Zeilen).',
      PREVIEW_CHANGED: 'Die Systemdaten haben sich seit der Vorschau geändert.',
      NUMBER_TAKEN: 'Diese Nummer trägt im Projekt schon eine andere manuelle Aufgabe.',
      TASK_IN_USE: 'Die Aufgabe hat Stunden in einem abgeschlossenen Monat oder auf einer Abrechnung; sie lässt sich nur ausblenden.',
      TASK_APPROVED_HOURS: 'Auf der Aufgabe sind freigegebene Stunden; löschen darf nur, wer Einträge korrigieren darf.',
      TASK_HAS_HOURS: 'Auf der Aufgabe sind Stunden gebucht; sie wird nicht gelöscht, sondern ausgeblendet.',
      TASK_DELETED: 'Die Aufgabe wurde gelöscht; ihre Einträge lassen sich nicht wiederherstellen.',
    },
    IMPORT_UNKNOWN_EMAIL: 'unbekannte E-Mail {{email}}',
    IMPORT_INVALID_DATES: 'ungültige Daten (Format JJJJ-MM-TT, Beginn nicht nach Ende)',
    IMPORT_ABSENCE_OVERLAP: 'überschneidet sich mit einer beantragten oder genehmigten Abwesenheit',
    IMPORT_PERIOD_LOCKED: 'liegt in einem abgeschlossenen Monat',
    IMPORT_SELF_APPROVAL: 'eigene Abwesenheit: bitte als Antrag stellen, eine andere Person entscheidet',
    NO_WORKDAY: 'Im gewählten Zeitraum liegt kein Arbeitstag (Wochenende, Feiertag oder freier Tag).',
    PROTECTED_ACCOUNT: 'Geschützte Rechte (Freigaben, Abrechnung, Sätze, Personal, Team-Kennzahlen, Auslastung, Gesamtexport) vergibt und ändert nur, wer sie selbst hat. Das gilt auch für Rolle, Zugang, E-Mail und Aktivierung solcher Konten.',
    SELF_BILLING: 'Abzurechnende Stunden eigener Einträge ändert eine andere Person mit dem Recht Abrechnung.',
    UNDO_NOT_POSSIBLE: 'Rückgängig ist nicht mehr möglich: der Eintrag wurde inzwischen weiterbearbeitet.',
    UNAUTHENTICATED: 'Bitte neu anmelden.',
    MFA_REQUIRED: 'Zweiter Faktor erforderlich.',
    FORBIDDEN: 'Dafür fehlen die Rechte.',
    NOT_FOUND: 'Nicht gefunden.',
    VALIDATION: 'Eingaben prüfen.',
    CONFLICT: 'Inzwischen von jemand anderem geändert. Bitte neu laden.',
    PERIOD_LOCKED: 'Der Monat ist abgeschlossen.',
    ENTRY_BILLED: 'Bereits abgerechnet. Änderung nur nach Storno des Stundennachweises.',
    ENTRY_APPROVED: 'Bereits freigegeben. Änderungen nur durch Projektleitung oder Büro.',
    ENTRY_DELETED: 'Der Eintrag ist gelöscht.',
    SELF_APPROVAL: 'Über eigene Zeiten und eigene Anträge entscheidet eine andere Person.',
    WRONG_STATUS: 'In diesem Status nicht möglich.',
    REASON_REQUIRED: 'Bitte eine Begründung angeben.',
    NOT_BOOKABLE: 'Auf diese Aufgabe kann nicht gebucht werden.',
    DESCRIPTION_REQUIRED: 'Bitte die Tätigkeit beschreiben.',
    FUTURE_DATE: 'So weit in die Zukunft kann nicht gebucht werden.',
    STEP_MINUTES: 'Stunden bitte im eingestellten Raster erfassen.',
    LAST_ADMIN: 'Der letzte Administrator kann nicht entfernt werden.',
    FORMA_ERROR: 'Forma hat einen Fehler gemeldet.',
    FORMA_NOT_CONNECTED: 'Forma ist nicht verbunden.',
    INTERNAL: 'Unerwarteter Fehler. Bitte erneut versuchen.',
    NETWORK: 'Keine Verbindung zum Server.',
    CSRF: 'Anfrage abgelehnt.',
    INVALID_CREDENTIALS: 'E-Mail oder Passwort falsch.',
    INVALID_TOTP: 'Code ungültig.',
    TOTP_SETUP_EXPIRED: 'Die Einrichtung ist abgelaufen. Bitte neu starten und den neuen Code eingeben.',
    ACCOUNT_LOCKED: 'Zu viele Versuche. Konto für 15 Minuten gesperrt.',
    SETUP_INVALID: 'Der Einrichtungslink ist ungültig oder abgelaufen.',
    PASSWORD_TOO_SHORT: 'Passwort zu kurz.',
    PASSWORD_TOO_WEAK: 'Passwort zu einfach.',
    PASSWORD_TOO_LONG: 'Passwort zu lang.',
    bookability: {
      PROJECT_ARCHIVED: 'Das Projekt ist archiviert.',
      TASK_ARCHIVED: 'Die Aufgabe ist ausgeblendet.',
      NOT_MEMBER: 'Keine Zuordnung zu diesem Projekt.',
      TASK_NOT_ASSIGNED: 'Diese Aufgabe ist nicht zugewiesen.',
      PERSON_INACTIVE: 'Die Person ist deaktiviert.',
      PROJECT_NO_FORMA: 'Das Projekt hat keine aktive Forma-Verbindung und ist nicht zum Buchen freigegeben.',
      TASK_DRAFT: 'Die Aufgabe ist in Forma noch ein Entwurf. Auf Entwürfe wird nicht gebucht; sobald sie in Forma veröffentlicht ist, kann gebucht werden.',
    },
    shortCodeTaken: 'Dieses Kürzel ist schon vergeben. Bitte ein anderes wählen oder „Aus dem Namen vorschlagen“ benutzen.',
    shortCodeInvalid: 'Das Kürzel besteht aus 2 bis 6 Buchstaben oder Ziffern.',
    NO_OVERTIME_ACCOUNT: 'Für diese Person gibt es kein Überstundenkonto (Mehrarbeit wird mit dem Gehalt abgegolten). Freizeitausgleich ist daher nicht möglich.',
    BUSY: 'Gerade läuft schon ein großer Export, eine Sicherung oder ein Vergleich. Bitte in ein bis zwei Minuten noch einmal versuchen.',
  },
  picker: {
    source: 'Quelle',
    sources: {
      all: 'Alle',
      forma: 'Forma',
      manual: 'Manuell',
    },
    allProjects: 'Alle Projekte',
    counts: '{{forma}} Forma, {{manual}} manuell',
    location: 'Standort',
    allLocations: 'Alle Standorte',
    subLocation: 'Unterstandort',
    allSubLocations: 'Alle Unterstandorte',
    noSubLocations: 'Keine Unterstandorte',
    allCategories: 'Alle Kategorien',
    plan: 'Plan {{hours}} h',
    more: 'Weitere Treffer: Filter oder Suche eingrenzen.',
  },
  cockpit: {
    title: 'Cockpit',
    subtitleAll: 'Alle Projekte auf einen Blick. Details im Projekt; Plan-Stunden und Personal unter Planung.',
    subtitleLead: 'Die Projekte, die ich leite. Details im Projekt; Plan-Stunden und Personal unter Planung.',
    noAccess: 'Das Cockpit sehen Projektleitung, Büro und Geschäftsführung.',
    tabs: {
      overview: 'Überblick',
      projects: 'Projekte',
    },
    ranges: {
      thisMonth: 'Dieser Monat',
      lastMonth: 'Letzter Monat',
      year: 'Dieses Jahr',
      last4w: 'Letzte 4 Wochen',
      last3m: 'Letzte 3 Monate',
      last12m: 'Letzte 12 Monate',
      thisWeek: 'Diese Woche',
    },
    booked: 'Gebucht',
    activeProjects: 'Projekte mit Buchungen',
    persons: 'Personen mit Buchungen',
    approvalsPending: 'Freigaben offen',
    budgetAlerts: 'Budget ab 80 %',
    overPlan: 'Aufgaben über Plan',
    unbilled: 'Noch nicht abgerechnet (h)',
    hoursByProject: 'Stunden je Projekt',
    budgetUsedShort: 'Budget {{value}} verbraucht',
    otherProjects: '{{count}} weitere Projekte',
    otherProjects_one: '{{count}} weiteres Projekt',
    alerts: 'Hinweise',
    noAlerts: 'Keine Projekte mit Budget ab 80 % oder Aufgaben über Plan.',
    budgetNote: '{{booked}} von {{budget}} h',
    overPlanNote: '{{count}} Aufgaben über Plan',
    overPlanNote_one: '{{count}} Aufgabe über Plan',
    weekly: 'Wochenverlauf aller Projekte',
    sort: 'Sortieren',
    sorts: {
      period: 'Stunden im Zeitraum',
      total: 'Stunden gesamt',
      budget: 'Budgetverbrauch',
      overPlan: 'Aufgaben über Plan',
      number: 'Projektnummer',
    },
    colPeriod: 'Zeitraum (h)',
    colTotal: 'Gesamt (h)',
    colPlanTasks: 'Aufgaben mit Plan',
    colDone: 'Erledigt: Plan / Ist',
    colDoneHint: 'Abgeschlossene Aufgaben mit Plan: Summe Plan / Summe gebucht',
    colInvoiced: 'Abgerechnet / erfasst',
    overPlanShort: '{{count}} über Plan',
    projectsHint: 'Budget und Planwerte gelten für die gesamte Laufzeit, die Stunden für den gewählten Zeitraum. Abgerechnet / erfasst: abgerechnete Stunden im Verhältnis zu den erfassten Stunden derselben Einträge.',
    teamEfficiencyHint: 'Plan-Anteil / gebuchte Stunden aller bewerteten Aufgaben',
    weekFlags: 'Wochen unter / über Soll',
    weekFlagsHint: 'Abweichung über {{hours}} h je Woche',
    weekFlagsCol: 'Wochenhinweise',
    noFlags: 'unauffällig ({{count}} Wochen)',
    noFlags_one: 'unauffällig ({{count}} Woche)',
    tasksCount: '{{count}} Aufgaben',
    tasksCount_one: '{{count}} Aufgabe',
    personTitle: 'Kennzahlen: {{name}}',
    saved: 'Gegenüber Plan',
    savedHint: 'Plan-Anteil minus gebuchte Stunden (positiv = schneller)',
    toAnalysis: 'Projektanalyse',
    searchProject: 'Projekt suchen (Nummer oder Name)',
  },
  projectKpi: {
    tasksWithPlan: 'Aufgaben mit Plan',
    planHours: 'Plan {{plan}} h, gebucht {{booked}} h',
    done: 'Erledigte Aufgaben: Plan / Ist',
    doneHint: '{{count}} Aufgaben: Plan {{plan}} h, gebucht {{booked}} h',
    doneHint_one: '{{count}} Aufgabe: Plan {{plan}} h, gebucht {{booked}} h',
    overPlan: 'Offene Aufgaben über Plan',
    invoicedFactor: 'Abgerechnet / erfasst',
    invoicedHint: '{{invoiced}} h abgerechnet für {{recorded}} h erfasst',
    noInvoiced: 'Noch nichts abgerechnet.',
    overPlanList: 'Offene Aufgaben über Plan',
    noOverPlan: 'Keine offene Aufgabe über Plan.',
    plan: 'Plan (h)',
    onlyOverPlan: 'Nur über Plan',
    notEvaluated: 'nicht bewertet',
    planHoursLabel: 'Plan (Stunden)',
  },
  categories: {
    hint: 'Kategorien für manuelle Aufgaben (M-Nummern). Die Gruppe „Intern“ sind Gemeinkosten und werden nie abgerechnet. Nicht mehr benötigte Kategorien deaktivieren statt löschen, damit bestehende Aufgaben ihre Zuordnung behalten.',
    new: 'Kategorie anlegen',
    edit: 'Kategorie bearbeiten',
    createInternal: 'Interne Aufgaben anlegen',
    internalCreated: '{{count}} Aufgaben im Projekt {{project}} angelegt',
    internalCreated_one: '{{count}} Aufgabe im Projekt {{project}} angelegt',
    internalNone: 'Für alle internen Kategorien gibt es schon eine Aufgabe.',
    translations: 'Englisch · Türkisch',
    tasks: 'Aufgaben',
    fixed: 'fest',
    nameDe: 'Name (Deutsch)',
    nameEn: 'Name (Englisch)',
    nameTr: 'Name (Türkisch)',
    group: 'Gruppe',
    groups: {
      projekt: 'Projektbezogen',
      intern: 'Intern (Gemeinkosten)',
    },
    sort: 'Reihenfolge',
    fixedLabel: 'Abrechnungsart fest vorgeben',
    fixedHint: 'Buchungen können die Abrechnungsart dann nicht ändern.',
    activeLabel: 'Aktiv',
    activeHint: 'Inaktive Kategorien sind für neue Aufgaben nicht wählbar.',
    noOvertime: 'keine Überstunden',
    noOvertimeLabel: 'Zählt nicht als Überstunden',
    noOvertimeHint: 'Stunden auf Aufgaben dieser Kategorie zählen nicht für das Überstundenkonto (z. B. freiwillige Weiterbildung). Wirkt nur, wenn die Einstellung eingeschaltet ist.',
    noOvertimeRetro: 'Die Änderung gilt auch rückwirkend für bereits gebuchte Stunden dieser Kategorie und ändert damit Überstundensalden.',
  },
  analysis: {
    title: 'Projektanalyse',
    subtitle: 'Stand aller Projekte: Fortschritt, Terminlage und Stunden gegen Plan. Ein Projekt öffnen für Gebäude, Geschosse, Gewerke, Zeitplan und Team.',
    backToPortfolio: 'Zur Übersicht aller Projekte',
    period: 'Zeitraum',
    periodHint: 'Der Zeitraum gilt für Stunden und Kosten. Fortschritt und Terminlage zeigen immer den heutigen Stand.',
    periods: {
      all: 'Gesamte Laufzeit',
      year: 'Dieses Jahr',
      last12w: 'Letzte 12 Wochen',
      last4w: 'Letzte 4 Wochen',
      month: 'Dieser Monat',
      lastMonth: 'Letzter Monat',
      week: 'Diese Woche',
      custom: 'Eigener Zeitraum',
    },
    includeInactive: 'Pausierte und abgeschlossene Projekte zeigen',
    excel: 'Excel',
    pdf: 'PDF-Bericht',
    noProjects: 'Keine Projekte in Ihrem Zugriff.',
    search: 'Projekt, Nummer oder Auftraggeber suchen',
    shownOf: '{{shown}} von {{total}} Projekten',
    more: 'Weitere anzeigen',
    overdueAll: 'Überfällige Aufgaben aller Projekte',
    noOverdue: 'Keine überfälligen Aufgaben.',
    dueOn: 'fällig {{date}}',
    daysLate: '{{count}} Tage überfällig',
    daysLate_one: '{{count}} Tag überfällig',
    definitions: 'Fortschritt: erledigte (abgeschlossene) Aufgaben / alle Aufgaben, oder nach Planstunden (Einstellung je Projekt). Terminlage: Verzug, wenn mindestens 3 oder ein Fünftel der offenen Aufgaben mit Termin überfällig sind; Risiko bei einer überfälligen oder bald fälligen, noch nicht begonnenen Aufgabe. Plan-Ist-Quote: Planstunden der erledigten Aufgaben / ihre gebuchten Stunden (über 100 % = schneller als geplant). Ausgeblendete Aufgaben zählen nicht, ihre Stunden schon.',
    portfolioReport: 'Projektportfolio',
    projectReport: 'Projektbericht',
    reportAsOf: 'Stand {{date}}',
    printNow: 'Drucken / als PDF speichern',
    demoPrint: 'In der Demo kann das Druckfenster gesperrt sein. In der installierten Plattform öffnet „PDF-Bericht“ direkt den Druckdialog; dort „Als PDF speichern“ und Querformat wählen.',
    kpi: {
      projects: 'Projekte',
      progress: 'Fortschritt',
      doneOf: '{{done}} von {{tasks}} Aufgaben erledigt',
      byPlan: '{{done}} von {{plan}} Planstunden erledigt',
      overdue: 'Überfällig',
      dueSoon: '{{count}} in 7 Tagen fällig',
      overdueSoon: '{{overdue}} überfällig, {{soon}} in 7 Tagen fällig',
      withDue: 'von {{count}} offenen mit Termin',
      actual: 'Stunden im Zeitraum',
      lifetime: 'gesamt {{hours}} h',
      lifetimeShort: 'Ist gesamt (h)',
      plan: 'Planstunden',
      plannedTasks: '{{count}} von {{tasks}} Aufgaben mit Plan',
      planUse: 'Planverbrauch',
      planUseHint: 'Gebucht / geplant (Aufgaben mit Plan)',
      planRatio: 'Plan-Ist-Quote',
      planRatioHint: 'Erledigte Aufgaben: Plan / Ist',
      onTime: 'Termintreue',
      avgClose: 'Ø {{days}} Tage bis erledigt',
      noneDone: 'noch nichts erledigt',
      tasks: 'Aufgaben',
      cost: 'Kosten',
      costHint: 'Gebuchte Stunden × Kostensatz',
      costMissing: 'Für {{hours}} h fehlt ein Kostensatz.',
      sales: 'Erlöswert',
      salesHint: 'Abrechenbare Stunden × Verkaufssatz',
      margin: 'Deckungsbeitrag',
      marginHint: 'Erlöswert minus Kosten',
      fee: 'Honorar laut Vertrag',
      feeHint: 'Pauschalhonorar des Projekts',
    },
    schedule: {
      label: 'Terminlage',
      ok: 'im Plan',
      risk: 'Risiko',
      late: 'Verzug',
      none: 'ohne Termine',
    },
    scheduleHint: {
      ok: 'Keine überfälligen Aufgaben, keine bald fällige ohne Beginn.',
      risk: 'Einzelne Aufgaben überfällig, oder bald fällig und noch nicht begonnen.',
      late: 'Mehrere Aufgaben überfällig (mindestens 3 oder ein Fünftel der offenen mit Termin).',
      none: 'Keine offenen Aufgaben mit Fälligkeitsdatum.',
    },
    buildings: 'Gebäude und Geschosse',
    buildingAria: 'Schematische Ansicht der Gebäude mit dem Fortschritt je Geschoss',
    settings: 'Einstellungen',
    filters: 'Filter',
    removeFilter: 'Filter entfernen',
    clearFilters: 'Alle Filter zurücksetzen',
    tabs: {
      overview: 'Überblick',
      building: 'Gebäude',
      matrix: 'Matrix',
      schedule: 'Zeitplan',
      team: 'Team',
      tasks: 'Aufgaben',
      cost: 'Kosten',
    },
    dims: {
      building: 'Gebäude / Bauteil',
      floor: 'Geschoss',
      zone: 'Zone',
      trade: 'Gewerk',
      phase: 'Leistungsphase',
      category: 'Kategorie (Forma)',
      type: 'Typ (Forma)',
      stage: 'Bearbeitungsstand',
      person: 'Person',
      formaField: 'Forma-Feld',
    },
    none: 'ohne Angabe',
    stages: {
      open: 'offen',
      progress: 'in Arbeit',
      review: 'in Prüfung',
      done: 'erledigt',
    },
    legendProgress: 'Fortschritt:',
    legendHours: 'Stunden:',
    legendLess: 'wenig',
    legendMore: 'viel',
    export: {
      button: 'Exportieren …',
      title: 'Projektanalyse exportieren',
      format: 'Format',
      parts: 'Inhalt',
      formats: {
        pdf: 'PDF (Bericht drucken)',
        html: 'Interaktive HTML-Datei',
        xlsx: 'Excel (Daten)',
      },
      formatHints: {
        pdf: 'Zum Ablegen und Versenden; über „Als PDF speichern“ im Druckdialog.',
        html: 'Eine Datei, die jeder Browser öffnet, ohne Anmeldung: Wer sie erhält, sieht beim Zeigen auf ein Geschoss, einen Balken oder eine Zelle die Einzelheiten.',
        xlsx: 'Tabellen zum Weiterrechnen; ohne Zeichnungen (Gebäude, Zeitplan und Kosten nur in PDF und HTML).',
      },
      part: {
        overview: 'Kennzahlen und Fortschritt',
        building: 'Gebäude',
        matrix: 'Geschoss × Gewerk',
        schedule: 'Zeitplan (Burn-up, Balkenplan, überfällig)',
        team: 'Wer arbeitet wo',
        tasks: 'Alle Aufgaben',
        cost: 'Kosten und Umsatzwert',
      },
      notAvailable: 'Für dieses Projekt nicht vorhanden',
      notInExcel: 'Nur in PDF und HTML',
      filtersHint: 'Zeitraum und Filter der Analyse gelten auch für den Export. Die Datei enthält nur, was Sie mit Ihren Rechten sehen.',
      go: {
        pdf: 'Bericht drucken',
        html: 'HTML-Datei erstellen',
        xlsx: 'Excel erstellen',
      },
      html: 'HTML (interaktiv)',
      htmlHint: 'Bericht als Datei, die jeder Browser öffnet; Einzelheiten beim Zeigen auf die Werte',
      htmlNote: 'Erstellt am {{date}} von {{name}} mit {{app}}. Zeigen Sie auf Geschosse, Balken und Zellen, um die Einzelheiten zu sehen.',
      htmlShort: 'HTML (interaktiv)',
    },
    noTasks: 'keine Aufgaben',
    floorAria: '{{progress}} erledigt ({{done}} von {{tasks}} Aufgaben), {{overdue}} überfällig, {{hours}} h im Zeitraum',
    tipProgress: '{{progress}} erledigt ({{done}} von {{tasks}})',
    tipStages: 'in Arbeit {{progress}} · in Prüfung {{review}} · offen {{open}}',
    tipDue: '{{overdue}} überfällig · {{soon}} in 7 Tagen fällig',
    tipHours: '{{actual}} h gebucht im Zeitraum · Plan {{plan}} h',
    wholeProject: 'Gesamtes Projekt',
    buildingTotal: '{{progress}} erledigt · {{done}}/{{tasks}} Aufgaben',
    general: 'Gebäude allgemein',
    area: 'Bereich ohne Geschosse',
    progressBy: 'Fortschritt nach {{dim}}',
    noFloorsTitle: 'Noch kein Gebäudebild',
    noFloors: 'Keine Geschosse erkannt. Unter „Einstellungen“ festlegen, aus welchem Forma-Feld oder welcher Ebene der Standorte das Geschoss kommt. Felder werden im Projekt im Tab „Forma“ übernommen.',
    burn: {
      title: 'Verlauf (Burn-up)',
      total: 'Aufgaben gesamt',
      due: 'fällig laut Termin',
      finished: 'erledigt',
      aria: 'Burn-up: {{finished}} von {{total}} Aufgaben erledigt',
      week: 'In der Woche: {{done}} erledigt, {{created}} neu, {{hours}} h gebucht',
    },
    hoursPerWeek: 'Stunden je Woche',
    overdueTop: 'Am längsten überfällig',
    colourBy: 'Einfärben nach',
    modes: {
      progress: 'Fortschritt',
      schedule: 'Terminlage',
      hours: 'Stunden',
    },
    buildingHint: 'Klick auf ein Geschoss filtert die ganze Analyse darauf, ein zweiter Klick hebt den Filter auf. Das Bild wird aus den Geschossen der Aufgaben gezeichnet: Untergeschosse unter der Geländelinie, das Dach oben, gebäudeweite Aufgaben auf dem Schild darunter.',
    detailOf: '{{place}}: Fortschritt nach {{dim}}',
    rows: 'Zeilen',
    cols: 'Spalten',
    matrixHint: 'Oben der Fortschritt, darunter erledigt/gesamt; rote Zahl: überfällige Aufgaben. Klick auf eine Zelle, Zeile oder Spalte filtert die Analyse.',
    noData: 'Keine Daten für diese Auswahl.',
    groupBy: 'Gruppieren nach',
    openOnly: 'Nur offene Aufgaben',
    gantt: {
      empty: 'Keine Aufgaben mit Start- oder Fälligkeitsdatum.',
      overdue: 'überfällig',
      noDue: 'ohne Fälligkeitsdatum',
      overdueDays: '{{count}} Tage überfällig',
      overdueDays_one: '{{count}} Tag überfällig',
      limited: 'Die ersten {{count}} Aufgaben werden gezeigt; mit den Filtern eingrenzen.',
      without: '{{count}} Aufgaben ohne Datum sind nicht dargestellt.',
      without_one: '1 Aufgabe ohne Datum ist nicht dargestellt.',
    },
    overdueAllProject: 'Überfällige Aufgaben ({{count}})',
    overdueCount: '{{count}} überfällig',
    whoWhere: 'Wer arbeitet woran (Stunden im Zeitraum)',
    teamHint: 'Stunden laut Buchungen in Projektzeit im gewählten Zeitraum.',
    personTasks: 'Personen: Stunden und die Aufgaben, auf die sie gebucht haben',
    noHours: 'Keine Stunden in diesem Zeitraum.',
    hoursUnit: 'Werte in Stunden.',
    sortBy: 'Sortieren nach',
    sort: {
      overdue: 'Überfällige zuerst',
      due: 'Fälligkeit',
      ref: 'Nummer',
      plan: 'Planstunden',
      actual: 'Ist-Stunden',
    },
    startDue: 'Beginn - Fällig',
    showMore: 'Weitere {{count}} zeigen',
    costNote: 'Kosten aus den Kostensätzen der Personen am Buchungstag; Erlöswert aus den Verkaufssätzen der abrechenbaren Stunden (abgerechnete Stunden, wo erfasst). Nur für Personen mit dem jeweiligen Recht sichtbar.',
    cfg: {
      intro: 'Woher die Analyse Gebäude, Geschoss, Gewerk und Leistungsphase einer Aufgabe nimmt. Der Vorschlag kommt aus den übernommenen Forma-Feldern und den Standorten und kann hier angepasst werden.',
      none: 'nicht verwenden',
      field: 'Feld: {{title}}',
      loc1: 'Forma-Standort, Ebene 1',
      loc2: 'Forma-Standort, Ebene 2',
      loc3: 'Forma-Standort, Ebene 3',
      noFields: 'Für dieses Projekt sind noch keine Forma-Felder übernommen (Projekt, Tab „Forma“, Felder).',
      buildingHint: 'Am besten die Forma-Standorte (Ebene 1: Gebäude, Ebene 2: Geschoss, Ebene 3: Zone); ein eigenes Feld wie „Teilprojekt“ ist dann nicht nötig.',
      floorHint: 'Namen wie 2.UG, KG, EG, 1.OG, DG, Dach werden erkannt und von unten nach oben sortiert.',
      progressBy: 'Fortschritt messen nach',
      progressByHint: 'Nach Planstunden zählen nur Aufgaben mit Plan; große Aufgaben wiegen mehr.',
      byCount: 'Anzahl der Aufgaben',
      byPlan: 'Planstunden',
      fieldsHint: 'Weitere übernommene Felder (z. B. Priorität, Sprints) stehen automatisch als Filter zur Verfügung.',
      reset: 'Vorschlag verwenden',
      zoneHint: 'Zonen eines Geschosses (meist Forma-Standorte, Ebene 3). Ist ein Geschoss gewählt, zeigt die Analyse dieses Geschoss allein mit seinen Zonen und der offenen Arbeit je Zone.',
    },
    scheduleCol: 'Terminlage',
    view: {
      label: 'Ansicht',
      cards: 'Karten',
      list: 'Liste',
    },
    zones: {
      title: 'Zonen: {{floor}}',
      none: 'Auf diesem Geschoss liegen keine Aufgaben in Zonen.',
      noZone: 'ohne Zone',
      progress: '{{pct}} % erledigt',
      left: '{{count}} offen',
      tileHint: '{{zone}}: {{done}} von {{tasks}} Aufgaben erledigt, {{open}} offen. Klick filtert auf die Zone.',
      hint: 'Ein Geschoss mit seinen Zonen (Forma-Standorte, Ebene 3). Grün = Anteil der erledigten Arbeit; „offen“ = Aufgaben, die noch zu tun sind.',
    },
    portfolioTitle: 'Projektanalysen',
  },
  documents: {
    title: 'Nachweise',
    column: 'Nachweis',
    choose: 'Datei wählen',
    pickHint: 'PDF oder Foto (JPG, PNG, HEIC), höchstens 10 MB, bis zu 5 Dateien. Auch per Ziehen und Ablegen.',
    tooMany: 'Höchstens {{count}} Dateien je Abwesenheit.',
    badType: '„{{name}}“: nur PDF oder Bilder (JPG, PNG, WEBP, HEIC).',
    tooLarge: '„{{name}}“ ist größer als 10 MB.',
    download: 'Herunterladen',
    view: 'Ansehen',
    heicHint: 'HEIC-Fotos (iPhone) zeigt nicht jeder Browser an. Zum Ansehen herunterladen.',
    demoPdf: 'In der Demo zeigt die Vorschau den Text des Dokuments; in der installierten Plattform öffnet sich das PDF im Browser.',
    noPreview: 'Für diese Datei gibt es keine Vorschau. Bitte herunterladen.',
    added: 'Nachweis hinzugefügt',
    missing: 'Für diesen Zeitraum wird ein Nachweis erwartet; bisher liegt keiner vor.',
    missingShort: 'Nachweis fehlt',
    none: 'Keine Nachweise.',
    upload: '{{count}} Dateien hochladen',
    upload_one: 'Datei hochladen',
    removeTitle: 'Nachweis löschen',
    removeText: 'Der Inhalt der Datei wird gelöscht; Name und Zeitpunkt bleiben im Protokoll. Nach der Entscheidung kann nur die Personalverwaltung löschen, mit Begründung.',
    removed: 'Nachweis gelöscht',
    count: '{{count}} Nachweise',
    count_one: '1 Nachweis',
    add: 'Nachweis',
    uploadFailed: '{{count}} Dateien konnten nicht hochgeladen werden; bitte unter „Meine Abwesenheiten“ nachreichen.',
    uploadFailed_one: 'Eine Datei konnte nicht hochgeladen werden; bitte unter „Meine Abwesenheiten“ nachreichen.',
    labelRequired: 'Nachweis (erforderlich)',
    labelOptional: 'Nachweis (optional)',
    healthHint: 'Arbeitsunfähigkeitsbescheinigung oder ärztliche Bescheinigung, ab dem {{day}}. Kalendertag erforderlich. Sehen können sie nur Sie und die Personalverwaltung.',
    otherHint: 'z. B. Einladung, Anmeldebestätigung, Bescheinigung. Sehen können sie Sie, die genehmigende Person und die Personalverwaltung.',
    requiredNotice: 'Ab dem {{day}}. Kalendertag wird eine Bescheinigung erwartet. Sie können sie auch später unter „Meine Abwesenheiten“ hochladen.',
    missingNotice: 'Bescheinigung fehlt für {{count}} Krankmeldungen:',
    missingNotice_one: 'Bescheinigung fehlt für eine Krankmeldung:',
  },
  leaveRequests: {
    title: 'Abwesenheitsanträge',
    noAccess: 'Sie entscheiden keine Abwesenheitsanträge. Die Personalverwaltung legt fest, wer die Anträge einer Person genehmigt.',
    subtitleHr: 'Alle offenen Anträge und Krankmeldungen. Anträge von Personen mit eigener genehmigender Person (z. B. Teamleitung) können Sie ebenfalls entscheiden; Krankmeldungen bestätigt nur die Personalverwaltung.',
    subtitleApprover: 'Anträge der Personen, für die Sie genehmigen (Urlaub, Freizeitausgleich, Weiterbildung, Sonderurlaub). Krankmeldungen bestätigt die Personalverwaltung.',
    open: 'Offen',
    decided: 'Zuletzt entschieden',
    provisionalHint: 'Krankmeldungen zählen schon, solange sie auf die Bestätigung warten.',
    healthNote: 'Gesundheitsdaten: nur Personalverwaltung',
    approverIs: 'genehmigt: {{name}}',
    approverHr: 'genehmigt: Personalverwaltung',
    confirm: 'Bestätigen',
    decidedHint: 'Ihre Entscheidungen der letzten 30 Tage. „Rückgängig“ geht, solange danach nichts geändert wurde und der Monat offen ist.',
    noneDecided: 'Keine Entscheidungen in den letzten 30 Tagen.',
    stage: {
      l1: 'Stufe 1: zugewiesene Person',
      final: 'Stufe 2: Personal',
    },
    split: 'Kein Urlaubsteil von 10 Tagen mehr möglich',
    splitHint: 'Türkei (İş Kanunu m. 56/3): Ein Teil des Jahresurlaubs soll mindestens 10 Arbeitstage umfassen. Keine Buchung des Jahres erreicht 10 Tage, und es sind weniger als 10 Tage übrig. Nur ein Hinweis: Die Parteien können anderes vereinbaren.',
  },
  customers: {
    title: 'Kunden',
    subtitle: 'Kontaktliste, Firmen und Zahlungsbedingungen der Projekte. Keine Buchhaltung, keine Rechnungsstellung.',
    noAccess: 'Nur für die Geschäftsführung (Recht „Kundenstamm“).',
    tabs: {
      contacts: 'Kontakte',
      companies: 'Firmen',
      terms: 'Konditionen',
      analytics: 'Auswertung',
      migration: 'Übernahme aus Text',
    },
    search: 'Suchen: Firma, Name, Ort, E-Mail …',
    filterStatus: 'Nach Status filtern',
    allStatus: 'Alle',
    showInactive: 'Auch inaktive Kontakte',
    showArchived: 'Archivierte anzeigen',
    archivedPill: 'archiviert',
    inactivePill: 'inaktiv',
    shownOf: '{{shown}} von {{total}} angezeigt',
    noMatches: 'Keine Treffer für diese Suche oder diesen Status.',
    resetFilters: 'Filter zurücksetzen',
    newContact: 'Neuer Kontakt',
    newCompany: 'Neue Firma',
    importCsv: 'CSV importieren',
    exportCsv: 'CSV exportieren',
    emptyContacts: 'Noch keine Kontakte. Legen Sie einen Kontakt an oder übernehmen Sie Ihre bestehende Liste als CSV-Datei (Excel: „Speichern unter“ → CSV).',
    emptyCompanies: 'Noch keine Firmen. Firmen entstehen beim Anlegen eines Kontakts oder hier.',
    dncHint: 'Nicht kontaktieren: bitte keine E-Mails senden und nicht anrufen.',
    statuses: {
      prospect: 'Interessent',
      offered: 'Angebot abgegeben',
      active: 'Aktiver Kunde',
      former: 'Ehemaliger Kunde',
      partner: 'Geschäftspartner',
      do_not_contact: 'Nicht kontaktieren',
    },
    cols: {
      company: 'Firma',
      contact: 'Ansprechpartner',
      email: 'E-Mail',
      phone: 'Telefon',
      status: 'Status',
      note: 'Notiz',
      city: 'Ort',
      owner: 'Verantwortlich',
      contacts: 'Kontakte',
      projects: 'Projekte',
      hours12m: 'Stunden (12 Mon.)',
      wip: 'Nicht abgerechnet',
      billed: 'Belege netto',
      project: 'Projekt',
      role: 'Rolle',
      roles: 'Zuständig für',
      kind: 'Art',
      client: 'Auftraggeber',
      recipient: 'Rechnungsempfänger',
      paymentTerm: 'Zahlungsbedingung',
      method: 'Abrechnung',
      completeness: 'Vollständigkeit',
      items: 'Nachträge',
      number: 'Nummer',
      period: 'Zeitraum',
      amount: 'Betrag',
    },
    stats: {
      companies: 'Firmen',
      active: 'Aktive Kunden',
      prospects: 'Interessenten und Angebote',
      prospectsHint: 'Status „Interessent“ oder „Angebot abgegeben“',
      wip: 'Nicht abgerechnete Leistung',
      wipHint: 'Freigegebene, noch nicht abgerechnete Stunden mal Satz am Buchungstag',
      billed: 'Belege (netto)',
      billedHint: 'Finalisierte Stundennachweise und Abschläge; keine Buchhaltung',
    },
    types: {
      company: 'Unternehmen',
      public: 'Öffentliche Hand',
      person: 'Privatperson',
    },
    roles: {
      auftraggeber: 'Auftraggeber',
      rechnungsempfaenger: 'Rechnungsempfänger',
      bauherr: 'Bauherr / Endkunde',
      generalplaner: 'Generalplaner / Partner',
      subplaner: 'Subplaner',
    },
    contactRoles: {
      invoice: 'Rechnung',
      technical: 'Technik',
      sn_approver: 'Stundennachweis-Freigabe',
    },
    methods: {
      hourly: 'Nach Aufwand (Stunden)',
      hoai: 'HOAI-Abschläge',
      fixed_fee: 'Pauschalhonorar',
      mixed: 'Gemischt',
    },
    channels: {
      email: 'E-Mail',
      post: 'Post',
      portal: 'Portal',
    },
    itemKinds: {
      nachtrag: 'Nachtrag',
      nebenkosten: 'Nebenkosten',
    },
    itemStatuses: {
      offered: 'Angeboten',
      approved: 'Beauftragt',
      rejected: 'Abgelehnt',
      invoiced: 'Abgerechnet',
    },
    taxScenarios: {
      de_standard: 'Inland, Regelsteuersatz (laut Einstellung)',
      pending_advisor: 'Steuerberater-Bestätigung ausstehend',
    },
    company: {
      newTitle: 'Neue Firma',
      editTitle: 'Firma bearbeiten',
      name: 'Firmenname',
      status: 'Status',
      owner: 'Verantwortlich',
      ownerHint: 'Wer bei uns für diesen Kunden zuständig ist',
      noOwner: 'nicht zugeordnet',
      street: 'Straße und Hausnummer',
      postalCode: 'PLZ',
      city: 'Ort',
      country: 'Land',
      countryHint: '2 Buchstaben, z. B. DE',
      note: 'Notiz',
      more: 'Weitere Angaben für die Abrechnung',
      moreHint: 'Nur nötig, wenn diese Firma Rechnungen erhält: Steuernummer, Kundennummer …',
      type: 'Art',
      legalName: 'Vollständige Firmierung',
      vatId: 'USt-IdNr. / Steuernummer',
      vatIdHint: 'DE: „DE“ und 9 Ziffern; TR: 10 oder 11 Ziffern',
      taxBad: 'Format prüfen',
      taxOk: 'Format in Ordnung',
      leitwegId: 'Leitweg-ID',
      leitwegHint: 'Pflicht bei öffentlichen Auftraggebern (Käuferreferenz)',
      customerNo: 'Kundennummer',
      debitorNo: 'Debitorennummer',
      debitorHint: 'vergibt der Steuerberater',
    },
    contact: {
      newTitle: 'Neuer Kontakt',
      editTitle: 'Kontakt bearbeiten',
      company: 'Firma',
      pickCompany: 'Firma wählen …',
      newCompany: 'Neue Firma',
      firstName: 'Vorname',
      lastName: 'Nachname',
      position: 'Funktion',
      phone: 'Telefon',
      email: 'E-Mail',
      note: 'Notiz',
      responsible: 'Zuständig für',
      active: 'Aktiv',
      activeHint: 'Inaktive Kontakte (z. B. ausgeschieden) bleiben gespeichert, erscheinen aber nur auf Wunsch in der Liste.',
      deleteTitle: 'Kontakt löschen?',
      deleteText: 'Der Kontakt wird aus den Projektrollen entfernt. Nur Geschäftsdaten speichern, keine privaten Daten (DSGVO).',
    },
    party: {
      add: 'Projekt zuordnen',
      title: 'Rolle im Projekt',
      none: 'Noch keinem Projekt zugeordnet.',
      pickProject: 'Projekt wählen …',
      noContact: 'kein bestimmter Ansprechpartner',
      contactHint: 'Optional: wer bei dieser Firma für das Projekt zuständig ist',
      remove: 'Rolle entfernen',
      removeTitle: 'Rolle entfernen?',
      removeText: 'Die Zuordnung der Firma zum Projekt wird gelöst. Der Freitext im Projekt bleibt unverändert.',
    },
    detail: {
      back: 'Zu den Kunden',
      master: 'Stammdaten',
      address: 'Anschrift',
      contacts: 'Ansprechpartner',
      addContact: 'Kontakt hinzufügen',
      noContacts: 'Noch keine Ansprechpartner.',
      projects: 'Projekte und Rollen',
      terms: 'Konditionen',
      archive: 'Archivieren',
      unarchive: 'Wieder aktivieren',
      archiveTitle: 'Firma archivieren?',
      archiveText: 'Die Firma und ihre Kontakte verschwinden aus den Listen; die Rollen in den Projekten bleiben erhalten. Sie können die Firma jederzeit wieder aktivieren.',
    },
    docs: {
      title: 'Stundennachweise und Abschläge',
      hint: 'Vorhandene Belege der Projekte dieser Firma (nur lesen). Rechnungen werden hier nicht erstellt.',
      none: 'Noch keine Belege.',
      draft: 'Entwurf',
    },
    terms: {
      title: 'Konditionen',
      intro: 'Pro Projekt: Zahlungsziel (z. B. 14 Tage), Skonto (z. B. 1,5 % bei Zahlung in 7 Tagen), Abzüge nach der Umsatzsteuer, Rechnungsempfänger und Zustellung. Klicken Sie ein Projekt an, um die Konditionen zu bearbeiten. Hier wird keine Rechnung erzeugt.',
      defaultDays: 'Vorgeschlagenes Zahlungsziel (Tage)',
      defaultDaysHint: 'Vorgabe, wenn die Konditionen eines Projekts angelegt werden.',
      search: 'Suchen: Projekt, Auftraggeber …',
      onlyOpen: 'Nur unvollständige',
      allComplete: 'Alle Projekte haben vollständige Konditionen.',
      none: 'keine Konditionen',
      complete: 'vollständig',
      gapsCount: '{{count}} offen',
      gapsCount_one: '{{count}} offen',
      stillNeeded: 'Noch nötig',
      freeText: 'Freitext im Projekt',
      customer: 'Kunde',
      partner: 'Partner',
      sectionRecipient: 'Rechnungsempfänger und Referenzen',
      recipient: 'Rechnungsempfänger (Firma)',
      noRecipient: 'nicht gewählt',
      recipientAddress: 'Abweichende Rechnungsadresse',
      recipientAddressHint: 'leer = Anschrift der Firma',
      orderRef: 'Referenz Auftraggeber (Bestellnr.)',
      buyerRef: 'Käuferreferenz (BT-10 / Leitweg-ID)',
      sectionPayment: 'Zahlungsbedingungen',
      paymentIntro: 'Zahlungsziel, Skonto bei früher Zahlung und Abzüge, die erst nach der Umsatzsteuer vom Gesamtbetrag abgezogen werden (z. B. Nachlass, Sicherheitseinbehalt).',
      paymentDays: 'Zahlungsziel (Tage)',
      paymentHint: 'Vorgabe aus den Einstellungen: {{days}} Tage',
      discountPercent: 'Skonto (%)',
      discountDays: 'bei Zahlung innerhalb (Tage)',
      adjustments: 'Abzüge nach der Umsatzsteuer',
      adjustmentsHint: 'Jeder Abzug bezieht sich auf den Gesamtbetrag inklusive Umsatzsteuer, nicht auf die anderen Abzüge. Das Skonto wird vom verbleibenden Zahlbetrag berechnet.',
      addAdjustment: 'Abzug hinzufügen',
      adjustmentLabel: 'Bezeichnung (z. B. Nachlass)',
      modePercent: '% vom Gesamtbetrag',
      modeAmount: 'Betrag (EUR)',
      exampleTitle: 'Beispielrechnung',
      exampleNet: 'Nettobetrag (EUR)',
      net: 'Netto',
      vat: 'Umsatzsteuer {{percent}} %',
      gross: 'Brutto (inkl. Umsatzsteuer)',
      payable: 'Zahlbetrag',
      payableDue: 'Zahlbetrag innerhalb von {{days}} Tagen',
      payableDiscount: 'Bei Zahlung innerhalb von {{days}} Tagen ({{percent}} % Skonto)',
      documentText: 'Text auf dem Beleg',
      taxAdvisorNote: 'Ob und wie die Umsatzsteuer bei Skonto korrigiert wird, entscheidet der Steuerberater (§ 17 UStG). Die Beispielrechnung zeigt nur, was der Kunde zahlt, und ersetzt keine Rechnung.',
      daysShort: '{{count}} Tage',
      daysShort_one: '{{count}} Tag',
      discountShort: '{{percent}} % Skonto in {{days}} Tagen',
      sectionBilling: 'Abrechnung und Steuer',
      method: 'Abrechnungsart',
      notChosen: 'nicht gewählt',
      taxScenario: 'Steuerszenario',
      taxOpen: 'Offene Frage: Die freigegebene Liste der Steuerszenarien (Inland, Reverse Charge, EU, Drittland) gibt der Steuerberater vor. Bis zur Antwort gibt es nur dieses Beispiel, kein freier Steuersatz.',
      sectionDelivery: 'Zustellung und Freigabe',
      delivery: 'Zustellung',
      deliveryAddress: 'Zustelladresse (E-Mail oder Anschrift)',
      snApproval: 'Stundennachweis braucht Freigabe des Kunden',
      snTemplate: 'Stundennachweis-Vorlage',
      note: 'Notiz',
      itemsTitle: 'Nachträge und Nebenkosten',
      itemsTotal: 'Beauftragt oder abgerechnet',
      addItem: 'Posten hinzufügen',
      itemEdit: 'Posten bearbeiten',
      itemTitle: 'Bezeichnung',
      itemAmount: 'Betrag netto (EUR)',
      noItems: 'Keine Posten',
      needTerms: 'Zuerst Konditionen speichern, dann Posten erfassen.',
      discountMax: 'Höchstens {{max}} %',
    },
    gaps: {
      recipient: 'Rechnungsempfänger fehlt',
      address: 'Rechnungsadresse fehlt',
      payment_days: 'Zahlungsziel fehlt',
      discount: 'Skonto: Frist fehlt oder ist nicht kürzer als das Zahlungsziel',
      billing_method: 'Abrechnungsart fehlt',
      tax_scenario: 'Steuerszenario fehlt',
      delivery: 'Zustellung unvollständig',
      vat_id: 'USt-IdNr. fehlt oder ungültig',
      leitweg: 'Leitweg-ID fehlt (öffentlicher Auftraggeber)',
    },
    import: {
      title: 'Kontaktliste importieren',
      intro: 'Laden Sie Ihre bestehende Tabelle als CSV-Datei hoch (Excel: Speichern unter → CSV). Zuerst sehen Sie eine Vorschau, erst danach wird gespeichert. Bestehende Firmen bleiben unverändert, es werden nur neue Kontakte ergänzt.',
      choose: 'CSV-Datei wählen',
      formatTitle: 'Welche Spalten werden erkannt?',
      format: 'Erste Zeile = Überschriften. Erkannt werden: Firma (Pflicht), Adresse, PLZ, Ort, Land, Vorname, Nachname, Funktion, E-Mail, Telefon, Status, Notiz – auf Deutsch, Englisch oder Türkisch. Trennzeichen „;“ oder „,“. Der Status wird aus dem Text erkannt (z. B. „Aktiver Kunde“, „aktif müşteri“); ohne Angabe gilt „Interessent“.',
      line: 'Zeile',
      result: 'Ergebnis',
      rows: '{{count}} Zeilen',
      rows_one: '1 Zeile',
      newCompanies: '{{count}} neue Firmen',
      newCompanies_one: '1 neue Firma',
      newContacts: '{{count}} neue Kontakte',
      newContacts_one: '1 neuer Kontakt',
      skipped: '{{count}} schon vorhanden',
      skipped_one: '1 schon vorhanden',
      errors: '{{count}} mit Fehler',
      errors_one: '1 mit Fehler',
      apply: 'Importieren',
      done: '{{contacts}} Kontakte und {{companies}} Firmen übernommen.',
      actions: {
        create_company: 'Neue Firma',
        add_contact: 'Neuer Kontakt',
        skip_duplicate: 'Schon vorhanden',
        error: 'Fehler',
      },
      errorCodes: {
        missing_company: 'Firma fehlt',
        missing_name: 'Name fehlt',
        unknown_status: 'Status unbekannt',
      },
    },
    migration: {
      intro: 'Aus „Kunde“ und „Partner“ der Projekte entstehen Firmenkandidaten. Schreibweisen werden nur als Gruppe vorgeschlagen; Sie bestätigen jede Gruppe. Gleicher Name ist kein Grund zur automatischen Zusammenführung. Die Freitexte im Projekt bleiben als Sicherung erhalten.',
      none: 'Keine offenen Freitexte: alle Projekte haben ihre Firmen.',
      selectAll: 'Alle auswählen',
      selectNone: 'Auswahl aufheben',
      selected: '{{count}} Gruppen ausgewählt',
      selected_one: '1 Gruppe ausgewählt',
      fieldCustomer: 'Kunde → Auftraggeber',
      fieldPartner: 'Partner → Generalplaner',
      projectCount: '{{count}} Projekte',
      projectCount_one: '1 Projekt',
      spellings: 'Schreibweisen',
      usedIn: 'Verwendet in',
      createNew: 'Neue Firma anlegen',
      linkExisting: 'Bestehender Firma zuordnen',
      suggested: 'Vorschlag: bestehende Firma',
      shortName: 'Firmenname',
      pickCompany: 'Firma wählen …',
      apply: 'Ausgewählte übernehmen',
      applied: '{{created}} Firmen angelegt, {{linked}} Projektrollen gesetzt',
    },
    analytics: {
      year: 'Jahr',
      intro: 'Je Firma: Projekte (aktiv / alle), versandte Dokumente (abgeschlossen, in Rechnung gestellt, bezahlt; stornierte zählen nicht) mit Stunden und Nettobeträgen, offene Entwürfe und das letzte Dokument. Firma eines Dokuments ist sein Empfänger aus den Kundendaten, sonst der Rechnungsempfänger der Konditionen.',
      topAmount: 'Die zehn Firmen mit dem größten Nettobetrag {{year}}',
      topHours: 'Die zehn Firmen mit den meisten abgerechneten Stunden {{year}}',
      empty: 'Noch keine Firma mit Projekten oder Dokumenten.',
      company: 'Firma',
      projects: 'Projekte',
      activeOf: '{{active}} aktive von {{all}} Projekten',
      documents: 'Dokumente',
      drafts: 'Entwürfe',
      hoursYear: 'Stunden {{year}}',
      amountYear: 'Netto {{year}}',
      amountAll: 'Netto gesamt',
      last: 'Letztes Dokument',
    },
  },
  shell: {
    back: 'Zurück',
    forward: 'Vor',
    backTitle: 'Zur vorherigen Seite (Alt + Pfeil links)',
    forwardTitle: 'Zur nächsten Seite (Alt + Pfeil rechts)',
    quickLinks: 'Links der Firma',
    links: {
      standards: 'Standards & Vorlagen',
      meetings: 'Koordination: Notizen',
      website: 'Website',
      formaHome: 'Forma My Home',
      sharepoint: 'SharePoint der Firma',
    },
    linkHints: {
      standards: 'Richtlinien, Vorlagen und Layouts der Firma',
      meetings: 'Notizen der wöchentlichen Koordinationsbesprechung (SharePoint)',
      website: 'Website der Firma',
      formaHome: 'Eigene Startseite in Forma (für alle dieselbe Adresse)',
      sharepoint: 'Hauptordner der Firma in SharePoint',
    },
  },
  notif: {
    title: 'Benachrichtigungen',
    bellUnread: '{{count}} ungelesene Benachrichtigungen',
    bellUnread_one: '1 ungelesene Benachrichtigung',
    tabFeed: 'Benachrichtigungen',
    tabHistory: 'Mein Verlauf',
    filterTitle: 'Anzeigen',
    filterReset: 'Alle anzeigen',
    filterHint: 'Ihre Auswahl wird in Ihrem Konto gespeichert und gilt auf jedem Gerät. Was Sie hier sehen, betrifft nur Sie und richtet sich nach Ihren Rechten.',
    hideCategory: '„{{name}}“ ausblenden',
    showCategory: '„{{name}}“ einblenden',
    onlyUnread: 'Nur Ungelesene',
    markAll: 'Alle als gelesen markieren',
    empty: 'Keine Benachrichtigungen. Sobald etwas Ihre Aufmerksamkeit braucht, erscheint es hier.',
    emptyFiltered: 'Nichts zu zeigen. Prüfen Sie die Auswahl oben.',
    unread: 'ungelesen',
    critical: 'Dringend',
    todo: 'Zu erledigen',
    categories: {
      hours: 'Meine Zeiten',
      leave: 'Abwesenheiten',
      approvals: 'Freigaben',
      period: 'Monatsabschluss',
      missing: 'Fehlende Buchungen',
      announcement: 'Mitteilungen',
      system: 'System',
      forma: 'Forma',
    },
    historyHint: 'Ihre eigenen Aktionen der letzten Zeit. Zu Daten anderer Personen steht nur die Art der Aktion, nicht der Inhalt.',
    historyEmpty: 'Noch keine Aktionen.',
    historyMore: 'Mehr laden',
    actions: {
      time_update: 'Zeiteintrag geändert',
      time_delete: 'Zeiteintrag gelöscht',
      time_restore: 'Zeiteintrag wiederhergestellt',
      time_submit: 'Zeiten eingereicht',
      time_withdraw: 'Zeiten zurückgezogen',
      time_approve: 'Zeiten freigegeben',
      time_approve_undo: 'Freigabe rückgängig gemacht',
      time_reject: 'Zeiten zurückgewiesen',
      time_reject_undo: 'Zurückweisung rückgängig gemacht',
      time_reopen: 'Zeiten wieder geöffnet',
      time_create_for_other: 'Zeit für andere Person gebucht',
      time_billed: 'Zeiten als abgerechnet markiert',
      absence_request: 'Abwesenheit beantragt',
      absence_create: 'Abwesenheit eingetragen',
      absence_withdraw: 'Antrag zurückgezogen',
      absence_withdraw_undo: 'Rückzug rückgängig gemacht',
      absence_cancel: 'Abwesenheit storniert',
      absence_approve: 'Abwesenheit genehmigt',
      absence_reject: 'Abwesenheit abgelehnt',
      absence_change_request: 'Änderung angefordert',
      absence_decision_undo: 'Entscheidung rückgängig gemacht',
      absence_document_add: 'Nachweis hochgeladen',
      absence_document_removed: 'Nachweis entfernt',
      absence_import: 'Abwesenheiten importiert',
      person_update: 'Personendaten geändert',
      person_avatar: 'Profilbild geändert',
      person_avatar_removed: 'Profilbild entfernt',
      person_create: 'Person angelegt',
      person_activate: 'Person aktiviert',
      person_deactivate: 'Person deaktiviert',
      person_role: 'Rolle geändert',
      person_approver: 'Genehmigende Person geändert',
      person_reset_access: 'Zugang zurückgesetzt',
      person_fill_codes: 'Kürzel ergänzt',
      project_create: 'Projekt angelegt',
      project_update: 'Projekt geändert',
      project_archive: 'Projekt archiviert',
      project_unarchive: 'Projekt wiederhergestellt',
      project_member_set: 'Projektteam geändert',
      project_member_remove: 'Person aus Projekt entfernt',
      project_party_set: 'Firma im Projekt zugeordnet',
      project_party_remove: 'Firmenzuordnung gelöst',
      task_create_manual: 'Aufgabe angelegt',
      task_create_internal: 'Interne Aufgabe angelegt',
      task_update_manual: 'Aufgabe geändert',
      task_archive: 'Aufgabe archiviert',
      task_unarchive: 'Aufgabe wiederhergestellt',
      task_plan: 'Plan-Stunden geändert',
      billing_create: 'Beleg angelegt',
      billing_finalize: 'Beleg finalisiert',
      billing_cancel: 'Beleg storniert',
      billing_delete_draft: 'Entwurf gelöscht',
      company_create: 'Firma angelegt',
      company_update: 'Firma geändert',
      company_archive: 'Firma archiviert',
      company_unarchive: 'Firma wiederhergestellt',
      company_contact_create: 'Ansprechpartner angelegt',
      company_contact_update: 'Ansprechpartner geändert',
      company_contact_delete: 'Ansprechpartner gelöscht',
      company_contacts_export: 'Kontaktliste exportiert',
      company_contacts_import: 'Kontaktliste importiert',
      terms_create: 'Konditionen angelegt',
      terms_update: 'Konditionen geändert',
      terms_item_create: 'Nachtrag erfasst',
      terms_item_update: 'Nachtrag geändert',
      terms_item_delete: 'Nachtrag gelöscht',
      announcement_create: 'Mitteilung veröffentlicht',
      announcement_update: 'Mitteilung geändert',
      announcement_archive: 'Mitteilung archiviert',
      announcement_unarchive: 'Mitteilung wiederhergestellt',
      period_lock: 'Monat abgeschlossen',
      period_unlock: 'Monat wieder geöffnet',
      settings_update: 'Einstellungen geändert',
      settings_logo: 'Logo geändert',
      settings_logo_removed: 'Logo entfernt',
      quick_favorites: 'Favoriten geändert',
      quick_templates: 'Wochenvorlagen geändert',
      notifications: 'Benachrichtigungsfilter geändert',
      contract_set: 'Vertrag geändert',
      rate_cost: 'Kostensatz geändert',
      rate_sales: 'Verkaufssatz geändert',
      rate_delete: 'Satz gelöscht',
      company_event_create: 'Firmentermin angelegt',
      company_event_update: 'Firmentermin geändert',
      company_event_delete: 'Firmentermin gelöscht',
      holiday_set: 'Feiertag geändert',
      holiday_delete: 'Feiertag entfernt',
      absence_document_viewed: 'Nachweis geöffnet',
      absence_export: 'Abwesenheiten exportiert',
      absence_leave_cut: 'Urlaub wegen Krankheit gekürzt',
      absence_resubmit: 'Antrag angepasst und erneut gesendet',
      allocation_fill: 'Planung übernommen',
      analysis_export: 'Projektanalyse exportiert',
      analysis_export_portfolio: 'Portfolio-Analyse exportiert',
      auth_entra_linked: 'Microsoft-Anmeldung verknüpft',
      auth_entra_mismatch: 'Microsoft-Anmeldung abgelehnt',
      auth_step_up: 'Zusätzlich bestätigt (Abrechnung, Kunden)',
      auth_step_up_failed: 'Zusätzliche Bestätigung fehlgeschlagen',
      bi_export: 'Power-BI-Export erstellt',
      billing_basis_checked: 'Beleg als geprüft markiert',
      billing_import_edit: 'Bearbeitung aus Excel übernommen',
      category_create: 'Kategorie angelegt',
      category_update: 'Kategorie geändert',
      contract_delete: 'Vertragsabschnitt gelöscht',
      data_export_all: 'Gesamtexport erstellt',
      entitlement_set: 'Urlaubsanspruch geändert',
      forma_connect: 'Forma verbunden',
      holiday_revert: 'Feiertagsänderung rückgängig gemacht',
      jobs_check: 'Tägliche Prüfung ausgeführt',
      kpi_person_viewed: 'Kennzahlen einer Person geöffnet',
      kpi_team_viewed: 'Mitarbeiterauswertung geöffnet',
      outlook_sync: 'Outlook-Abgleich ausgeführt',
      overtime_remove: 'Auszahlung oder Korrektur gelöscht',
      overtime_report_viewed: 'Überstundenbericht geöffnet',
      overtime_reset: 'Überstundensaldo zurückgesetzt',
      project_analysis_config: 'Einstellungen der Projektanalyse geändert',
      project_attribute_scope: 'Feldwerte des Projekts eingegrenzt',
      project_colors: 'Projektfarben vergeben',
      project_fee_phases: 'Honorarphasen geändert',
      project_forma_auto_import: 'Forma-Projekt automatisch übernommen',
      project_forma_import: 'Forma-Projekte übernommen',
      project_forma_link: 'Mit Forma verknüpft',
      project_forma_renamed: 'Name aus Forma übernommen',
      project_forma_unlink: 'Forma-Verknüpfung gelöst',
      project_import_cleanup: 'Ausgeschlossene Aufgaben bereinigt',
      project_import_filter: 'Importfilter geändert',
      project_member_tasks: 'Aufgaben eines Mitglieds eingeschränkt',
      project_sync_config: 'Forma-Einstellungen des Projekts geändert',
      settings_step_up: 'Zusätzliche Bestätigung geändert',
      task_delete_manual: 'Aufgabe gelöscht',
      task_forma_access_lost: 'Forma-Aufgabe nicht mehr erreichbar',
      task_forma_deleted: 'Forma-Aufgabe gelöscht',
      task_forma_restored: 'Forma-Aufgabe wieder aktiv',
      task_template_delete: 'Aufgabenvorlage gelöscht',
      task_template_save: 'Aufgabenvorlage gespeichert',
    },
    fields: {
      minutes: 'Dauer (Min.)',
      status: 'Status',
      work_date: 'Datum',
      description: 'Tätigkeit',
      billing_type: 'Abrechnungsart',
      work_location: 'Arbeitsort',
      task_id: 'Aufgabe',
      project_id: 'Projekt',
      date_from: 'Von',
      date_to: 'Bis',
      kind: 'Art',
      half_day: 'Halber Tag',
      note: 'Notiz',
      display_name: 'Name',
      birthday: 'Geburtstag',
      show_birthday: 'Geburtstag im Teamkalender',
      short_code: 'Kürzel',
      language: 'Sprache',
    },
  },
  notify: {
    hours: {
      rejected: 'Zurückgewiesen: {{count}} Einträge in KW {{week}}',
      rejected_one: 'Zurückgewiesen: 1 Eintrag in KW {{week}}',
      returned: 'Freigegebene Stunden zur Korrektur zurückgegeben: {{count}} Einträge in KW {{week}}',
      returned_one: 'Freigegebene Stunden zur Korrektur zurückgegeben: 1 Eintrag in KW {{week}}',
      approved: 'Freigegeben: {{count}} Einträge in KW {{week}}',
      approved_one: 'Freigegeben: 1 Eintrag in KW {{week}}',
      l1: 'Erste Freigabe erteilt: {{count}} Einträge in KW {{week}} warten auf die endgültige Freigabe',
      l1_one: 'Erste Freigabe erteilt: 1 Eintrag in KW {{week}} wartet auf die endgültige Freigabe',
      waiting: '{{count}} Einträge in KW {{week}} warten seit {{days}} Tagen auf Freigabe',
      waiting_one: '1 Eintrag in KW {{week}} wartet seit {{days}} Tagen auf Freigabe',
    },
    missing: {
      days: 'Keine Buchung an {{count}} Arbeitstagen (zuletzt am {{last}})',
      days_one: 'Keine Buchung am {{last}}',
      week_due: 'Heute ist Frist für KW {{week}}: {{count}} Entwürfe sind noch nicht eingereicht',
      week_due_one: 'Heute ist Frist für KW {{week}}: 1 Entwurf ist noch nicht eingereicht',
      week_overdue: 'Frist für KW {{week}} ({{deadline}}) überschritten: {{count}} Entwürfe sind noch nicht eingereicht',
      week_overdue_one: 'Frist für KW {{week}} ({{deadline}}) überschritten: 1 Entwurf ist noch nicht eingereicht',
    },
    leave: {
      pending: '{{kind}} {{period}} wartet auf Entscheidung',
      approved: '{{kind}} {{period}} genehmigt',
      rejected: '{{kind}} {{period}} abgelehnt',
      change_requested: 'Änderung gewünscht für {{kind}} {{period}}: bitte anpassen und erneut einreichen',
      cancelled: '{{kind}} {{period}} wurde storniert',
      document_missing: '{{count}} Abwesenheiten ohne Nachweis (Krankmeldung oder Bescheinigung)',
      document_missing_one: '1 Abwesenheit ohne Nachweis (Krankmeldung oder Bescheinigung)',
      overtime_reset: 'Ihr Überstundensaldo wurde von {{by}} zurückgesetzt: Überstunden zählen ab {{date}}. Saldo vorher {{before}} h, jetzt {{after}} h; ausgebucht: {{hours}} h. Ihre gebuchten Stunden bleiben unverändert.',
      holiday_personal: 'Ihr Feiertag am {{date}} wurde festgelegt oder geändert: {{name}}',
      holiday_changed: 'Feiertag geändert: {{date}} {{name}}',
    },
    approvals: {
      time: '{{count}} Zeiteinträge warten auf Ihre Freigabe (der älteste seit {{days}} Tagen)',
      time_one: '1 Zeiteintrag wartet auf Ihre Freigabe (seit {{days}} Tagen)',
      leave: '{{count}} Abwesenheitsanträge warten auf Ihre Entscheidung',
      leave_one: '1 Abwesenheitsantrag wartet auf Ihre Entscheidung',
    },
    period: {
      open: 'Der Monat {{month}} ist noch nicht abgeschlossen',
    },
    announcement: {
      new: 'Neue Mitteilung: {{title}}',
      confirm: 'Bitte bestätigen: {{title}}',
    },
    system: {
      sync_error: 'Forma-Abgleich: Fehler in den letzten 24 Stunden',
      access_lost: '{{count}} Projekte: Zugriff auf Forma verloren',
      access_lost_one: '1 Projekt: Zugriff auf Forma verloren',
      backup_old: 'Die letzte Sicherung ist älter als 8 Tage',
      job_errors: 'Nachtwartung oder Prüfung vom {{date}}: {{count}} Fehler oder Hinweise',
      job_warnings: 'Nachtwartung oder Prüfung vom {{date}}: {{count}} Hinweise',
      access_reset_cli: 'Ihr Zugang wurde direkt auf dem Server eingerichtet oder zurückgesetzt (neuer Einrichtungslink, Passwort und Authenticator gelöscht, alle Sitzungen beendet). Falls Sie das nicht veranlasst haben, informieren Sie bitte die Geschäftsführung.',
    },
    forma: {
      own_deleted: '{{ref}} {{title}} ({{project}}) wurde in Forma gelöscht: Ihre {{hours}} h darauf bitte prüfen und umbuchen',
      own_lost: 'Kein Zugriff mehr auf {{ref}} {{title}} ({{project}}) in Forma: Ihre {{hours}} h darauf bitte prüfen',
      team_lost: '{{count}} gelöschte oder nicht mehr erreichbare Forma-Aufgaben tragen noch {{hours}} h von {{persons}} Personen',
    },
  },
  ann: {
    title: 'Mitteilungen',
    subtitle: 'Neuigkeiten des Unternehmens: Termine, Hinweise, Unterweisungen. Veröffentlichen dürfen nur Personen, denen die Geschäftsführung das Recht „Mitteilungen“ gegeben hat.',
    tabCurrent: 'Aktuell (so sehen es alle)',
    tabManage: 'Verwalten',
    emptyCurrent: 'Keine aktuellen Mitteilungen für Sie.',
    emptyManage: 'Noch keine Mitteilungen veröffentlicht. Mit „Neue Mitteilung“ legen Sie die erste an.',
    types: {
      info: 'Information',
      event: 'Termin',
      closure: 'Betriebsschließung',
      deadline: 'Frist',
      safety: 'Unterweisung / Arbeitsschutz',
      it: 'IT und System',
      policy: 'Richtlinie geändert',
    },
    typeHints: {
      info: 'Allgemeine Nachricht an die Belegschaft.',
      event: 'Veranstaltung oder Termin (Sommerfest, Teamtag). Erscheint auch unter „Demnächst“.',
      closure: 'Brückentag oder Betriebsferien. Erscheint auch unter „Demnächst“.',
      deadline: 'Erinnerung mit Datum (Stunden einreichen, Urlaubsplanung). Erscheint auch unter „Demnächst“.',
      safety: 'Unterweisung oder Arbeitsschutzhinweis. Die Bestätigung der Kenntnisnahme ist voreingestellt (Nachweis).',
      it: 'Wartung, Passwort, neue Funktion.',
      policy: 'Eine Richtlinie oder ein Dokument wurde geändert. Verweisen Sie mit einem Link auf die Stelle, an der die Firma es ablegt.',
    },
    priorities: {
      normal: 'Normal',
      important: 'Wichtig',
      critical: 'Dringend',
    },
    pinned: 'Angeheftet',
    pinnedHint: 'Bleibt oben stehen',
    new: 'Neu',
    needsConfirm: 'Bestätigung offen',
    more: 'Mehr anzeigen',
    less: 'Weniger anzeigen',
    openLink: 'Öffnen',
    markRead: 'Als gelesen markieren',
    confirm: 'Zur Kenntnis genommen',
    confirmed: 'Danke, Ihre Bestätigung ist gespeichert.',
    confirmedShort: 'Bestätigt',
    newButton: 'Neue Mitteilung',
    showArchived: 'Archivierte anzeigen',
    status: {
      active: 'Aktiv',
      planned: 'Geplant',
      expired: 'Abgelaufen',
      archived: 'Archiviert',
    },
    needsAck: 'mit Bestätigung',
    readText: '{{read}} von {{reach}} gelesen',
    ackText: '{{ack}} bestätigt',
    audienceAll: 'Alle Mitarbeitenden',
    locationOne: 'Standort {{code}}',
    projectsN: '{{count}} Projekte',
    projectsN_one: '1 Projekt',
    personsN: '{{count}} Personen',
    personsN_one: '1 Person',
    roleLead: 'Projektleitung',
    every: {
      weekly: 'wöchentlich',
      monthly: 'monatlich',
      yearly: 'jährlich',
    },
    everyN: 'alle {{count}} {{unit}}',
    units: {
      weeks: 'Wochen',
      months: 'Monate',
      years: 'Jahre',
    },
    recurring: 'wiederkehrend',
    untilShort: 'bis {{date}}',
    fromShort: 'ab {{date}}',
    eventShort: 'Termin {{date}}',
    duplicate: 'Duplizieren',
    receipts: 'Lesebestätigungen',
    restored: 'Mitteilung wiederhergestellt',
    archivedToast: 'Mitteilung archiviert',
    published: 'Mitteilung veröffentlicht',
    form: {
      titleNew: 'Neue Mitteilung',
      titleEdit: 'Mitteilung bearbeiten',
      publish: 'Veröffentlichen',
      type: 'Art',
      headline: 'Überschrift',
      body: 'Text',
      priority: 'Wichtigkeit',
      pin: 'Oben anheften',
      pinHint: 'Angeheftete Mitteilungen stehen vor den übrigen (nach dringenden).',
      startsOn: 'Sichtbar ab',
      endsOn: 'Sichtbar bis',
      endsOnHint: 'Leer: bleibt sichtbar, bis Sie die Mitteilung archivieren.',
      endsOnRepeat: 'Bei Wiederholung bestimmt „Sichtbar für (Tage)“ die Dauer.',
      eventDate: 'Datum des Termins',
      eventTime: 'Uhrzeit',
      repeat: 'Wiederholen',
      repeatHint: 'Für Wiederkehrendes, z. B. monatliche Stundenabgabe oder jährliche Unterweisung. Jede Wiederholung zählt für die Lesebestätigung neu.',
      freq: 'Rhythmus',
      interval: 'Abstand ({{unit}})',
      until: 'Wiederholen bis',
      duration: 'Sichtbar für (Tage)',
      lead: 'Vorher anzeigen (Tage)',
      leadHint: 'So viele Tage vor dem Beginn erscheint sie schon.',
      audience: 'Zielgruppe',
      audienceAll: 'Alle Mitarbeitenden',
      audienceAllHint: 'Externe Personen sehen sie nicht.',
      audienceHint: 'Wer zu mindestens einer der Gruppen gehört, sieht die Mitteilung.',
      locations: 'Standorte (Feiertagskalender der Person)',
      roles: 'Rollen',
      projects: 'Projektteams',
      addProject: 'Projekt hinzufügen …',
      persons: 'Einzelne Personen',
      personsHint: 'Zum Beispiel für eine Mitteilung an eine einzelne Person. Auch externe Personen lassen sich wählen.',
      addPerson: 'Person hinzufügen …',
      externalShort: 'extern',
      externalHint: 'Externe Personen sehen nur Mitteilungen, die ihre Rolle „Extern“, eines ihrer Projekte oder sie persönlich betreffen.',
      needAudience: 'Bitte eine Zielgruppe wählen.',
      email: 'Auch per E-Mail senden',
      emailHint: 'Geht an die Firmenadressen der erreichten Personen (als Blindkopie), sobald die Mitteilung sichtbar wird: bei einer Wiederholung zu jedem Termin, bei einer neuen Fassung erneut.',
      emailSenderFixed: 'Absender: {{name}} ({{email}})',
      emailSenderSelf: 'Absender: Ihre eigene Adresse',
      emailOff: 'Der Versand per E-Mail ist ausgeschaltet. Die Systemverwaltung schaltet ihn unter Verwaltung › Einstellungen › Mitteilungen per E-Mail ein.',
      emailNoService: 'Es ist kein E-Mail-Dienst eingerichtet (Microsoft Graph); die E-Mail kann nicht gesendet werden.',
      ack: 'Kenntnisnahme bestätigen lassen',
      ackHint: 'Für Unterweisungen: Jede Person bestätigt mit einem Klick. Sie sehen, wer noch nicht bestätigt hat.',
      linkUrl: 'Link (optional)',
      linkHint: 'Firmenrichtlinien und Dokumente bleiben an ihrem Ort; hier genügt der Link dorthin.',
      linkLabel: 'Beschriftung des Links',
      newRevision: 'Als neue Fassung erneut zur Kenntnis geben',
      newRevisionHint: 'Der Text wurde geändert. Aus: nur eine Korrektur, gelesene und bestätigte Fassungen bleiben gültig.',
    },
    receiptsTitle: 'Lesebestätigungen',
    receiptsOccurrence: 'Stand für den Zeitraum ab {{date}}',
    receiptsReach: 'Erreichte Personen',
    receiptsRead: 'Gelesen',
    receiptsAcked: 'Bestätigt',
    receiptsPending: 'Noch nicht bestätigt ({{count}})',
    receiptsAllDone: 'Alle haben bestätigt.',
    receiptsPrivacy: 'Namen zeigt das System nur bei Mitteilungen, die eine Bestätigung verlangen. Bei allen anderen sehen Sie nur die Zahlen.',
    archiveFilter: 'Anzeige',
    archiveModes: {
      active: 'Aktuelle',
      all: 'Aktuelle und Archiv',
      only: 'Nur Archiv',
    },
    receiptsRevision: 'Fassung {{revision}}',
    mail: {
      button: 'E-Mail',
      title: 'E-Mail der Mitteilung',
      states: {
        disabled: 'E-Mail ausgeschaltet',
        scheduled: 'E-Mail am {{date}}',
        pending: 'E-Mail wird gesendet',
        sent: 'E-Mail an {{count}} gesendet',
        error: 'E-Mail mit Fehler',
      },
      sentAt: 'Gesendet am {{date}} an {{sent}} von {{recipients}} Adressen.',
      scheduledText: 'Die E-Mail geht am {{date}}, wenn die Mitteilung sichtbar wird.',
      pendingText: 'Die Mitteilung ist sichtbar; die E-Mail geht in den nächsten Minuten.',
      disabledText: 'Die Mitteilung soll auch per E-Mail gehen, der Versand ist aber in den Einstellungen ausgeschaltet. Es wird nichts gesendet.',
      errors: {
        NO_SENDER: 'Kein gültiger Absender: Die gewählte Person hat keine E-Mail-Adresse oder ist nicht mehr aktiv. Bitte in Verwaltung › Einstellungen den Absender prüfen.',
        NO_RECIPIENTS: 'Keine der erreichten Personen hat eine E-Mail-Adresse.',
      },
      errorText: 'Fehler beim Senden: {{error}}',
      preview: 'Vorschau',
      from: 'Absender',
      noSender: 'kein gültiger Absender',
      subject: 'Betreff',
      recipients: 'Empfänger: {{count}} Personen als Blindkopie',
      recipients_one: 'Empfänger: 1 Person als Blindkopie',
      withoutAddress: '{{count}} erreichte Personen haben keine E-Mail-Adresse und sehen die Mitteilung nur in Projektzeit.',
      languageHint: 'Die festen Zeilen der E-Mail stehen in der Sprache der jeweiligen Person; Überschrift und Text so, wie Sie sie geschrieben haben.',
      demo: 'Demo: Keine E-Mail verlässt den Browser. Die Vorschau zeigt, was gesendet würde.',
      resend: 'Erneut senden',
      resendHint: 'Sendet die aktuelle Fassung noch einmal an alle erreichten Personen (z. B. nach einem Fehler).',
      toastSent: 'E-Mail an {{count}} Personen gesendet',
      toastSent_one: 'E-Mail an 1 Person gesendet',
      toastScheduled: 'Die E-Mail geht, sobald die Mitteilung sichtbar wird.',
      toastError: 'Mitteilung gespeichert, die E-Mail ist aber nicht (vollständig) gesendet. Details unter „E-Mail“ in der Liste.',
    },
  },
  home: {
    announcements: 'Mitteilungen',
    manageAnnouncements: 'Verwalten',
    allAnnouncements: 'Alle anzeigen',
    noAnnouncements: 'Keine Mitteilungen.',
    moreAnnouncements: '{{count}} weitere Mitteilungen',
    moreAnnouncements_one: '1 weitere Mitteilung',
    standards: 'Firmenstandards und Vorlagen',
    standardsHint: 'Richtlinien, Vorlagen und Layouts der Firma (öffnet in neuem Tab)',
    upcoming: 'Demnächst',
    upcomingEmpty: 'In den nächsten Tagen steht nichts an.',
    up: {
      requested: 'beantragt',
      birthday: 'Geburtstag: {{name}}',
      projectEnd: 'Projektende: {{project}}',
      weekDeadline: 'Frist zum Einreichen von KW {{week}}',
    },
    upKinds: {
      leave: 'Abwesenheit',
      holiday: 'Feiertag',
      event: 'Termin',
      closure: 'Betriebsschließung',
      deadline: 'Frist',
      birthday: 'Geburtstag',
      project_end: 'Projektende',
      week_deadline: 'Stunden einreichen',
    },
    myWork: 'Meine Aufgaben',
    tiles: {
      absence: 'Abwesenheit',
      openCount: '{{count}} offen',
      toCorrect: '{{count}} zu korrigieren',
      publish: 'Mitteilung veröffentlichen',
    },
  },
  quick: {
    pin: 'Als Favorit merken',
    unpin: 'Favorit entfernen',
    favorites: 'Favoriten',
    sortLabel: 'Reihenfolge der Aufgaben',
    sort: {
      manual: 'Eigene Reihenfolge',
      hours: 'Meiste Stunden zuerst',
      project: 'Nach Projekt',
    },
    pinnedAt: '{{ref}} zu den Favoriten',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    favoritesEmpty: 'Noch keine Favoriten. Mit dem Stern merken Sie sich Aufgaben, die Sie oft buchen.',
    favoritesFull: 'Es sind höchstens 30 Favoriten möglich. Bitte zuerst einen entfernen.',
    multi: 'Mehrere Tage buchen',
    multiHint: 'Dieselbe Aufgabe mit gleichen Stunden und Tätigkeit an mehreren Tagen, z. B. eine Woche Baustelle. Vor dem Buchen sehen Sie jeden Tag einzeln.',
    from: 'Von',
    to: 'Bis',
    weekdays: 'Wochentage',
    hoursPerDay: 'Stunden pro Tag',
    daysCount: '{{count}} Tage',
    daysCount_one: '{{count}} Tag',
    daysNone: 'Kein Tag im gewählten Zeitraum',
    daysTooMany: 'Höchstens {{max}} Tage auf einmal',
    checkDays: 'Tage prüfen',
    back: 'Zurück',
    bookN: '{{count}} Einträge buchen',
    bookN_one: '{{count}} Eintrag buchen',
    bookNDraft: '{{count}} Einträge als Entwurf anlegen',
    bookNDraft_one: '{{count}} Eintrag als Entwurf anlegen',
    reviewIntro: 'So sehen Sie vor dem Buchen, was passiert. Tage mit Hinweis (Feiertag, Abwesenheit, schon gebucht) sind nicht angehakt; wer dort trotzdem gearbeitet hat, hakt sie an. Tage, an denen nicht gebucht werden kann, sind grau.',
    selected: '{{count}} von {{total}} ausgewählt, zusammen {{hours}} h',
    doneMany: '{{count}} Einträge angelegt',
    doneMany_one: '{{count}} Eintrag angelegt',
    partial: '{{ok}} angelegt, {{failed}} nicht. Die übrigen stehen weiter unten mit dem Grund.',
    unknownTask: 'Aufgabe nicht verfügbar',
    hint: {
      DUPLICATE: 'Aufgabe an diesem Tag schon gebucht',
      WEEKEND: 'Wochenende',
      WEEKEND_DATE: 'Wochenende',
      FREE_DAY: 'Arbeitsfreier Tag',
      HOLIDAY: 'Feiertag',
      ABSENCE_DAY: 'Abwesenheit',
    },
    copyWeek: 'Woche übernehmen',
    copyTitle: 'Woche übernehmen',
    copyIntro: 'Übernimmt die Einträge einer früheren Woche oder einer Vorlage in KW {{week}}. Alles wird als Entwurf angelegt; Sie prüfen vorher jede Zeile und reichen wie gewohnt ein.',
    source: 'Quelle',
    sourceLast: 'Letzte Woche (KW {{week}})',
    sourceOther: 'Andere Woche …',
    sourceTemplate: 'Vorlage: {{name}}',
    otherWeek: 'Ein Datum der gewünschten Woche',
    emptySource: 'In dieser Quelle gibt es keine Einträge zum Übernehmen.',
    saveTemplate: 'Diese Woche als Vorlage speichern',
    templateHint: 'Die Vorlage merkt sich Aufgabe, Wochentag, Stunden, Tätigkeit und Arbeitsort der Einträge in KW {{week}}. Sie ist nur für Sie sichtbar.',
    templateName: 'Name der Vorlage',
    templateNamePlaceholder: 'z. B. Standardwoche',
    templateSave: 'Vorlage speichern',
    templateSaved: 'Vorlage „{{name}}“ gespeichert',
    templateDelete: 'Vorlage löschen',
    templateDeleted: 'Vorlage gelöscht',
    templateLimit: 'Es sind höchstens 20 Vorlagen möglich. Bitte zuerst eine löschen.',
    templateEmptyWeek: 'In KW {{week}} gibt es noch keine Einträge, die sich als Vorlage speichern lassen.',
  },
  recurring: {
    title: 'Wiederkehrend',
    add: 'Neu',
    empty: 'Was jede Woche gleich wiederkommt (z. B. die wöchentliche Teambesprechung): im Buchungsdialog „Jede Woche wiederholen“ wählen.',
    edit: 'Bearbeiten',
    editTitle: 'Wiederkehrenden Eintrag bearbeiten',
    pause: 'Pausieren',
    resume: 'Fortsetzen',
    paused: 'pausiert',
    pausedDone: 'Pausiert: es werden keine Entwürfe mehr angelegt',
    resumedDone: 'Fortgesetzt',
    notBookable: 'Aufgabe nicht mehr buchbar',
    delete: 'Löschen',
    deleteTitle: 'Wiederkehrenden Eintrag löschen?',
    deleteText: 'Es werden keine weiteren Entwürfe angelegt. Bereits angelegte Einträge bleiben in Ihren Zeiten und lassen sich dort ändern oder löschen.',
    deleted: 'Wiederkehrender Eintrag gelöscht',
    save: 'Wiederkehrend speichern',
    saved: 'Wiederkehrender Eintrag gespeichert',
    savedBooked: 'Wiederkehrender Eintrag gespeichert, {{count}} Entwürfe in dieser Woche angelegt',
    savedBooked_one: 'Wiederkehrender Eintrag gespeichert, {{count}} Entwurf in dieser Woche angelegt',
    bookedNow: '{{count}} wiederkehrende Einträge als Entwurf angelegt',
    bookedNow_one: '{{count}} wiederkehrender Eintrag als Entwurf angelegt',
    from: 'Ab',
    until: 'Bis (optional)',
    untilHint: 'Leer: ohne Ende',
    untilShort: 'bis {{date}}',
    hoursPerDay: 'Stunden je Tag',
    toggle: 'Jede Woche wiederholen',
    toggleHint: 'Zum Beispiel die wöchentliche Teambesprechung: an den gewählten Wochentagen jeder Woche als Entwurf.',
    toggleOnHint: 'Die Einträge entstehen als Entwürfe, wenn Sie die Woche öffnen (die laufende Woche auch über Nacht).',
    everyWeek: 'jede Woche',
    explain: 'Feiertage, Betriebsruhe, ganztägige Abwesenheiten und Tage ohne Sollstunden werden ausgelassen. Ein gelöschter Entwurf kommt nicht wieder. Eingereicht wird wie immer mit der Woche.',
  },
  templates: {
    title: 'Vorlagen',
    new: 'Neue Vorlage',
    empty: 'Noch keine Vorlagen.',
    pick: 'Vorlage links wählen oder neu anlegen.',
    count: '{{count}} Aufgaben',
    count_one: '{{count}} Aufgabe',
    hint: 'Vorlagen für manuelle Aufgaben: einmal anlegen (z. B. 20 bis 30 Standardaufgaben), in einem neuen Projekt unter Aufgaben > „Aus Vorlage“ in einem Schritt übernehmen. Die Aufgaben entstehen wie von Hand angelegt; Titel, die das Projekt schon hat, werden ausgelassen.',
    name: 'Name der Vorlage',
    namePlaceholder: 'z. B. TGA Standard',
    fromProject: 'Aufgaben eines Projekts übernehmen',
    fromProjectHint: 'Fügt die manuellen Aufgaben des Projekts unten an',
    fromProjectDone: '{{count}} Aufgaben aus dem Projekt angefügt',
    descriptionPlaceholder: 'Beschreibung (optional)',
    billingDefault: 'Vorgabe der Kategorie',
    fixed: 'für alle Buchungen festlegen',
    duplicate: 'Titel kommt doppelt vor',
    addRow: 'Zeile',
    rowsHint: '{{count}} von höchstens 100 Zeilen',
    removeRow: 'Zeile entfernen',
    deleteTitle: 'Vorlage „{{name}}“ löschen?',
    deleteText: 'Aufgaben, die schon aus der Vorlage übernommen wurden, bleiben in ihren Projekten.',
    deleted: 'Vorlage gelöscht',
    fromTemplate: 'Aus Vorlage',
    applyTitle: 'Aufgaben aus einer Vorlage übernehmen',
    applyHint: 'Gewählte Zeilen werden als manuelle Aufgaben angelegt. Planstunden und Abrechnungsart übernimmt nur, wer sie im Projekt festlegen darf; sonst gilt die Vorgabe der Kategorie.',
    applyN: '{{count}} Aufgaben anlegen',
    applyN_one: '{{count}} Aufgabe anlegen',
    applied: '{{count}} Aufgaben angelegt',
    applied_one: '{{count}} Aufgabe angelegt',
    appliedSkipped: '{{count}} ausgelassen (Titel schon vorhanden oder Kategorie inaktiv)',
    exists: 'schon im Projekt',
    noneYet: 'Es gibt noch keine Vorlagen. Das Büro legt sie unter Verwaltung > Aufgabenvorlagen an.',
  },
  search: {
    open: 'Bereich suchen (Strg+K)',
    placeholder: 'Bereich suchen …',
    title: 'Bereich suchen',
    inputPlaceholder: 'Bereich, Projekt oder Person, z. B. Überstunden, 2026-012, Brandt',
    none: 'Nichts gefunden.',
    hint: 'Findet Bereiche und Reiter sowie Projekte und Personen, aber nur, was Sie öffnen dürfen; Inhalte (Buchungen, Texte) werden nicht durchsucht. Pfeiltasten wählen, Enter öffnet.',
    projects: 'Projekte',
    people: 'Personen',
    personRecord: 'Stammdaten',
    archived: 'archiviert',
    inactive: 'inaktiv',
    searching: 'Suche in Projekten und Personen …',
  },
};

export default de;
export type Dict = typeof de;
